/* eslint-disable */

import { GraphQLClient, RequestOptions } from 'graphql-request';
import { DocumentNode } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CurrencyCode: string;
  Date: string;
  DateTime: string;
  Decimal: string;
  ImageContentType: string;
  JSONObject: Record<string, unknown>;
  ObjectId: string;
  TimeZone: string;
  URL: string;
};

export type AbsoluteTimeRange = {
  /**
   * The start date of the views.
   * The time range will include this date (using >=).
   *
   * Defaults to the unix epoch start (1970-01-01).
   */
  from?: InputMaybe<Scalars['DateTime']>;
  /**
   * The end date of the views.
   * The time range will include this date (using <=).
   *
   * Defaults to the current date.
   */
  to?: InputMaybe<Scalars['DateTime']>;
};

/** The input for accepting an invitation to join a documentation project. */
export type AcceptInviteToDocumentationProjectInput = {
  /** The invitation token to accept. */
  inviteToken: Scalars['String'];
};

/** Response to accepting an invitation to join a documentation project. */
export type AcceptInviteToDocumentationProjectPayload = {
  __typename?: 'AcceptInviteToDocumentationProjectPayload';
  /** The documentation project that the user has been invited to. */
  project?: Maybe<DocumentationProject>;
  /** Signifies the success of the mutation. */
  success: Scalars['Boolean'];
};

export type AcceptInviteToPublicationInput = {
  /** The invitation token to accept. */
  inviteToken: Scalars['String'];
};

/** Response to accepting an invitation to join a publication. */
export type AcceptInviteToPublicationPayload = {
  __typename?: 'AcceptInviteToPublicationPayload';
  /** Signifies if the mutation was successful. */
  success: Scalars['Boolean'];
};

/** Input to accept a role based invite. */
export type AcceptRoleBasedInviteInput = {
  /** Invite token of the role based invite. */
  inviteToken: Scalars['String'];
};

/** Input to toggle role based invite links. */
export type AcceptRoleBasedInvitePayload = {
  __typename?: 'AcceptRoleBasedInvitePayload';
  /** Signifies if the mutation was successful. */
  success: Scalars['Boolean'];
};

export type AcknowledgeEmailImportInput = {
  /** The publication ID for which the import has to be acknowledged. */
  publication: Scalars['ObjectId'];
};

export type AcknowledgeEmailImportPayload = {
  __typename?: 'AcknowledgeEmailImportPayload';
  /** The date the import started */
  importStartedAt: Scalars['DateTime'];
  /** The status of the import */
  status: EmailImportStatus;
};

export type ActivateFreeTrialPayload = {
  __typename?: 'ActivateFreeTrialPayload';
  user: MyUser;
};

export type AddCommentInput = {
  contentMarkdown: Scalars['String'];
  postId: Scalars['ID'];
};

export type AddCommentPayload = {
  __typename?: 'AddCommentPayload';
  comment?: Maybe<Comment>;
};

/** The input for adding a prompt to the AI search */
export type AddDocumentationProjectAiPromptInput = {
  /** The ID of the documentation project */
  projectId: Scalars['ID'];
  /** The prompt text */
  prompt: Scalars['String'];
};

/** Response to adding a prompt to the AI search */
export type AddDocumentationProjectAiPromptPayload = {
  __typename?: 'AddDocumentationProjectAIPromptPayload';
  project?: Maybe<DocumentationProject>;
};

export type AddDocumentationProjectCustomDomainInput = {
  domain: Scalars['String'];
  projectId: Scalars['ID'];
  wwwDomain: Scalars['Boolean'];
};

export type AddDocumentationProjectCustomDomainPayload = {
  __typename?: 'AddDocumentationProjectCustomDomainPayload';
  /**
   * Additional DNS entries required to verify the domain.
   * There are cases where additional records in the DNS config are required to successfully verify the domain.
   */
  dnsVerificationEntries: Array<DnsVerificationEntry>;
  project?: Maybe<DocumentationProject>;
  wwwRedirectDnsVerificationEntries: Array<DnsVerificationEntry>;
};

/** The input for adding the GitHub integration to a documentation project */
export type AddDocumentationProjectGitHubSyncIntegrationInput = {
  accessToken: Scalars['String'];
  installationId: Scalars['String'];
  owner: Scalars['String'];
  projectId: Scalars['ID'];
  repository: Scalars['String'];
};

/** The payload for adding github integration to a documentation project. */
export type AddDocumentationProjectGitHubSyncIntegrationPayload = {
  __typename?: 'AddDocumentationProjectGitHubSyncIntegrationPayload';
  project?: Maybe<DocumentationProject>;
};

export type AddPostToSeriesInput = {
  /** The ID of the post to be added to the series. */
  postId: Scalars['ObjectId'];
  /** The ID of the series to which the post is to be added. */
  seriesId: Scalars['ObjectId'];
};

export type AddPostToSeriesPayload = {
  __typename?: 'AddPostToSeriesPayload';
  /** The series to which the post was added. */
  series?: Maybe<Series>;
};

export type AddPublicationCustomDomainInput = {
  domain: Scalars['String'];
  publicationId: Scalars['ID'];
  wwwDomain: Scalars['Boolean'];
};

export type AddPublicationCustomDomainPayload = {
  __typename?: 'AddPublicationCustomDomainPayload';
  /**
   * Additional DNS entries required to verify the domain.
   * There are cases where additional records in the DNS config are required to successfully verify the domain.
   */
  dnsVerificationEntries: Array<DnsVerificationEntry>;
  publication?: Maybe<Publication>;
  wwwRedirectDnsVerificationEntries: Array<DnsVerificationEntry>;
};

export type AddPublicationsToProPlanInput = {
  /**
   * The IDs of the publications to add to the pro plan.
   * Note: This does not change the pro plan subscription and thus the price.
   */
  publicationIds: Array<Scalars['ObjectId']>;
};

/** The payload for the add publications to pro plan mutation. */
export type AddPublicationsToProPlanPayload = {
  __typename?: 'AddPublicationsToProPlanPayload';
  /** The new amount of credits after assigning pro to publications. */
  newPublicationCredits: UserProPublicationCredits;
  /** The old amount credits before assigning pro to publications. */
  oldPublicationCredits: UserProPublicationCredits;
};

export type AddReplyInput = {
  commentId: Scalars['ID'];
  contentMarkdown: Scalars['String'];
};

export type AddReplyPayload = {
  __typename?: 'AddReplyPayload';
  reply?: Maybe<Reply>;
};

export enum AnalyticsDimension {
  Browser = 'BROWSER',
  Country = 'COUNTRY',
  DeviceType = 'DEVICE_TYPE',
  OperatingSystem = 'OPERATING_SYSTEM',
  Page = 'PAGE',
  Path = 'PATH',
  Post = 'POST',
  ReferrerHost = 'REFERRER_HOST'
}

/**
 * Contains the flag indicating if the audio blog feature is enabled or not.
 * User can enable or disable the audio blog feature from the publication settings.
 * Shows audio player on blogs if enabled.
 */
export type AudioBlogFeature = Feature & {
  __typename?: 'AudioBlogFeature';
  /** A flag indicating if the audio blog feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
  /** The voice type for the audio blog. */
  voiceType: AudioBlogVoiceType;
};

/** The voice type for the audio blog. */
export enum AudioBlogVoiceType {
  /** Enum for the female voice type of the audio blog. */
  Female = 'FEMALE',
  /** Enum for the male voice type of the audio blog. */
  Male = 'MALE'
}

/** Used when Audioblog feature is enabled. Contains URLs to the audioblog of the post. */
export type AudioUrls = {
  __typename?: 'AudioUrls';
  /** Female version of audio url of the post. */
  female?: Maybe<Scalars['String']>;
  /** Male version of audio url of the post. */
  male?: Maybe<Scalars['String']>;
};

/** Autogenerated pages that are created by hashnode. */
export enum AutogeneratedPage {
  /** Badges page */
  Badges = 'BADGES',
  /** Members page for teams */
  Members = 'MEMBERS',
  /** Newsletter page */
  Newsletter = 'NEWSLETTER'
}

/**
 * Filter for publication average visit time. Only visits matching the filter will be used to calculate the average visit time.
 *
 * Individual filters are combined with an AND condition whereas multiple values for the same filter are combined with an OR condition.
 *
 * Example: `postIds: ["1", "2"], operatingSystems: ["Mac OS"]` will only take visits for posts with ID 1 or 2 AND operating system Mac OS into account.
 */
export type AverageVisitTimeFilter = {
  /**
   * Filter by one or multiple browsers.
   *
   * If multiple browsers are provided, the filter will be applied as an OR condition.
   */
  browsers?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple countries.
   *
   * If multiple countries are provided, the filter will be applied as an OR condition.
   */
  countries?: InputMaybe<Array<CountryCodeAlpha2>>;
  /**
   * Filter by one or multiple device types.
   *
   * If multiple device types are provided, the filter will be applied as an OR condition.
   */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /**
   * Filter by one or multiple operating systems.
   *
   * If multiple operating systems are provided, the filter will be applied as an OR condition.
   */
  operatingSystems?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple page IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  pageIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple paths.
   *
   * If multiple paths are provided, the filter will be applied as an OR condition.
   */
  paths?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple post IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  postIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple referrer hosts.
   *
   * If multiple referrer hosts are provided, the filter will be applied as an OR condition.
   */
  referrerHosts?: InputMaybe<Array<Scalars['String']>>;
  /** Filter based on time range. */
  time?: InputMaybe<TimeFilter>;
};

/** The status of the backup i.e., success or failure. */
export enum BackupStatus {
  /** The backup failed. */
  Failed = 'failed',
  /** The backup was successful. */
  Success = 'success'
}

/** A badge that the user has earned. */
export type Badge = Node & {
  __typename?: 'Badge';
  /** The date the badge was earned. */
  dateAssigned?: Maybe<Scalars['DateTime']>;
  /** The description of the badge. */
  description?: Maybe<Scalars['String']>;
  /** The ID of the badge. */
  id: Scalars['ID'];
  /** The image of the badge. */
  image: Scalars['String'];
  /** Link to badge page on Hashnode. */
  infoURL?: Maybe<Scalars['String']>;
  /** The name of the badge. */
  name: Scalars['String'];
  /** A flag to determine if the badge is hidden. */
  suppressed?: Maybe<Scalars['Boolean']>;
};

/**
 * Contains basic information about the beta feature.
 * A beta feature is a feature that is not yet released to all users.
 */
export type BetaFeature = Node & {
  __typename?: 'BetaFeature';
  /** The description of the beta feature. */
  description?: Maybe<Scalars['String']>;
  /** The date the beta feature was created. */
  enabled: Scalars['Boolean'];
  /** The ID of the beta feature. */
  id: Scalars['ID'];
  /** The key of the beta feature. */
  key: Scalars['String'];
  /** The title of the beta feature. */
  title?: Maybe<Scalars['String']>;
  /** The url of the beta feature. */
  url?: Maybe<Scalars['String']>;
};

/** Billing interval for which to set the pricing. */
export enum BillingInterval {
  /** Subscription is billed every month. */
  Monthly = 'MONTHLY',
  /** Subscription is billed every year. */
  Yearly = 'YEARLY'
}

export type BlogWithBetaFeatures = {
  __typename?: 'BlogWithBetaFeatures';
  /** The beta features of the blog. */
  betaFeatures: Array<BetaFeature>;
  /** The ID of the blog with beta features. */
  id: Scalars['ID'];
  /** A flag indicating whether the blog is pro. */
  isPro: Scalars['Boolean'];
  /** The photo of the blog with beta features. */
  photo: Scalars['String'];
  /** The title of the blog with beta features. */
  title: Scalars['String'];
};

export type BuyProPlanCreditsInput = {
  /** The amount of credits to buy. */
  credits: Scalars['Int'];
  /** If true, no credits will be bought. Provides a preview of the result. */
  dryRun?: InputMaybe<Scalars['Boolean']>;
};

export type BuyProPlanCreditsPayload = {
  __typename?: 'BuyProPlanCreditsPayload';
  /** The payment that the user has to make immediately. */
  immediatePayment?: Maybe<Payment>;
  /** The new amount of credits after buying. */
  newPublicationCredits: UserProPublicationCredits;
  /** The payment that the user will be charged for starting from the next billing period. */
  nextPayment: Payment;
  /** The old amount credits before buying. */
  oldPublicationCredits: UserProPublicationCredits;
};

/** The input for the calcel publication pro plan mutation. */
export type CancelPublicationsProPlanInput = {
  /** The IDs of the publications to cancel the pro plan for. */
  publicationIds: Array<Scalars['ObjectId']>;
};

/** The payload for the cancel publications pro plan mutation. */
export type CancelPublicationsProPlanPayload = {
  __typename?: 'CancelPublicationsProPlanPayload';
  publications: Array<Publication>;
};

export type CancelScheduledDraftInput = {
  /** The Draft ID of the scheduled draft. */
  draftId: Scalars['ID'];
};

export type CancelScheduledDraftPayload = {
  __typename?: 'CancelScheduledDraftPayload';
  /** Payload returned in response of cancel scheduled post mutation. */
  scheduledPost: ScheduledPost;
};

export type ChangeDraftPublicationInput = {
  /** ID of the draft to be moved. */
  draftId: Scalars['ID'];
  /** The ID of the publication the draft should be moved to. */
  publicationId: Scalars['ID'];
};

export type ChangeDraftPublicationPayload = {
  __typename?: 'ChangeDraftPublicationPayload';
  draft?: Maybe<Draft>;
};

/** Input to change the role of a user in a publication. */
export type ChangePublicationMemberRoleInput = {
  /** The publication ID the user is a member of. */
  publicationId: Scalars['ID'];
  /** The role of the user in the publication. */
  role: UserPublicationRole;
  /** The username of the user to change the role for. */
  username: Scalars['String'];
};

/** Response to changing the role of a user in a publication. */
export type ChangePublicationMemberRolePayload = {
  __typename?: 'ChangePublicationMemberRolePayload';
  /** The updated publication member. */
  member: PublicationMember;
};

/** Input to change the privacy state of a user in a publication. */
export type ChangePublicationMemberVisibilityInput = {
  /**
   * The privacy state of the user in the publication.
   * PRIVATE members are not visible on the members page while PUBLIC members are visible.
   */
  privacyState: PublicationMemberPrivacyState;
  /** The publication ID the user is a member of. */
  publicationId: Scalars['ID'];
  /** The username of the user to change the role for. */
  username: Scalars['String'];
};

/** Response to changing the privacy state of a user in a publication. */
export type ChangePublicationMemberVisibilityPayload = {
  __typename?: 'ChangePublicationMemberVisibilityPayload';
  /** The updated publication member. */
  member: PublicationMember;
};

export type CheckCustomDomainAvailabilityInput = {
  domain: Scalars['String'];
  withWWWRedirect: Scalars['Boolean'];
};

export type CheckCustomDomainAvailabilityResult = {
  __typename?: 'CheckCustomDomainAvailabilityResult';
  domainAvailable: Scalars['Boolean'];
};

export type CheckSubdomainAvailabilityResult = {
  __typename?: 'CheckSubdomainAvailabilityResult';
  subdomainAvailable: Scalars['Boolean'];
};

/** Contains the flag indicating if the collaboration feature is enabled or not. */
export type CollaborationFeature = Feature & {
  __typename?: 'CollaborationFeature';
  /** A flag indicating if the collaboration feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

/**
 * Contains basic information about the comment.
 * A comment is a response to a post.
 */
export type Comment = Node & {
  __typename?: 'Comment';
  /** The author of the comment. */
  author: User;
  authorId: Scalars['ID'];
  /** The content of the comment in markdown and html format. */
  content: Content;
  /** The date the comment was created. */
  dateAdded: Scalars['DateTime'];
  /** The ID of the comment. */
  id: Scalars['ID'];
  /** Total number of reactions on the comment by the authenticated user. User must be authenticated to use this field. */
  myTotalReactions: Scalars['Int'];
  /** Returns a list of replies to the comment. */
  replies: CommentReplyConnection;
  /** A unique string identifying the comment. Used as element id in the DOM on hashnode blogs. */
  stamp?: Maybe<Scalars['String']>;
  /** Total number of reactions on the comment. Reactions are hearts added to any comment. */
  totalReactions: Scalars['Int'];
};


/**
 * Contains basic information about the comment.
 * A comment is a response to a post.
 */
export type CommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};

/**
 * Connection to get list of replies to a comment.
 * Returns a list of edges which contains the posts in publication and cursor to the last item of the previous page.
 */
export type CommentReplyConnection = Connection & {
  __typename?: 'CommentReplyConnection';
  /**
   * A list of edges containing nodes in the connection.
   * A node contains a reply to a comment.
   */
  edges: Array<CommentReplyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/** An edge that contains a node of type reply and cursor to the node. */
export type CommentReplyEdge = Edge & {
  __typename?: 'CommentReplyEdge';
  /** A cursor to the last item of the previous page. */
  cursor: Scalars['String'];
  /** The node containing a reply to a comment. */
  node: Reply;
};

/**
 * Connection to get list of top commenters. Contains a list of edges containing nodes.
 * Each node is a user who commented recently.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type CommenterUserConnection = Connection & {
  __typename?: 'CommenterUserConnection';
  /** A list of edges of commenters. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/**
 * Connection to get list of items.
 * Returns a list of edges which contains the items and cursor to the last item of the previous page.
 * This is a common interface for all connections.
 */
export type Connection = {
  /** A list of edges of items connection. */
  edges: Array<Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type Content = {
  __typename?: 'Content';
  /** The HTML version of the content. */
  html: Scalars['String'];
  /** The Markdown version of the content. */
  markdown: Scalars['String'];
  /** The text version from sanitized html content. HTML tags are stripped and only text is returned. */
  text: Scalars['String'];
};

export type ConvertToTeamPublicationInput = {
  publicationId: Scalars['ID'];
};

export type ConvertToTeamPublicationPayload = {
  __typename?: 'ConvertToTeamPublicationPayload';
  publication?: Maybe<Publication>;
};

/** Two letter ISO 3166-1 alpha-2 country code. */
export enum CountryCodeAlpha2 {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bolivia (Plurinational State of) */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo, Democratic Republic of the */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cabo Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czechia */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands (Malvinas) */
  Fk = 'FK',
  /** Micronesia (Federated States of) */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom of Great Britain and Northern Ireland */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran (Islamic Republic of) */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** Korea (Democratic People's Republic of) */
  Kp = 'KP',
  /** Korea, Republic of */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Lao People's Democratic Republic */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova, Republic of */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** North Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine, State of */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russian Federation */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syrian Arab Republic */
  Sy = 'SY',
  /** Eswatini */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan, Province of China */
  Tw = 'TW',
  /** Tanzania, United Republic of */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States of America */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Holy See */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela (Bolivarian Republic of) */
  Ve = 'VE',
  /** Virgin Islands (British) */
  Vg = 'VG',
  /** Virgin Islands (U.S.) */
  Vi = 'VI',
  /** Viet Nam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW',
  /** Unknown */
  Zz = 'ZZ'
}

/** Contains information about cover image options of the post. Like URL of the cover image, attribution, etc. */
export type CoverImageOptionsInput = {
  /** Information about the cover image attribution. */
  coverImageAttribution?: InputMaybe<Scalars['String']>;
  /** The name of the cover image photographer, used when cover was chosen from unsplash. */
  coverImagePhotographer?: InputMaybe<Scalars['String']>;
  /** The URL of the cover image. */
  coverImageURL?: InputMaybe<Scalars['String']>;
  /** A flag to indicate if the cover attribution is hidden, used when cover was chosen from unsplash. */
  isCoverAttributionHidden?: InputMaybe<Scalars['Boolean']>;
  /** A flag to indicate if the cover image is sticked to bottom. */
  stickCoverToBottom?: InputMaybe<Scalars['Boolean']>;
};

/** Input to create a docs custom page. */
export type CreateDocsCustomPageInput = {
  /** Content of the docs custom page. Accepts mdx version of the docs custom page's content. */
  content: Scalars['String'];
  /** OG Image URL of the docs custom page. */
  ogImage?: InputMaybe<Scalars['URL']>;
  /** Project ID to which the docs custom page belongs. */
  projectId: Scalars['ID'];
  /** Description of the docs custom page for SEO. */
  seoDescription?: InputMaybe<Scalars['String']>;
  /** The slug of the docs custom page. Used to access docs custom page. Example `https://mydocs.com/my-page`. */
  slug: Scalars['String'];
  /** The title of the docs custom page. */
  title: Scalars['String'];
  /** Visibility of the docs custom page. */
  visibility: DocumentationSidebarItemVisibility;
};

export type CreateDocumentationApiReferenceInput = {
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CreateDocumentationApiReferencePayload = {
  __typename?: 'CreateDocumentationApiReferencePayload';
  guide: DocumentationApiReference;
};

export type CreateDocumentationGuideInput = {
  name: Scalars['String'];
  projectId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
};

export type CreateDocumentationGuidePayload = {
  __typename?: 'CreateDocumentationGuidePayload';
  guide: DocumentationGuide;
};

export type CreateDocumentationGuideVersionInput = {
  /** Internal code name for the new version. */
  codeName?: InputMaybe<Scalars['String']>;
  /** Specify an existing version to form from in order to copy the content of that version into the new version. */
  forkFromVersionId?: InputMaybe<Scalars['ID']>;
  /** ID of the guide to create a new version for. */
  guideId: Scalars['ID'];
  /** Name of the new version. */
  name: Scalars['String'];
  /** ID of the project to create the guide version in. */
  projectId: Scalars['ID'];
  /**
   * URL-friendly identifier for the new version.
   *
   * Will be generated based on the name if not provided.
   */
  slug?: InputMaybe<Scalars['String']>;
  /** Status of the guide version. */
  status: GuideVersionStatus;
  /** Visibility setting for the new version. */
  visibility: DocumentationGuideVisibility;
};

export type CreateDocumentationGuideVersionPayload = {
  __typename?: 'CreateDocumentationGuideVersionPayload';
  /** The updated project containing the new version. */
  project?: Maybe<DocumentationProject>;
  /** The newly created guide version. */
  version?: Maybe<DocumentationGuideVersion>;
};

export type CreateDocumentationLinkInput = {
  guideSlug: Scalars['String'];
  label: Scalars['String'];
  projectId: Scalars['ID'];
  url: Scalars['String'];
  /**
   * The slug of the version the new link should be created in.
   *
   * Defaults to the default version slug.
   */
  versionSlug?: InputMaybe<Scalars['String']>;
};

export type CreateDocumentationLinkPayload = {
  __typename?: 'CreateDocumentationLinkPayload';
  guide?: Maybe<DocumentationGuide>;
  link?: Maybe<DocumentationLink>;
};

/** Input for creating a navbar column for a docs project. */
export type CreateDocumentationNavbarColumnInput = {
  /** The label of the column. */
  label: Scalars['String'];
  /** The ID of the project that the column will be added to. */
  projectId: Scalars['ID'];
};

/** Payload for creating a new navbar column for a documentation project. */
export type CreateDocumentationNavbarColumnPayload = {
  __typename?: 'CreateDocumentationNavbarColumnPayload';
  /** The newly created column. */
  column?: Maybe<DocumentationNavbarColumn>;
  /** The project that the column was added to. */
  project?: Maybe<DocumentationProject>;
};

/** Input for creating a new navbar guide item for a documentation project. */
export type CreateDocumentationNavbarItemGuideInput = {
  /** The ID of the footer column that the navbar item will be added to. */
  columnId?: InputMaybe<Scalars['ID']>;
  /** The guide id that the navbar item will point to. */
  guideId: Scalars['ID'];
  /** The label of the navbar item. */
  label: Scalars['String'];
  /** The ID of the project that the navbar item will be added to. */
  projectId: Scalars['ID'];
};

/** Payload for adding a new navbar guide item to a documentation project. */
export type CreateDocumentationNavbarItemGuidePayload = {
  __typename?: 'CreateDocumentationNavbarItemGuidePayload';
  /** The newly created navbar guide item. */
  item?: Maybe<DocumentationNavbarItemGuide>;
  /** The project that the navbar item was added to. */
  project?: Maybe<DocumentationProject>;
};

/** Input for creating a new navbar link item for a documentation project. */
export type CreateDocumentationNavbarItemLinkInput = {
  /** The ID of the footer column that the navbar item will be added to. */
  columnId?: InputMaybe<Scalars['ID']>;
  /** The label of the navbar item. */
  label: Scalars['String'];
  /** Whether the link should open in a new tab. */
  opensInNewTab?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the project that the navbar item will be added to. */
  projectId: Scalars['ID'];
  /** The URL that the navbar item will link to. */
  url: Scalars['URL'];
};

/** Payload for adding a new navbar link item to a documentation project. */
export type CreateDocumentationNavbarItemLinkPayload = {
  __typename?: 'CreateDocumentationNavbarItemLinkPayload';
  /** The newly created navbar link item. */
  item?: Maybe<DocumentationNavbarItemLink>;
  /** The project that the navbar item was added to. */
  project?: Maybe<DocumentationProject>;
};

/** Input for creating a new navbar page item for a documentation project. */
export type CreateDocumentationNavbarItemPageInput = {
  /** The ID of the footer column that the navbar item will be added to. */
  columnId?: InputMaybe<Scalars['ID']>;
  /** The label of the navbar item. */
  label: Scalars['String'];
  /** Whether the page should open in a new tab. */
  opensInNewTab?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the page that the navbar item will link to. */
  pageId: Scalars['ID'];
  /** The ID of the project that the navbar item will be added to. */
  projectId: Scalars['ID'];
};

/** Payload for adding a new navbar page item to a documentation project. */
export type CreateDocumentationNavbarItemPagePayload = {
  __typename?: 'CreateDocumentationNavbarItemPagePayload';
  /** The newly created navbar page item. */
  item?: Maybe<DocumentationNavbarItemPage>;
  /** The project that the navbar item was added to. */
  project?: Maybe<DocumentationProject>;
};

export type CreateDocumentationPageDraftInput = {
  content?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  guideSlug: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  /** The meta tags for the page. */
  metaTags?: InputMaybe<MetaTagsInput>;
  parentId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
  /** The slug of the path used to generate the path. */
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /**
   * The slug of the version the new page should be created in.
   *
   * Defaults to the default version slug.
   */
  versionSlug?: InputMaybe<Scalars['String']>;
  /** The visibility of the page. */
  visibility?: InputMaybe<DocumentationSidebarItemVisibility>;
};

export type CreateDocumentationPageDraftPayload = {
  __typename?: 'CreateDocumentationPageDraftPayload';
  guide?: Maybe<DocumentationGuide>;
  page?: Maybe<DocumentationPage>;
};

export type CreateDocumentationPreviewApiReferenceInput = {
  /** The ID of the api reference to create */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the api reference */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the api reference used to create the path */
  slug?: InputMaybe<Scalars['String']>;
  /** The url of the api reference's definition */
  url: Scalars['String'];
};

/** The input for creating a documentation preview guide */
export type CreateDocumentationPreviewGuideInput = {
  /** The ID of the guide to create */
  id?: InputMaybe<Scalars['ID']>;
  /** The meta tags of the guide */
  metaTags?: InputMaybe<MetaTagsInput>;
  /** The name of the guide */
  name: Scalars['String'];
  /** The slug of the guide used to create the path */
  slug?: InputMaybe<Scalars['String']>;
  /** The versions of the guide */
  versions: Array<CreateDocumentationPreviewGuideVersionInput>;
};

/** The input for creating a documentation preview guide version */
export type CreateDocumentationPreviewGuideVersionInput = {
  /** Internal code name for the new version. */
  codeName?: InputMaybe<Scalars['String']>;
  /** Is the version the default one */
  isDefault: Scalars['Boolean'];
  /** Name of the new version. */
  name: Scalars['String'];
  /** The sidebar items of the guide */
  sidebarItems: Array<DocumentationPreviewSidebarItemInput>;
  /**
   * URL-friendly identifier for the new version.
   *
   * Will be generated based on the name if not provided.
   */
  slug?: InputMaybe<Scalars['String']>;
  /** Status of the guide version. */
  status: GuideVersionStatus;
  /** Visibility setting for the new version. */
  visibility: DocumentationGuideVisibility;
};

/** The input for creating a documentation preview link */
export type CreateDocumentationPreviewLinkInput = {
  /** The ID of the link to create */
  id?: InputMaybe<Scalars['ID']>;
  /** The label of the link */
  label: Scalars['String'];
  /** The URL of the link */
  url: Scalars['String'];
};

/** The input for creating a documentation preview page */
export type CreateDocumentationPreviewPageInput = {
  /** The content of the page */
  content?: InputMaybe<Scalars['String']>;
  /** The description of the page */
  description?: InputMaybe<Scalars['String']>;
  /** The format of the page. Could be MDX or MD. */
  format?: InputMaybe<DocumentationPageFormat>;
  /** The ID of the page to create */
  id?: InputMaybe<Scalars['ID']>;
  /** The label of the page on the sidebar */
  label: Scalars['String'];
  /** The meta tags of the page */
  metaTags?: InputMaybe<MetaTagsInput>;
  /** The nested pages of the page */
  pages: Array<CreateDocumentationPreviewPageInput>;
  /** The slug of the page used to create the path */
  slug?: InputMaybe<Scalars['String']>;
  /** The title of the page */
  title?: InputMaybe<Scalars['String']>;
  /** The visibility of the page */
  visibility?: InputMaybe<DocumentationSidebarItemVisibility>;
};

/** The input for creating a documentation preview project from GitHub */
export type CreateDocumentationPreviewProjectFromGitHubInput = {
  /** The branch name of the project to preview */
  branchName: Scalars['String'];
  /** The commit SHA of the project to preview */
  commitSha: Scalars['String'];
  /** The ID of the project to preview */
  projectId: Scalars['ID'];
};

/** The response to creating a documentation preview project from GitHub */
export type CreateDocumentationPreviewProjectFromGitHubPayload = {
  __typename?: 'CreateDocumentationPreviewProjectFromGitHubPayload';
  /** The preview project that was created */
  project?: Maybe<DocumentationProject>;
};

/** The input creating a preview of a documentation project */
export type CreateDocumentationPreviewProjectInput = {
  /** The input for creating preview api references */
  apiReferences: Array<CreateDocumentationPreviewApiReferenceInput>;
  /** The input for creating a documentation guides */
  guides: Array<CreateDocumentationPreviewGuideInput>;
  /** If the preview project is personal */
  isPersonal: Scalars['Boolean'];
  /** The ID of the project to preview */
  projectId: Scalars['ID'];
  /** The subdomain of the preview project */
  subdomain: Scalars['String'];
};

/** The response to creating a preview of a documentation project */
export type CreateDocumentationPreviewProjectPayload = {
  __typename?: 'CreateDocumentationPreviewProjectPayload';
  /** The preview project that was created */
  project?: Maybe<DocumentationProject>;
};

/** The input for creating a documentation preview section */
export type CreateDocumentationPreviewSectionInput = {
  /** The ID of the section to create */
  id?: InputMaybe<Scalars['ID']>;
  /** The label of the section */
  label: Scalars['String'];
  /** The input for nested pages for the section */
  pages: Array<CreateDocumentationPreviewPageInput>;
  /** The slug of the section used to create the path */
  slug?: InputMaybe<Scalars['String']>;
  /** The visibility of the section */
  visibility?: InputMaybe<DocumentationSidebarItemVisibility>;
};

export type CreateDocumentationProjectBillingPortalUrlInput = {
  projectId: Scalars['ID'];
  /** The URL to return to if user clicks on button in the billing portal to return to the website. */
  returnUrl?: InputMaybe<Scalars['URL']>;
};

export type CreateDocumentationProjectBillingPortalUrlPayload = {
  __typename?: 'CreateDocumentationProjectBillingPortalUrlPayload';
  billingPortalUrl?: Maybe<Scalars['URL']>;
};

export type CreateDocumentationProjectCheckoutUrlInput = {
  projectId: Scalars['ID'];
};

export type CreateDocumentationProjectCheckoutUrlPayload = {
  __typename?: 'CreateDocumentationProjectCheckoutUrlPayload';
  checkoutUrl: Scalars['URL'];
};

export type CreateDocumentationProjectInput = {
  description?: InputMaybe<Scalars['String']>;
  favIconUrl?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<DocumentationProjectLinksInput>;
  logoDarkThemeUrl?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: InputMaybe<DocumentationProjectSettingsInput>;
  subdomain: Scalars['String'];
};

export type CreateDocumentationProjectPayload = {
  __typename?: 'CreateDocumentationProjectPayload';
  project: DocumentationProject;
};

export type CreateDocumentationProjectPaymentLinkInput = {
  priceId: Scalars['String'];
  projectId: Scalars['ID'];
};

export type CreateDocumentationProjectPaymentLinkPayload = {
  __typename?: 'CreateDocumentationProjectPaymentLinkPayload';
  paymentLink: Scalars['String'];
};

export type CreateDocumentationSectionInput = {
  guideSlug: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  /** The slug of the section used to generate the path. */
  slug?: InputMaybe<Scalars['String']>;
  /**
   * The slug of the version the new section should be created in.
   *
   * Defaults to the default version slug.
   */
  versionSlug?: InputMaybe<Scalars['String']>;
};

export type CreateDocumentationSectionPayload = {
  __typename?: 'CreateDocumentationSectionPayload';
  guide?: Maybe<DocumentationGuide>;
  section?: Maybe<DocumentationSection>;
};

export type CreateDraftInput = {
  /** Ids of the co-authors of the resulting draft. */
  coAuthors?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Content of the resulting draft in markdown format. */
  contentMarkdown?: InputMaybe<Scalars['String']>;
  /** Options for the cover image of the resulting draft. */
  coverImageOptions?: InputMaybe<CoverImageOptionsInput>;
  /** A flag to indicate if the comments are disabled for the resulting draft. */
  disableComments?: InputMaybe<Scalars['Boolean']>;
  /**
   * The id of the user who owns the draft. When this field is supplied, the draft is created directly under that user's account.
   * Only applicable for team publications.
   */
  draftOwner?: InputMaybe<Scalars['ID']>;
  /** Information about the meta tags added to the resulting draft, used for SEO purpose. */
  metaTags?: InputMaybe<MetaTagsInput>;
  /** The URL of the original article if the draft is imported from an external source. */
  originalArticleURL?: InputMaybe<Scalars['String']>;
  /** The ID of publication the draft and resulting post belongs to. */
  publicationId: Scalars['ID'];
  /**
   * Publish the draft on behalf of another user who is a member of the publication.
   *
   * Only applicable for team publications.
   */
  publishAs?: InputMaybe<Scalars['ObjectId']>;
  /** Date when the resulting draft is published. */
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** Providing a seriesId will add the resulting draft to that series. */
  seriesId?: InputMaybe<Scalars['ObjectId']>;
  /** Settings for the resulting draft like table of contents and newsletter activation. */
  settings?: InputMaybe<CreateDraftSettingsInput>;
  /** Slug of the resulting draft. */
  slug?: InputMaybe<Scalars['String']>;
  /** The subtitle of the resulting draft. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** A list of tags added to the resulting draft. */
  tags?: InputMaybe<Array<CreateDraftTagInput>>;
  /** The title of the resulting draft. */
  title?: InputMaybe<Scalars['String']>;
};

export type CreateDraftPayload = {
  __typename?: 'CreateDraftPayload';
  /** The newly created draft */
  draft?: Maybe<Draft>;
};

export type CreateDraftRevisionInput = {
  /** The content of the revision in markdown format. */
  contentMarkdown: Scalars['String'];
  /** The id of the draft. */
  draftId: Scalars['ID'];
};

export type CreateDraftRevisionPayload = {
  __typename?: 'CreateDraftRevisionPayload';
  draftRevision?: Maybe<DraftRevision>;
};

export type CreateDraftSettingsInput = {
  /** Whether to send a newsletter for the resulting draft's post. */
  activateNewsletter?: InputMaybe<Scalars['Boolean']>;
  /** A flag to indicate if the resulting draft should be delisted, used to hide the post created from the draft from public feed. */
  delist?: InputMaybe<Scalars['Boolean']>;
  /** A flag to indicate if the resulting draft'S post should contain a table of content */
  enableTableOfContent?: InputMaybe<Scalars['Boolean']>;
  /** Flag to indicate if the slug is overridden by the user. */
  slugOverridden?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDraftTagInput = {
  /**
   * A tag id that is referencing an existing tag.
   *
   * Either this or name and slug should be provided. If both are provided, the id will be used.
   */
  id?: InputMaybe<Scalars['ObjectId']>;
  /**
   * A name of a new tag to create.
   *
   * Either this and slug or id should be provided. If both are provided, the id will be used.
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * A slug of a new tag to create.
   *
   * Either this and name or id should be provided. If both are provided, the id will be used.
   */
  slug?: InputMaybe<Scalars['String']>;
};

export type CreateImageUploadInput = {
  /**
   * The content type of the image.
   * Starts with "image/". Example: "image/png".
   */
  contentType: Scalars['ImageContentType'];
};

export type CreateImageUploadPayload = {
  __typename?: 'CreateImageUploadPayload';
  presignedPost: PresignedPost;
};

/** Returns the created personal access token. */
export type CreatePersonalAccessTokenPayload = {
  __typename?: 'CreatePersonalAccessTokenPayload';
  personalAccessToken?: Maybe<PersonalAccessToken>;
};

export type CreateProSubscriptionCheckoutInput = {
  billingInterval: BillingInterval;
  publicationIds?: InputMaybe<Array<Scalars['ObjectId']>>;
};

/** Returns checkout URL for the pro plan. */
export type CreateProSubscriptionCheckoutPayload = {
  __typename?: 'CreateProSubscriptionCheckoutPayload';
  /** The URL to the checkout page. */
  checkoutUrl: Scalars['String'];
};

/** The input to create personal publication. */
export type CreatePublicationInput = {
  /** A custom domain to map the publication. */
  domain?: InputMaybe<Scalars['String']>;
  /** The logo of the publication. */
  favicon?: InputMaybe<Scalars['String']>;
  /** Unique subdomain for the publication. */
  hashnodeSubdomain: Scalars['String'];
  /** A flag indicating if the publication should have a www prefixed domain. */
  shouldAddWWWPrefixedDomain?: InputMaybe<Scalars['Boolean']>;
  /** The title of the publication. */
  title?: InputMaybe<Scalars['String']>;
};

export type CreatePublicationNavbarItemInput = {
  label: Scalars['String'];
  publicationId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  type: PublicationNavigationType;
  url?: InputMaybe<Scalars['URL']>;
};

export type CreatePublicationNavbarItemPayload = {
  __typename?: 'CreatePublicationNavbarItemPayload';
  navbarItem: PublicationNavbarItem;
};

export type CreatePublicationPayload = {
  __typename?: 'CreatePublicationPayload';
  publication?: Maybe<Publication>;
};

export type CreateRedirectionRuleInput = {
  destination: Scalars['URL'];
  publicationId: Scalars['ID'];
  source: Scalars['String'];
  type: HttpRedirectionType;
};

export type CreateRedirectionRulePayload = {
  __typename?: 'CreateRedirectionRulePayload';
  redirectionRule: RedirectionRule;
};

/** Input to create a role based invite for a publication. */
export type CreateRoleBasedInviteForPublicationInput = {
  /** The capacity of how many members to be invited by the link. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** Boolean to enable unlimited capacity. */
  enableUnlimitedCapacity?: InputMaybe<Scalars['Boolean']>;
  /** The expiry date of the invite. */
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  /** Invite token set for the invitation */
  inviteToken?: InputMaybe<Scalars['String']>;
  /** The publication ID to create the invite for. */
  publicationId: Scalars['ID'];
  /** The role to assign to the user in the publication. */
  role: UserPublicationInviteRole;
};

/** Response to creating a role based invite for a publication. */
export type CreateRoleBasedInviteForPublicationPayload = {
  __typename?: 'CreateRoleBasedInviteForPublicationPayload';
  /** The created role based invite. */
  invite: RoleBasedInvite;
};

export type CreateSeriesInput = {
  /** The cover image of the series. */
  coverImage?: InputMaybe<Scalars['String']>;
  /** The description of the series. Accepts markdown. */
  descriptionMarkdown?: InputMaybe<Scalars['String']>;
  /** The name of the series. */
  name: Scalars['String'];
  /** The id of the publication the series belongs to. */
  publicationId: Scalars['ID'];
  /** The slug of the series. Used to access series page.  Example https://johndoe.com/series/series-slug */
  slug: Scalars['String'];
  /** The sort order of the series, determines if the latest posts should appear first or last in series. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type CreateSeriesPayload = {
  __typename?: 'CreateSeriesPayload';
  /** Returns the created series. */
  series: Series;
};

/** Input to create a new static page. */
export type CreateStaticPageInput = {
  /** Content of the static page. Accepts markdown. */
  contentMarkdown: Scalars['String'];
  /** Accepts og image url for the static page. */
  ogImage?: InputMaybe<Scalars['URL']>;
  /** The id of the publication the page belongs to. */
  publicationId: Scalars['ID'];
  /** The description of the static page for SEO. */
  seoDescription?: InputMaybe<Scalars['String']>;
  /** The slug of the static page. Used to access static page.  Example `https://johndoe.com/my-page`. */
  slug: Scalars['String'];
  /** The title of the static page. */
  title: Scalars['String'];
};

export type CreateStaticPagePayload = {
  __typename?: 'CreateStaticPagePayload';
  /** Returns the newly created static page. */
  staticPage: StaticPage;
};

/** The input to create team publication. */
export type CreateTeamPublicationInput = {
  /** A custom domain to map the publication. */
  domain?: InputMaybe<Scalars['String']>;
  /** The logo of the publication. */
  favicon?: InputMaybe<Scalars['String']>;
  /** Unique subdomain for the publication. */
  hashnodeSubdomain: Scalars['String'];
  /** A flag indicating if the publication should have a www prefixed domain. */
  shouldAddWWWPrefixedDomain?: InputMaybe<Scalars['Boolean']>;
  /** The title of the publication. */
  title?: InputMaybe<Scalars['String']>;
};

export type CreateTeamPublicationPayload = {
  __typename?: 'CreateTeamPublicationPayload';
  publication?: Maybe<Publication>;
};

export type CreateWebhookInput = {
  events: Array<WebhookEvent>;
  publicationId: Scalars['ID'];
  secret: Scalars['String'];
  url: Scalars['String'];
};

export type CreateWebhookPayload = {
  __typename?: 'CreateWebhookPayload';
  webhook?: Maybe<Webhook>;
};

export type CreateWidgetInput = {
  /** Content of the widget, can be a simple string or HTML */
  content: Scalars['String'];
  /** Widget pin details describing if it should be pinned on articles and location of the widget */
  pinSettings?: InputMaybe<WidgetPinSettingsInput>;
  publicationId: Scalars['ID'];
  /** WidgetId, can be embedded as %%[widgetId] in the article */
  widgetId: Scalars['String'];
};

export type CreateWidgetPayload = {
  __typename?: 'CreateWidgetPayload';
  widget: Widget;
};

export type CustomCss = {
  __typename?: 'CustomCSS';
  /** Custom CSS that will be applied on the publication homepage. */
  home?: Maybe<Scalars['String']>;
  /** The same as `home` but minified. */
  homeMinified?: Maybe<Scalars['String']>;
  /** Custom CSS that will be applied on all posts of the publication. */
  post?: Maybe<Scalars['String']>;
  /** The same as `post` but minified. */
  postMinified?: Maybe<Scalars['String']>;
  /** Custom CSS that will be applied on all static pages of the publication. */
  static?: Maybe<Scalars['String']>;
  /** The same as `static` but minified. */
  staticMinified?: Maybe<Scalars['String']>;
};

export type CustomCssFeature = Feature & {
  __typename?: 'CustomCSSFeature';
  /** CSS that is not published yet. */
  draft?: Maybe<CustomCss>;
  /** A flag indicating if the custom CSS feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
  /** CSS that is live. */
  published?: Maybe<CustomCss>;
};

/** Contains the publication's custom CSS preferences. */
export type CustomCssPreferences = {
  __typename?: 'CustomCSSPreferences';
  /** A flag indicating if the custom CSS is enabled for the publication. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The minified version of custom CSS of the publication used in home page. */
  homeMin?: Maybe<Scalars['String']>;
  /** The minified version of custom CSS of the publication used in static pages. */
  staticMin?: Maybe<Scalars['String']>;
};

export enum CustomDomainStatus {
  Invalid = 'INVALID',
  Valid = 'VALID',
  Verifying = 'VERIFYING'
}

/** Contains the publication's dark mode preferences. */
export type DarkModePreferences = {
  __typename?: 'DarkModePreferences';
  /** A flag indicating if the dark mode is enabled for the publication. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The custom dark mode logo of the publication. */
  logo?: Maybe<Scalars['String']>;
};

export enum DefaultDocsTheme {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type DeleteDraftInput = {
  /** ID of the draft to be deleted. */
  draftId: Scalars['ID'];
};

export type DeleteDraftPayload = {
  __typename?: 'DeleteDraftPayload';
  draft?: Maybe<Draft>;
};

export type DeletePublicationInput = {
  id: Scalars['ID'];
};

export type DeletePublicationPayload = {
  __typename?: 'DeletePublicationPayload';
  /** `true` if the publication was deleted successfully. */
  success: Scalars['Boolean'];
};

/** Input to delete a role based invite. */
export type DeleteRoleBasedInviteInput = {
  /** The ID of the role based invite. */
  inviteId: Scalars['ID'];
  publicationId: Scalars['ID'];
};

/** Response to deleting a role based invite. */
export type DeleteRoleBasedInvitePayload = {
  __typename?: 'DeleteRoleBasedInvitePayload';
  /** Deleted invite. */
  invite: RoleBasedInvite;
};

/** Returns the deleted user */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** Returns true if the user was deleted successfully. */
  success: Scalars['Boolean'];
};

export type DeleteWebhookPayload = {
  __typename?: 'DeleteWebhookPayload';
  webhook?: Maybe<Webhook>;
};

export enum DeviceType {
  Desktop = 'DESKTOP',
  Laptop = 'LAPTOP',
  Mobile = 'MOBILE',
  Tablet = 'TABLET'
}

/** The input for disabling AI search for a documentation project */
export type DisableDocumentationProjectAiSearchInput = {
  /** The ID of the documentation project */
  projectId: Scalars['ID'];
};

/** The response to disabling AI search for a documentation project */
export type DisableDocumentationProjectAiSearchPayload = {
  __typename?: 'DisableDocumentationProjectAISearchPayload';
  project?: Maybe<DocumentationProject>;
};

export type DisableDocumentationProjectHeadlessCmsInput = {
  projectId: Scalars['ID'];
};

export type DisableDocumentationProjectHeadlessCmsPayload = {
  __typename?: 'DisableDocumentationProjectHeadlessCmsPayload';
  project?: Maybe<DocumentationProject>;
};

export type DisableHeadlessCmsInput = {
  publicationId: Scalars['ID'];
};

export type DisableHeadlessCmsPayload = {
  __typename?: 'DisableHeadlessCMSPayload';
  publication?: Maybe<Publication>;
};

export type DnsVerificationEntry = {
  __typename?: 'DnsVerificationEntry';
  name: Scalars['String'];
  type: DnsVerificationType;
  value: Scalars['String'];
};

export enum DnsVerificationType {
  ARecord = 'A_RECORD',
  CnameRecord = 'CNAME_RECORD',
  TxtRecord = 'TXT_RECORD'
}

export enum DocsAnalyticsDimension {
  ApiReferenceGuide = 'API_REFERENCE_GUIDE',
  Browser = 'BROWSER',
  Country = 'COUNTRY',
  DeviceType = 'DEVICE_TYPE',
  DocumentationGuide = 'DOCUMENTATION_GUIDE',
  OperatingSystem = 'OPERATING_SYSTEM',
  Page = 'PAGE',
  Path = 'PATH',
  ReferrerHost = 'REFERRER_HOST'
}

/**
 * Contains basic information about the docs custom page.
 * Docs custom pages are pages that can be written in mdx and can be added to docs. It can be used for changelog or other such requirements.
 */
export type DocsCustomPage = Node & {
  __typename?: 'DocsCustomPage';
  /** Content of the docs custom page. Contains mdx version of the docs custom page's content. */
  content: DocumentationPageContent;
  /** The ID of the docs custom page. */
  id: Scalars['ID'];
  /** Last modified date of the docs custom page. */
  lastModified: Scalars['DateTime'];
  /** Information about the docs custom page's Open Graph metadata i.e. image. */
  ogMetaData?: Maybe<OpenGraphMetaData>;
  /** Information about the docs custom page's SEO metadata i.e. title and description */
  seo?: Maybe<Seo>;
  /** the slug of the docs custom page. Used to access docs custom page. Example `https://mydocs.com/my-page`. */
  slug: Scalars['String'];
  /** The title of the docs custom page. */
  title: Scalars['String'];
  /** Visibility of the docs custom page. */
  visibility: DocumentationSidebarItemVisibility;
};

export type DocsCustomPageConnection = PageConnection & {
  __typename?: 'DocsCustomPageConnection';
  /** A list docs custom pages */
  nodes: Array<DocsCustomPage>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
  /** Total number of docs custom pages. */
  totalDocuments: Scalars['Int'];
};

export type DocsCustomPagePayload = {
  __typename?: 'DocsCustomPagePayload';
  /** Returns the newly created docs custom page. */
  docsCustomPage: DocsCustomPage;
};

export enum DocsGitHubActivityDeploymentType {
  /** The deployment is a preview deployment. */
  Preview = 'PREVIEW',
  /** The deployment is a production deployment. */
  Production = 'PRODUCTION'
}

export type DocsProjectInvitedMembers = {
  __typename?: 'DocsProjectInvitedMembers';
  email: Scalars['String'];
  role: DocumentationMemberRole;
  /** Invited Hashnode user, returns null if the user is not a Hashnode user. */
  user?: Maybe<User>;
};

export type DocsViews = {
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

export type DocsVisitors = {
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

export type DocumentationApiReference = IGuide & {
  __typename?: 'DocumentationApiReference';
  /** The base64 encoded gzip compressed string of the parsed OpenAPI Definition of the API Reference. */
  definition: Scalars['String'];
  id: Scalars['ID'];
  /**
   * A guide can be locked if the subscription doesn't cover to having this guide.
   *
   * A locked guide is readonly. It can only be removed or edited after subscribing.
   */
  isLocked: Scalars['Boolean'];
  lastModified: Scalars['DateTime'];
  name: Scalars['String'];
  /** OG meta-data of the page. Contains image url used in open graph meta tags. */
  ogMetaData?: Maybe<OpenGraphMetaData>;
  projectId: Scalars['ObjectId'];
  /** The provider of the guide. */
  provider: GuideProvider;
  /** A single public version of the guide. */
  publicVersion?: Maybe<DocumentationApiReferenceVersion>;
  /** A list of all publicly visible versions of this guide. */
  publicVersions: DocumentationApiReferenceVersionConnection;
  /** URL of the published api reference. */
  publishedUrl?: Maybe<Scalars['String']>;
  /** SEO information of the page. Contains title and description used in meta tags. */
  seo?: Maybe<Seo>;
  slug: Scalars['String'];
  status: DocumentationGuideItemStatus;
  /** URL of the OpenAPI definition used by the default version of this guide. */
  url: Scalars['String'];
  /** A single version of the guide. */
  version?: Maybe<DocumentationApiReferenceVersion>;
  /** The ID of the default version. */
  versionId?: Maybe<Scalars['String']>;
  /** A list of all versions of this guide. Includes hidden versions. */
  versions: DocumentationApiReferenceVersionConnection;
};


export type DocumentationApiReferencePublicVersionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type DocumentationApiReferencePublicVersionsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type DocumentationApiReferenceVersionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type DocumentationApiReferenceVersionsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type DocumentationApiReferenceVersion = IGuideVersion & Node & {
  __typename?: 'DocumentationApiReferenceVersion';
  /** Internal code name for the version. */
  codeName?: Maybe<Scalars['String']>;
  /** Timestamp of when the version was created. */
  createdAt: Scalars['DateTime'];
  /** The base64 encoded gzip compressed string of the parsed OpenAPI Definition of the API Reference. */
  definition: Scalars['String'];
  /** The version that this version was forked from. */
  forkedFrom?: Maybe<DocumentationApiReferenceVersion>;
  /** Unique identifier for the guide version. */
  id: Scalars['ID'];
  /**
   * Indicates if this is the default version.
   *
   * There is always exactly one default version at a given time.
   */
  isDefault: Scalars['Boolean'];
  /** Display name of the version. */
  name: Scalars['String'];
  projectId: Scalars['ObjectId'];
  /** URL-friendly identifier for the version. */
  slug: Scalars['String'];
  /** Status of the guide version. */
  status: GuideVersionStatus;
  /** Timestamp of the last update to the version. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** URL of the schema definition that this API reference version is based on. */
  url: Scalars['String'];
  /** Visibility of the guide version. */
  visibility: DocumentationGuideVisibility;
};

export type DocumentationApiReferenceVersionConnection = PageConnection & {
  __typename?: 'DocumentationApiReferenceVersionConnection';
  /** A list of versions. */
  nodes: Array<DocumentationApiReferenceVersion>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
  /** Total number of versions. */
  totalDocuments: Scalars['Int'];
};

export type DocumentationGitHubActivityLogFilter = {
  /** Deployment type to filter the activity. */
  deploymentType?: InputMaybe<DocsGitHubActivityDeploymentType>;
};

/**
 * Connection to get the activity logs of the GitHub sync.
 * Returns a list of edges which contains the activity logs and page information as well as total documents.
 */
export type DocumentationGitHubSyncActivityConnection = PageConnection & {
  __typename?: 'DocumentationGitHubSyncActivityConnection';
  /** A list of activity logs for the GitHub sync. */
  nodes: Array<GitHubActivityLog>;
  /** Information for page based pagination in github sync activity logs connection. */
  pageInfo: OffsetPageInfo;
};

export type DocumentationGuide = IGuide & {
  __typename?: 'DocumentationGuide';
  /** The default version of the guide. */
  defaultVersion: DocumentationGuideVersion;
  defaultVersionSlug: Scalars['String'];
  hasChanges: Scalars['Boolean'];
  id: Scalars['ID'];
  /**
   * A guide can be locked if the subscription doesn't cover to having this guide.
   *
   * A locked guide is readonly. It can only be removed or edited after subscribing.
   */
  isLocked: Scalars['Boolean'];
  lastModified: Scalars['DateTime'];
  name: Scalars['String'];
  /** OG meta-data of the page. Contains image url used in open graph meta tags. */
  ogMetaData?: Maybe<OpenGraphMetaData>;
  /** Page of any version of this guide. */
  page?: Maybe<DocumentationPage>;
  projectId: Scalars['ObjectId'];
  provider: GuideProvider;
  /** A single public version of the guide. */
  publicVersion?: Maybe<DocumentationGuideVersion>;
  /** A list of all publicly visible versions of this guide. */
  publicVersions: DocumentationGuideVersionConnection;
  /** Only published page of any version of this guide. */
  publishedPage?: Maybe<DocumentationPage>;
  /** Only published sidebar items of the default version of this guide. */
  publishedSidebarItems: Array<DocumentationSidebarItem>;
  /**
   * Only published page of any version of this guide. The path may include the version slug.
   *
   * Takes redirects into account and may return the page that the requested page redirects to.
   *
   * If the path is only a version slug, it will redirect to the first page of that version.
   */
  redirectedPublishedPage?: Maybe<DocumentationPage>;
  /** SEO information of the page. Contains title and description used in meta tags. */
  seo?: Maybe<Seo>;
  /** Sidebar items of the default version of this guide. */
  sidebarItems: Array<DocumentationSidebarItem>;
  slug: Scalars['String'];
  status: DocumentationGuideItemStatus;
  /**
   * URL of the published guide.
   *
   * Example: `https://example.com/my-guide-slug`
   */
  url?: Maybe<Scalars['String']>;
  /** A single version of the guide. */
  version?: Maybe<DocumentationGuideVersion>;
  /** The ID of the default version. */
  versionId?: Maybe<Scalars['String']>;
  /** A list of all versions of this guide. Includes hidden versions. */
  versions: DocumentationGuideVersionConnection;
};


export type DocumentationGuidePageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
};


export type DocumentationGuidePublicVersionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type DocumentationGuidePublicVersionsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type DocumentationGuidePublishedPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
};


export type DocumentationGuideRedirectedPublishedPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
};


export type DocumentationGuideVersionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type DocumentationGuideVersionsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type DocumentationGuideItem = DocumentationApiReference | DocumentationGuide;

export enum DocumentationGuideItemStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type DocumentationGuideVersion = IGuideVersion & Node & {
  __typename?: 'DocumentationGuideVersion';
  /** Internal code name for the version. */
  codeName?: Maybe<Scalars['String']>;
  /** Timestamp of when the version was created. */
  createdAt: Scalars['DateTime'];
  /** The version that this version was forked from. */
  forkedFrom?: Maybe<DocumentationGuideVersion>;
  /** Unique identifier for the guide version. */
  id: Scalars['ID'];
  /**
   * Indicates if this is the default version.
   *
   * There is always exactly one default version at a given time.
   */
  isDefault: Scalars['Boolean'];
  /** Display name of the version. */
  name: Scalars['String'];
  projectId: Scalars['ObjectId'];
  /** List of publicly visible sidebar items. */
  publishedSidebarItems: Array<DocumentationSidebarItem>;
  /** List of sidebar items which holds the content of this version. */
  sidebarItems: Array<DocumentationSidebarItem>;
  /** URL-friendly identifier for the version. */
  slug: Scalars['String'];
  /** Status of the guide version. */
  status: GuideVersionStatus;
  /** Timestamp of the last update to the version. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Visibility of the guide version. */
  visibility: DocumentationGuideVisibility;
};

export type DocumentationGuideVersionConnection = PageConnection & {
  __typename?: 'DocumentationGuideVersionConnection';
  /** A list of versions. */
  nodes: Array<DocumentationGuideVersion>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
  /** Total number of versions. */
  totalDocuments: Scalars['Int'];
};

/** Visibility options for documentation guides. */
export enum DocumentationGuideVisibility {
  /** Not visible in public listings. Only visible to users with access to the project. */
  Hidden = 'HIDDEN',
  /** Visible to all users. */
  Public = 'PUBLIC'
}

export type DocumentationLink = IDocumentationSidebarItem & {
  __typename?: 'DocumentationLink';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  projectId: Scalars['ObjectId'];
  status: DocumentationSidebarItemStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  visibility: DocumentationSidebarItemVisibility;
};

export enum DocumentationMemberRole {
  Admin = 'ADMIN',
  Owner = 'OWNER'
}

/** A column for the navigation. Used in the footer */
export type DocumentationNavbarColumn = Node & {
  __typename?: 'DocumentationNavbarColumn';
  /** The date the column was created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the column. */
  id: Scalars['ID'];
  /** The navigation items in the column. */
  items: Array<DocumentationNavbarItem>;
  /** The label of the column. */
  label: Scalars['String'];
  /** The date the column was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentationNavbarItem = DocumentationNavbarItemGuide | DocumentationNavbarItemLink | DocumentationNavbarItemPage;

/** A navigation item pointing  to a guide. */
export type DocumentationNavbarItemGuide = Node & {
  __typename?: 'DocumentationNavbarItemGuide';
  /** The date the item was created. */
  createdAt: Scalars['DateTime'];
  /** The guide the item points to. */
  guide: DocumentationGuideItem;
  /** The ID of the item. */
  id: Scalars['ID'];
  /** The label of the item. */
  label: Scalars['String'];
  /** The date the item was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** A navigation item pointing to an external URL. */
export type DocumentationNavbarItemLink = Node & {
  __typename?: 'DocumentationNavbarItemLink';
  /** The date the item was created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the item. */
  id: Scalars['ID'];
  /** The label of the item. */
  label: Scalars['String'];
  /** Indicates if the link should open in a new tab. */
  openInNewTab: Scalars['Boolean'];
  /** The date the item was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The URL the item points to. */
  url: Scalars['String'];
};

/** A navigation item pointing to an custom page */
export type DocumentationNavbarItemPage = Node & {
  __typename?: 'DocumentationNavbarItemPage';
  /** The date the item was created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the item. */
  id: Scalars['ID'];
  /** The label of the item. */
  label: Scalars['String'];
  /** Indicates if the page should open in a new tab. */
  openInNewTab: Scalars['Boolean'];
  /** The page this item points to. */
  page: DocsCustomPage;
  pageId: Scalars['ID'];
  /** The date the item was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentationPage = {
  __typename?: 'DocumentationPage';
  content: DocumentationPageContent;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  draft: DocumentationPageDraft;
  format: DocumentationPageFormat;
  guideSlug: Scalars['String'];
  id: Scalars['ID'];
  /** OG meta-data of the page. Contains image url used in open graph meta tags. */
  ogMetaData?: Maybe<OpenGraphMetaData>;
  path: Scalars['String'];
  projectId: Scalars['ObjectId'];
  /** SEO information of the page. Contains title and description used in meta tags. */
  seo?: Maybe<Seo>;
  status: DocumentationSidebarItemStatus;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * URL of the published page.
   *
   * Returns `null` if the page is not published.
   */
  url?: Maybe<Scalars['String']>;
  version: DocumentationGuideVersion;
  versionSlug: Scalars['String'];
  visibility: DocumentationSidebarItemVisibility;
};

export type DocumentationPageContent = {
  __typename?: 'DocumentationPageContent';
  md?: Maybe<Scalars['String']>;
  mdx?: Maybe<Scalars['String']>;
};

export type DocumentationPageDraft = {
  __typename?: 'DocumentationPageDraft';
  content: DocumentationPageContent;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum DocumentationPageFormat {
  Md = 'MD',
  Mdx = 'MDX'
}

/** The input for creating a documentation preview sidebar item */
export type DocumentationPreviewSidebarItemInput = {
  /** The input for creating a documentation sidebar item link */
  link?: InputMaybe<CreateDocumentationPreviewLinkInput>;
  /** The input for creating a documentation sidebar item page */
  page?: InputMaybe<CreateDocumentationPreviewPageInput>;
  /** The input for creating a documentation sidebar item section */
  section?: InputMaybe<CreateDocumentationPreviewSectionInput>;
  /** The sidebar item type */
  variant: DocumentationSidebarItemVariant;
};

export type DocumentationProject = Node & {
  __typename?: 'DocumentationProject';
  ai?: Maybe<DocumentationProjectAiPreference>;
  analytics: DocumentationProjectAnalytics;
  appearance: DocumentationProjectAppearance;
  createdAt: Scalars['DateTime'];
  /** Returns a custom page with the given slug. */
  customPage?: Maybe<DocsCustomPage>;
  /** Returns a list of custom pages belonging to the project. */
  customPages: DocsCustomPageConnection;
  defaultGuide?: Maybe<DocumentationGuideItem>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<DocumentationProjectDomainSettings>;
  /** Object containing information about beta features enabled for the documentation project. */
  features: DocumentationProjectFeatures;
  githubSync?: Maybe<DocumentationProjectGitHubSyncSettings>;
  guide?: Maybe<DocumentationGuideItem>;
  guides: Array<DocumentationGuideItem>;
  id: Scalars['ID'];
  integrations?: Maybe<DocumentationProjectIntegrations>;
  links: DocumentationProjectLinks;
  /** @deprecated Use membersV2 */
  members: Array<DocumentationProjectMember>;
  membersV2: DocumentationProjectMemberConnection;
  name: Scalars['String'];
  /** The navigation configuration for the documentation project. */
  navigation: DocumentationProjectNavigation;
  /** The Owner of the documentation project. */
  owner: User;
  ownerId: Scalars['ID'];
  /** Details of publication invites. Returns null if publication is not a team publication. */
  pendingInvites: DocumentationProjectPendingInviteConnection;
  publishedGuide?: Maybe<DocumentationGuideItem>;
  publishedGuides: Array<DocumentationGuideItem>;
  /** A user search to find users with a specific status */
  searchUsers: DocumentationProjectSearchUserConnection;
  settings: DocumentationProjectSettings;
  subscription?: Maybe<DocumentationProjectSubscription>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** URL of the documentation project. */
  url: Scalars['String'];
};


export type DocumentationProjectCustomPageArgs = {
  slug: Scalars['String'];
};


export type DocumentationProjectCustomPagesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type DocumentationProjectGuideArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type DocumentationProjectMembersV2Args = {
  filter?: InputMaybe<DocumentationProjectMemberConnectionFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type DocumentationProjectPendingInvitesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type DocumentationProjectPublishedGuideArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type DocumentationProjectSearchUsersArgs = {
  input: DocumentationProjectSearchUsersInput;
};

export type DocumentationProjectAiPreference = {
  __typename?: 'DocumentationProjectAIPreference';
  /** The prompts for the documentation project. These prompts are shown to the user when AI Search chatbot is opened. */
  prompts: Array<DocumentationProjectAiPrompt>;
  /** The settings for the AI feature. */
  settings: DocumentationProjectAiSettings;
};

export type DocumentationProjectAiPrompt = {
  __typename?: 'DocumentationProjectAIPrompt';
  /** The date the prompt was created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the prompt. */
  id: Scalars['ID'];
  /** The prompt text. */
  prompt: Scalars['String'];
};

export type DocumentationProjectAiSettings = {
  __typename?: 'DocumentationProjectAISettings';
  /** A flag to indicate if the AI search feature is enabled. */
  isSearchEnabled: Scalars['Boolean'];
};

export type DocumentationProjectAnalytics = {
  __typename?: 'DocumentationProjectAnalytics';
  guides: Array<DocumentationGuideItem>;
  projectId: Scalars['ObjectId'];
  views?: Maybe<ProjectViewsConnection>;
  visitors: ProjectVisitorsConnection;
};


export type DocumentationProjectAnalyticsViewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProjectViewsFilter>;
  first: Scalars['Int'];
  groupBy?: InputMaybe<ProjectViewsGroupBy>;
  options?: InputMaybe<ProjectViewsOptions>;
  sortBy?: InputMaybe<ProjectViewsSortBy>;
};


export type DocumentationProjectAnalyticsVisitorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProjectVisitorsFilter>;
  first: Scalars['Int'];
  groupBy?: InputMaybe<ProjectVisitorsGroupBy>;
  options?: InputMaybe<ProjectVisitorsOptions>;
};

export type DocumentationProjectAppearance = {
  __typename?: 'DocumentationProjectAppearance';
  customScript?: Maybe<Scalars['String']>;
  defaultDocsTheme: DefaultDocsTheme;
  favIconUrl?: Maybe<Scalars['String']>;
  getStarted?: Maybe<DocumentationProjectGetStarted>;
  logoDarkThemeUrl?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
};

export type DocumentationProjectAppearanceInput = {
  customScript?: InputMaybe<Scalars['String']>;
  defaultDocsTheme?: InputMaybe<DefaultDocsTheme>;
  favIconUrl?: InputMaybe<Scalars['String']>;
  getStarted?: InputMaybe<DocumentationProjectGetStartedInput>;
  logoDarkThemeUrl?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
};

export type DocumentationProjectCustomDomain = {
  __typename?: 'DocumentationProjectCustomDomain';
  domain: Scalars['String'];
  status: CustomDomainStatus;
  verifiedAt?: Maybe<Scalars['DateTime']>;
  wwwDomain?: Maybe<DocumentationProjectCustomWwwDomain>;
};

export type DocumentationProjectCustomWwwDomain = {
  __typename?: 'DocumentationProjectCustomWwwDomain';
  status: CustomDomainStatus;
  verifiedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentationProjectDomainSettings = {
  __typename?: 'DocumentationProjectDomainSettings';
  customDomain?: Maybe<DocumentationProjectCustomDomain>;
  hashnodeSubDomain: Scalars['String'];
};

/** Contains the documentation project's beta features. */
export type DocumentationProjectFeatures = {
  __typename?: 'DocumentationProjectFeatures';
  /** Collaboration feature for the docs project which enables collaborative editing in the page editor. */
  collaboration: CollaborationFeature;
  /** GitHub sync feature for the docs project which enables syncing the docs project with a GitHub repository. */
  ghSync: GitHubSyncFeature;
  /** Versioning feature for the docs project which enables creating different versions of docs guides. */
  versioning: VersioningFeature;
};

export type DocumentationProjectGetStarted = {
  __typename?: 'DocumentationProjectGetStarted';
  label: Scalars['String'];
  url: Scalars['URL'];
};

export type DocumentationProjectGetStartedInput = {
  label?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['URL']>;
};

export type DocumentationProjectGitHubSyncSettings = {
  __typename?: 'DocumentationProjectGitHubSyncSettings';
  /** The access token for the installation. */
  accessToken: Scalars['String'];
  /** The date the installation was last updated */
  activityLogs: DocumentationGitHubSyncActivityConnection;
  /** The date the installation was created */
  createdAt: Scalars['DateTime'];
  /** The ID of the installation. This is set by github. */
  installationId: Scalars['String'];
  /** The owner of the repository. */
  owner: Scalars['String'];
  projectId: Scalars['ID'];
  /** The repository name. */
  repository: Scalars['String'];
};


export type DocumentationProjectGitHubSyncSettingsActivityLogsArgs = {
  filter?: InputMaybe<DocumentationGitHubActivityLogFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type DocumentationProjectIntegrations = {
  __typename?: 'DocumentationProjectIntegrations';
  /** FB Pixel ID for integration with Facebook Pixel. */
  fbPixelID?: Maybe<Scalars['String']>;
  /** Google Tag Manager ID for integration with Google Tag Manager. */
  gTagManagerID?: Maybe<Scalars['String']>;
  /** Google Analytics Tracking ID for integration with Google Analytics. */
  gaTrackingID?: Maybe<Scalars['String']>;
  /** Hotjar Site ID for integration with Hotjar. */
  hotjarSiteID?: Maybe<Scalars['String']>;
  /** Intercom ID for integration with Intercom */
  intercomID?: Maybe<Scalars['String']>;
  /** Koala Public Key for integration with Koala. */
  koalaPublicKey?: Maybe<Scalars['String']>;
  /** The meta tags associated with the documentation project. */
  metaTags?: Maybe<Scalars['String']>;
  /** MS Clarity ID for integration with Microsoft Clarity. */
  msClarityID?: Maybe<Scalars['String']>;
};

export type DocumentationProjectIntegrationsInput = {
  fbPixelID?: InputMaybe<Scalars['String']>;
  gTagManagerID?: InputMaybe<Scalars['String']>;
  gaTrackingID?: InputMaybe<Scalars['String']>;
  hotjarSiteID?: InputMaybe<Scalars['String']>;
  intercomID?: InputMaybe<Scalars['String']>;
  koalaPublicKey?: InputMaybe<Scalars['String']>;
  metaTags?: InputMaybe<Scalars['String']>;
  msClarityID?: InputMaybe<Scalars['String']>;
};

/** Contains the pending invite information. */
export type DocumentationProjectInvite = Node & {
  __typename?: 'DocumentationProjectInvite';
  /** The ID of the pending invite. */
  id: Scalars['ID'];
  /** The role assigned to the user in the publication. */
  role: DocumentationMemberRole;
  /** Invited Hashnode user, returns null if the user is not a Hashnode user. */
  user: User;
};

export type DocumentationProjectLinks = {
  __typename?: 'DocumentationProjectLinks';
  /** Bluesky URL of the documentation project. */
  bluesky?: Maybe<Scalars['String']>;
  /** Daily.dev URL of the documentation project. */
  dailydev?: Maybe<Scalars['String']>;
  /** GitHub URL of the documentation project. */
  github?: Maybe<Scalars['String']>;
  /** The GitHub repository of the documentation project. */
  githubRepository?: Maybe<Scalars['String']>;
  /** Hashnode profile of author of the documentation project. */
  hashnode?: Maybe<Scalars['String']>;
  /** Instagram URL of the documentation project. */
  instagram?: Maybe<Scalars['String']>;
  /** LinkedIn URL of the documentation project. */
  linkedin?: Maybe<Scalars['String']>;
  /** Mastodon URL of the documentation project. */
  mastodon?: Maybe<Scalars['String']>;
  /** Twitter URL of the documentation project. */
  twitter?: Maybe<Scalars['String']>;
  /** Website URL of the documentation project. */
  website?: Maybe<Scalars['String']>;
  /** YouTube URL of the documentation project. */
  youtube?: Maybe<Scalars['String']>;
};

export type DocumentationProjectLinksInput = {
  bluesky?: InputMaybe<Scalars['String']>;
  dailydev?: InputMaybe<Scalars['String']>;
  github?: InputMaybe<Scalars['String']>;
  githubRepository?: InputMaybe<Scalars['String']>;
  hashnode?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  mastodon?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
};

export type DocumentationProjectMember = {
  __typename?: 'DocumentationProjectMember';
  /** The role of the member in the documentation project. */
  role: DocumentationMemberRole;
  /** The user who is a member of the documentation project. */
  user: User;
  userId: Scalars['ID'];
};

export type DocumentationProjectMemberConnection = PageConnection & {
  __typename?: 'DocumentationProjectMemberConnection';
  /** A list of members. */
  nodes: Array<DocumentationProjectMemberV2>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
  /** Total number of nodes available i.e. number of members. */
  totalDocuments: Scalars['Int'];
};

/** The filter for the documentation member connection. */
export type DocumentationProjectMemberConnectionFilter = {
  /** Search filter can be used to filter members by their username or email. */
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type DocumentationProjectMemberV2 = Node & {
  __typename?: 'DocumentationProjectMemberV2';
  /** The ID of the member. */
  id: Scalars['ID'];
  /** The role of the member in the documentation project. */
  role: DocumentationMemberRole;
  /** The user who is a member of the documentation project. */
  user: User;
};

/** Contains the header and footer navigation for the documentation project. */
export type DocumentationProjectNavigation = {
  __typename?: 'DocumentationProjectNavigation';
  /** The columns in the footer navigation. */
  footer: Array<DocumentationNavbarColumn>;
  /** The items in the header navigation. */
  header: Array<DocumentationNavbarItem>;
};

/** A connection for the user search result. */
export type DocumentationProjectPendingInviteConnection = PageConnection & {
  __typename?: 'DocumentationProjectPendingInviteConnection';
  /** A list of invites */
  nodes: Array<DocumentationProjectInvite>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
  /** The total number of invites. */
  totalDocuments: Scalars['Int'];
};

export enum DocumentationProjectProductName {
  Enterprise = 'ENTERPRISE',
  Startup = 'STARTUP'
}

export type DocumentationProjectProductPricing = {
  __typename?: 'DocumentationProjectProductPricing';
  basePriceNet: Money;
  billingInterval: BillingInterval;
  pricePerAdditionalSeatNet: Money;
  productName: DocumentationProjectProductName;
  seatsIncluded: Scalars['Int'];
};

/** A connection for the user search result. */
export type DocumentationProjectSearchUserConnection = PageConnection & {
  __typename?: 'DocumentationProjectSearchUserConnection';
  /** The edges containing the user and the status of the user. */
  edges: Array<DocumentationProjectSearchUserEdge>;
  /** A list user nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
  /** Total number of nodes available i.e. number of user search results. */
  totalDocuments: Scalars['Int'];
};

export type DocumentationProjectSearchUserEdge = PageEdge & {
  __typename?: 'DocumentationProjectSearchUserEdge';
  node: User;
  status: UserInviteStatus;
};

export type DocumentationProjectSearchUsersInput = {
  /** The page number that should be returned. */
  page: Scalars['Int'];
  /** The number of users to return on a single page. */
  pageSize: Scalars['Int'];
  searchTerm: Scalars['String'];
  status: UserInviteStatus;
};

export type DocumentationProjectSettings = {
  __typename?: 'DocumentationProjectSettings';
  isHashnodeLoginAllowed: Scalars['Boolean'];
  /** A flag to indicate if the documentation project is using Headless CMS. */
  isHeadless: Scalars['Boolean'];
  isRobotsAllowed: Scalars['Boolean'];
};

export type DocumentationProjectSettingsInput = {
  allowHashnodeLogin?: InputMaybe<Scalars['Boolean']>;
  allowRobots?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentationProjectSubscription = {
  __typename?: 'DocumentationProjectSubscription';
  maxSeats: Scalars['Int'];
  nextBillingCycle?: Maybe<Scalars['DateTime']>;
  productName: DocumentationProjectProductName;
  status: DocumentationProjectSubscriptionStatus;
};

export enum DocumentationProjectSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  PastDue = 'PAST_DUE',
  Unpaid = 'UNPAID'
}

export type DocumentationSection = IDocumentationNestableSidebarItem & IDocumentationSidebarItem & {
  __typename?: 'DocumentationSection';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  pages: Array<DocumentationSidebarItemPage>;
  path: Scalars['String'];
  projectId: Scalars['ObjectId'];
  status: DocumentationSidebarItemStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility: DocumentationSidebarItemVisibility;
};

export type DocumentationSidebarItem = DocumentationLink | DocumentationSection | DocumentationSidebarItemPage;

export type DocumentationSidebarItemPage = IDocumentationNestableSidebarItem & IDocumentationSidebarItem & {
  __typename?: 'DocumentationSidebarItemPage';
  createdAt: Scalars['DateTime'];
  hasChanges: Scalars['Boolean'];
  id: Scalars['ID'];
  label: Scalars['String'];
  pages: Array<DocumentationSidebarItemPage>;
  path: Scalars['String'];
  projectId: Scalars['ObjectId'];
  status: DocumentationSidebarItemStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * URL of the published page.
   *
   * Returns `null` if the page is not published.
   */
  url?: Maybe<Scalars['String']>;
  visibility: DocumentationSidebarItemVisibility;
};

export enum DocumentationSidebarItemStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum DocumentationSidebarItemVariant {
  Link = 'LINK',
  Page = 'PAGE',
  Section = 'SECTION'
}

export enum DocumentationSidebarItemVisibility {
  Hidden = 'HIDDEN',
  Public = 'PUBLIC'
}

export type DocumentationVersion = DocumentationApiReferenceVersion | DocumentationGuideVersion;

/** Contains the publication's domain information. */
export type DomainInfo = {
  __typename?: 'DomainInfo';
  /** The domain of the publication. */
  domain?: Maybe<DomainStatus>;
  /**
   * The subdomain of the publication on hashnode.dev.
   *
   * It will redirect to you custom domain if it is present and ready.
   */
  hashnodeSubdomain?: Maybe<Scalars['String']>;
  /** The www prefixed domain of the publication. Says if redirect to www domain is configured. */
  wwwPrefixedDomain?: Maybe<DomainStatus>;
};

/** Contains the publication's domain status. */
export type DomainStatus = {
  __typename?: 'DomainStatus';
  /** The host of the publication domain. */
  host: Scalars['String'];
  /** A flag indicating if the publication domain is ready. */
  ready: Scalars['Boolean'];
  /** A flag indicating the status of a publication domain */
  status: CustomDomainStatus;
  /**
   * A timestamp indicating when the domain was verified.
   * It is only present if the domain is verified.
   */
  verifiedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Contains basic information about the draft.
 * A draft is a post that is not published yet.
 */
export type Draft = Node & {
  __typename?: 'Draft';
  /** The author of the draft. */
  author: User;
  authorId: Scalars['ID'];
  canonicalUrl?: Maybe<Scalars['String']>;
  coAuthorIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Returns the user details of the co-authors of the post.
   *
   * Only available for team publications.
   */
  coAuthors?: Maybe<Array<User>>;
  /** Content of the draft in HTML and markdown */
  content?: Maybe<Content>;
  /** The cover image preference of the draft. Contains cover image URL and other details. */
  coverImage?: Maybe<DraftCoverImage>;
  /**
   * The date the draft was updated.
   * @deprecated Use updatedAt instead. Will be removed on 26/12/2023.
   */
  dateUpdated: Scalars['DateTime'];
  draftTags: Array<DraftBaseTag>;
  /** Draft feature-related fields. */
  features: DraftFeatures;
  /** The ID of the draft. */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  /**
   * Whether or not the draft has been submitted for review.
   *
   * Only applicable to drafts in team publications.
   */
  isSubmittedForReview?: Maybe<Scalars['Boolean']>;
  /** Information about the last backup of the draft. */
  lastBackup?: Maybe<DraftBackup>;
  /** The date the draft last failed to back up. */
  lastFailedBackupAt?: Maybe<Scalars['DateTime']>;
  /** The date the draft was last successfully backed up. */
  lastSuccessfulBackupAt?: Maybe<Scalars['DateTime']>;
  /** OG meta-data of the draft. Contains image url used in open graph meta tags. */
  ogMetaData?: Maybe<OpenGraphMetaData>;
  /** The publication the draft belongs to. */
  publication?: Maybe<Publication>;
  publicationId: Scalars['ID'];
  publishAs?: Maybe<User>;
  publishAsId?: Maybe<Scalars['ID']>;
  /** Returns the published post when the draft is published, returns null otherwise */
  publishedPost?: Maybe<Post>;
  readTimeInMinutes: Scalars['Int'];
  /** Revisions of the draft. */
  revisions: DraftRevisionConnection;
  /** The date the draft is scheduled to be published. */
  scheduledDate?: Maybe<Scalars['DateTime']>;
  /** SEO information of the draft. Contains title and description used in meta tags. */
  seo?: Maybe<Seo>;
  /** Information of the series the draft belongs to. */
  series?: Maybe<Series>;
  seriesId?: Maybe<Scalars['ObjectId']>;
  settings: DraftSettings;
  slug: Scalars['String'];
  /** The subtitle of the draft. It would become the subtitle of the post when published. */
  subtitle?: Maybe<Scalars['String']>;
  tagIds: Array<Scalars['ID']>;
  /**
   * Returns list of tags added to the draft. Contains tag id, name, slug, etc.
   * @deprecated Use tagsV2 instead. Will be removed on 26/02/2024.
   */
  tags: Array<Tag>;
  tagsV2: Array<DraftTag>;
  /** The title of the draft. It would become the title of the post when published. */
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


/**
 * Contains basic information about the draft.
 * A draft is a post that is not published yet.
 */
export type DraftRevisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};

export type DraftBackup = {
  __typename?: 'DraftBackup';
  /** The date the backup was created. */
  at?: Maybe<Scalars['DateTime']>;
  /** The status of the backup i.e., success or failure. */
  status?: Maybe<BackupStatus>;
};

/**
 * Contains basic information about a Tag within a Draft.
 * A tag in a draft is a tag that is not published yet.
 */
export type DraftBaseTag = {
  __typename?: 'DraftBaseTag';
  /** The name of the tag. Shown in tag page. */
  name: Scalars['String'];
  /** The slug of the tag. Used to access tags feed.  Example https://hashnode.com/n/graphql */
  slug: Scalars['String'];
};

/**
 * Connection to get list of drafts.
 * Returns a list of edges which contains the draft and cursor to the last item of the previous page.
 */
export type DraftConnection = Connection & {
  __typename?: 'DraftConnection';
  /** A list of edges of drafts connection. */
  edges: Array<DraftEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/** Contains information about the cover image of the draft. */
export type DraftCoverImage = {
  __typename?: 'DraftCoverImage';
  /** Provides attribution information for the cover image, if available. */
  attribution?: Maybe<Scalars['String']>;
  /** True if the image attribution should be hidden. */
  isAttributionHidden: Scalars['Boolean'];
  /** The name of the photographer who captured the cover image. */
  photographer?: Maybe<Scalars['String']>;
  /** The URL of the cover image. */
  url: Scalars['String'];
};

/** An edge that contains a node of type draft and cursor to the node. */
export type DraftEdge = Edge & {
  __typename?: 'DraftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** A node in the connection containing a draft. */
  node: Draft;
};

export type DraftFeatures = {
  __typename?: 'DraftFeatures';
  tableOfContents: TableOfContentsFeature;
};

export type DraftRevision = Node & {
  __typename?: 'DraftRevision';
  /** The name of the user who created the revision. */
  authorName: Scalars['String'];
  /** The content of the draft revision. */
  content: Content;
  /** The time the revision has been created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the draft revision. */
  id: Scalars['ID'];
};

export type DraftRevisionConnection = Connection & {
  __typename?: 'DraftRevisionConnection';
  /** A list of edges of draft revisions. */
  edges: Array<DraftRevisionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

export type DraftRevisionEdge = Edge & {
  __typename?: 'DraftRevisionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** A node in the connection containing a draft revision. */
  node: DraftRevision;
};

export type DraftSettings = {
  __typename?: 'DraftSettings';
  /** A flag to indicate if the comments are disabled for the post. */
  disableComments: Scalars['Boolean'];
  /** Whether or not the post is hidden from the Hashnode community. */
  isDelisted: Scalars['Boolean'];
  /** A flag to indicate if the cover image is shown below title of the post. Default position of cover is top of title. */
  stickCoverToBottom: Scalars['Boolean'];
};

export type DraftTag = DraftBaseTag | Tag;

/** Contains the publication's draft count. */
export type DraftsInformation = {
  __typename?: 'DraftsInformation';
  /** The number of drafts in the publication. */
  total: Scalars['Int'];
};

/**
 * An edge that contains a node and cursor to the node.
 * This is a common interface for all edges.
 */
export type Edge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** A node in the connection. */
  node: Node;
};

/** The input for the email import acknowledgement mutation. */
export type EmailCurrentImport = {
  __typename?: 'EmailCurrentImport';
  /** The number of subscribers that have attempted to import */
  attemptedToImport?: Maybe<Scalars['Int']>;
  /** The filename of the csv file containing emails */
  filename?: Maybe<Scalars['String']>;
  /** The date the import started */
  importStartedAt: Scalars['DateTime'];
  /** The status of the import */
  status: EmailImportStatus;
  /** The number of subscribers that have been successfully imported */
  successfullyImported?: Maybe<Scalars['Int']>;
};

/** Contains information about the email import. */
export type EmailImport = {
  __typename?: 'EmailImport';
  /** Contains information about the current import example if it is in progress or has finished, date started, etc */
  currentImport?: Maybe<EmailCurrentImport>;
};

/** The status of the email import. */
export enum EmailImportStatus {
  /** There was an error during the import. */
  Failed = 'FAILED',
  /** The import has been acknowledged by the user. */
  Finished = 'FINISHED',
  /** Import has been initialized but is not yet in progress. */
  Initialized = 'INITIALIZED',
  /** Import is in progress. */
  InProgress = 'IN_PROGRESS',
  /** Import has to be reviewed by Hashnode. It is not yet reviewed. */
  InReview = 'IN_REVIEW',
  /** The has been rejected. Nothing has been imported. */
  Rejected = 'REJECTED',
  /** Import was successful. New emails have been imported. */
  Success = 'SUCCESS'
}

/** User's email notification preferences. */
export type EmailNotificationPreferences = {
  __typename?: 'EmailNotificationPreferences';
  /** Indicates if the user has opted in to receive activity notifications. */
  activityNotifications: Scalars['Boolean'];
  /** Indicates if the user has opted in to receive general announcements. */
  generalAnnouncements: Scalars['Boolean'];
  /** Indicates if the user has opted in to receive monthly blog performance stats. */
  monthlyBlogStats: Scalars['Boolean'];
  /** Indicates if the user has opted in to receive new followers weekly. */
  newFollowersWeekly: Scalars['Boolean'];
  /** Indicates if the user has opted in to receive the Hashnode Weekly newsletter. */
  weeklyNewsletterEmails: Scalars['Boolean'];
};

/** The input for enabling AI search for a documentation project */
export type EnableDocumentationProjectAiSearchInput = {
  /** The ID of the documentation project */
  projectId: Scalars['ID'];
};

/** The response to enabling AI search for a documentation project */
export type EnableDocumentationProjectAiSearchPayload = {
  __typename?: 'EnableDocumentationProjectAISearchPayload';
  project?: Maybe<DocumentationProject>;
};

export type EnableDocumentationProjectHeadlessCmsInput = {
  projectId: Scalars['ID'];
};

export type EnableDocumentationProjectHeadlessCmsPayload = {
  __typename?: 'EnableDocumentationProjectHeadlessCmsPayload';
  project?: Maybe<DocumentationProject>;
};

export type EnableHeadlessCmsInput = {
  headlessInstallationBaseUrl: Scalars['String'];
  publicationId: Scalars['ID'];
};

export type EnableHeadlessCmsPayload = {
  __typename?: 'EnableHeadlessCMSPayload';
  publication?: Maybe<Publication>;
};

/** Invitations that failed to be sent to the user */
export type FailedInvite = {
  __typename?: 'FailedInvite';
  /** The email of the user that failed to invite. */
  email?: Maybe<Scalars['String']>;
  /** The reason why the user failed to invite. */
  errorMessage: Scalars['String'];
  /** The username of the user that failed to invite. */
  username?: Maybe<Scalars['String']>;
};

/** Common fields that describe a feature. */
export type Feature = {
  /** Whether the feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

export type FeedFilter = {
  /** Adds a filter to return posts with maximum number of minutes required to read the post. */
  maxReadTime?: InputMaybe<Scalars['Int']>;
  /** Adds a filter to return posts with minimum number of minutes required to read the post. */
  minReadTime?: InputMaybe<Scalars['Int']>;
  /** Adds a filter to return posts with tagged with provided tags only. */
  tags?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The type of feed to be returned. */
  type?: InputMaybe<FeedType>;
};

/**
 * Connection for posts within a feed. Contains a list of edges containing nodes.
 * Each node is a post.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type FeedPostConnection = Connection & {
  __typename?: 'FeedPostConnection';
  /** A list of edges containing Post information */
  edges: Array<PostEdge>;
  /** Information for pagination in Post connection. */
  pageInfo: PageInfo;
};

/** Contains information about type of feed to be returned. */
export enum FeedType {
  /** Returns posts which were bookmarked by the user, sorted based on recency. */
  Bookmarks = 'BOOKMARKS',
  /** Returns posts which were featured, sorted based on recency. */
  Featured = 'FEATURED',
  /**
   * Returns only posts of the users you follow or publications you have subscribed to.
   *
   * Note: You have to be authenticated to use this feed type.
   */
  Following = 'FOLLOWING',
  /**
   * Returns only posts based on users following and interactions.
   *
   * Personalised feed is curated per requesting user basis.
   */
  Personalized = 'PERSONALIZED',
  /** Returns posts which were viewed by the user, sorted based on recency. */
  ReadingHistory = 'READING_HISTORY',
  /** Returns posts which were published recently, sorted based on recency. */
  Recent = 'RECENT',
  /** Returns posts based on old personalization algorithm. */
  Relevant = 'RELEVANT'
}

export type FollowTagsInput = {
  /** List of tag ids to follow. */
  ids: Array<Scalars['ID']>;
};

export type FollowTagsPayload = {
  __typename?: 'FollowTagsPayload';
  /** List of tags followed by the user. */
  tags?: Maybe<Array<Tag>>;
};

export type FreeTrialInfo = {
  __typename?: 'FreeTrialInfo';
  /**
   * The date the free trial will end or has ended.
   * If no value is returned, the free trial was not yet activated
   */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Indicates if the user has access to pro features within the free trial period. */
  hasFreeTrialAccess: Scalars['Boolean'];
  /**
   * The date the free trial was started.
   * If no value is returned, the free trial was not yet activated
   */
  startedAt?: Maybe<Scalars['DateTime']>;
};

export type GptBotCrawlingFeature = Feature & {
  __typename?: 'GPTBotCrawlingFeature';
  /** A flag indicating if the GPT Bot Crawler feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

/** The input for the exchange of token to a JWT to preview token for a documentation project. */
export type GenerateDocumentationProjectPreviewAuthorizationTokenInput = {
  token: Scalars['String'];
};

/** The payload for the exchange of token to a JWT to preview token for a documentation project. */
export type GenerateDocumentationProjectPreviewAuthorizationTokenPayload = {
  __typename?: 'GenerateDocumentationProjectPreviewAuthorizationTokenPayload';
  /** The JWT that can be used to preview the documentation project. */
  authorizationToken?: Maybe<Scalars['String']>;
  /** The project for which the JWT is generated. With this request, authenticated fields are not accessible. */
  project?: Maybe<DocumentationProject>;
};

/** The input for the generation of a exchangeable preview token for a documentation project. */
export type GenerateDocumentationProjectPreviewTokenInput = {
  projectId: Scalars['ID'];
};

/** The payload for the generation of a exchangeable preview token for a documentation project. */
export type GenerateDocumentationProjectPreviewTokenPayload = {
  __typename?: 'GenerateDocumentationProjectPreviewTokenPayload';
  /** The project for which the token is generated. */
  project?: Maybe<DocumentationProject>;
  /** The token that can be exchanged for a JWT to preview the documentation project. */
  token?: Maybe<Scalars['String']>;
};

export type GitHubActivityLog = Node & {
  __typename?: 'GitHubActivityLog';
  /** The branch name that the commit belongs to. */
  branchName: Scalars['String'];
  /** The date the log was created. */
  createdAt: Scalars['DateTime'];
  /** The deployment type related to the log. */
  deploymentType: DocsGitHubActivityDeploymentType;
  /** The deployment URL. For preview activities, the deployment URL is different for every commit. For production deployments, the deploymentUrl points to the main project subdomain. */
  deploymentUrl: Scalars['String'];
  /** The errors occurred during the sync. */
  errors: Array<GitHubSyncError>;
  /** The commit ID. */
  gitCommitId: Scalars['String'];
  /** The commit message. */
  gitCommitMessage: Scalars['String'];
  /** The commit URL. */
  gitCommitUrl: Scalars['String'];
  /** The ID of the log. */
  id: Scalars['ID'];
  /** The ID of the project. */
  projectId: Scalars['ID'];
  /** The status of the sync. */
  status: GitHubSyncStatus;
};

export type GitHubSyncError = {
  __typename?: 'GitHubSyncError';
  /** The error code denoting the reason of failure for GitHub sync. */
  code: GitHubSyncErrorCode;
  /** List of error messages */
  messages: Array<Scalars['String']>;
};

export enum GitHubSyncErrorCode {
  /** Indicates that the project has configuration errors. */
  ConfigurationError = 'CONFIGURATION_ERROR',
  /** Indicates that the project has invalid content. */
  ContentError = 'CONTENT_ERROR',
  /** Indicates that the project has duplicate paths. */
  DuplicatePaths = 'DUPLICATE_PATHS',
  /** Indicates that the project has duplicate slugs. */
  DuplicateSlugs = 'DUPLICATE_SLUGS',
  /** Indicates that the project has missing files. */
  MissingFiles = 'MISSING_FILES'
}

/** Contains the flag indicating if the GitHub sync feature is enabled or not. */
export type GitHubSyncFeature = Feature & {
  __typename?: 'GitHubSyncFeature';
  /** A flag indicating if the GitHub sync feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

export enum GitHubSyncStatus {
  /** The sync is in progress */
  Building = 'BUILDING',
  /** The sync failed */
  Failed = 'FAILED',
  /** The sync is complete */
  Ready = 'READY'
}

/** Views implementation that will be returned if grouping by browser. */
export type GroupedByBrowserViews = Node & Views & {
  __typename?: 'GroupedByBrowserViews';
  /** The browser that these views belong to. */
  browser: Scalars['String'];
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by browser. */
export type GroupedByBrowserVisitors = Node & Visitors & {
  __typename?: 'GroupedByBrowserVisitors';
  /** The browser that these views belong to. */
  browser: Scalars['String'];
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by country. */
export type GroupedByCountryViews = Node & Views & {
  __typename?: 'GroupedByCountryViews';
  /** The country that these views belong to. */
  country: CountryCodeAlpha2;
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by country. */
export type GroupedByCountryVisitors = Node & Visitors & {
  __typename?: 'GroupedByCountryVisitors';
  /** The country that these views belong to. */
  country: CountryCodeAlpha2;
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by device type. */
export type GroupedByDeviceTypeViews = Node & Views & {
  __typename?: 'GroupedByDeviceTypeViews';
  /** The type of device that these views belong to. */
  deviceType: DeviceType;
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by device type. */
export type GroupedByDeviceTypeVisitors = Node & Visitors & {
  __typename?: 'GroupedByDeviceTypeVisitors';
  /** The type of device that these views belong to. */
  deviceType: DeviceType;
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by browser. */
export type GroupedByDocsBrowserViews = DocsViews & Node & {
  __typename?: 'GroupedByDocsBrowserViews';
  /** The browser that these views belong to. */
  browser: Scalars['String'];
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by browser. */
export type GroupedByDocsBrowserVisitors = DocsVisitors & Node & {
  __typename?: 'GroupedByDocsBrowserVisitors';
  /** The browser that these views belong to. */
  browser: Scalars['String'];
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by country. */
export type GroupedByDocsCountryViews = DocsViews & Node & {
  __typename?: 'GroupedByDocsCountryViews';
  /** The country that these views belong to. */
  country: CountryCodeAlpha2;
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by country. */
export type GroupedByDocsCountryVisitors = DocsVisitors & Node & {
  __typename?: 'GroupedByDocsCountryVisitors';
  /** The country that these views belong to. */
  country: CountryCodeAlpha2;
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by device type. */
export type GroupedByDocsDeviceTypeViews = DocsViews & Node & {
  __typename?: 'GroupedByDocsDeviceTypeViews';
  /** The type of device that these views belong to. */
  deviceType: DeviceType;
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by device type. */
export type GroupedByDocsDeviceTypeVisitors = DocsVisitors & Node & {
  __typename?: 'GroupedByDocsDeviceTypeVisitors';
  /** The type of device that these views belong to. */
  deviceType: DeviceType;
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Grouped views by documentation guide or API reference guide. */
export type GroupedByDocsGuideViews = DocsViews & Node & {
  __typename?: 'GroupedByDocsGuideViews';
  apiReferenceGuideId?: Maybe<Scalars['ObjectId']>;
  documentationGuideId?: Maybe<Scalars['ObjectId']>;
  /** The documentation Guide or the API reference guide that these views belong to. */
  guide?: Maybe<DocumentationGuideItem>;
  guides: Array<DocumentationGuideItem>;
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Grouped visitors by documentation guide or API reference guide. */
export type GroupedByDocsGuideVisitors = DocsVisitors & Node & {
  __typename?: 'GroupedByDocsGuideVisitors';
  apiReferenceGuideId?: Maybe<Scalars['ObjectId']>;
  documentationGuideId?: Maybe<Scalars['ObjectId']>;
  /** The documentation Guide or the API reference guide that these views belong to. */
  guide?: Maybe<DocumentationGuideItem>;
  guides: Array<DocumentationGuideItem>;
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by operating system. */
export type GroupedByDocsOperatingSystemViews = DocsViews & Node & {
  __typename?: 'GroupedByDocsOperatingSystemViews';
  id: Scalars['ID'];
  /** The operating system that these views belong to. */
  operatingSystem: Scalars['String'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by operating system. */
export type GroupedByDocsOperatingSystemVisitors = DocsVisitors & Node & {
  __typename?: 'GroupedByDocsOperatingSystemVisitors';
  id: Scalars['ID'];
  /** The operating system that these views belong to. */
  operatingSystem: Scalars['String'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

export type GroupedByDocsPageViews = DocsViews & Node & {
  __typename?: 'GroupedByDocsPageViews';
  id: Scalars['ID'];
  /** The page that these views belong to. */
  page?: Maybe<DocumentationPage>;
  pageId: Scalars['ObjectId'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by docs page. */
export type GroupedByDocsPageVisitors = DocsVisitors & Node & {
  __typename?: 'GroupedByDocsPageVisitors';
  id: Scalars['ID'];
  /** The page that these views belong to. */
  page?: Maybe<DocumentationPage>;
  pageId: Scalars['ObjectId'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by path. */
export type GroupedByDocsPathViews = DocsViews & Node & {
  __typename?: 'GroupedByDocsPathViews';
  id: Scalars['ID'];
  /** The path that these views belong to. */
  path: Scalars['String'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by path. */
export type GroupedByDocsPathVisitors = DocsVisitors & Node & {
  __typename?: 'GroupedByDocsPathVisitors';
  id: Scalars['ID'];
  /** The path that these views belong to. */
  path: Scalars['String'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by `REFERRER_HOST` dimension. */
export type GroupedByDocsReferrerHostViews = DocsViews & Node & {
  __typename?: 'GroupedByDocsReferrerHostViews';
  id: Scalars['ID'];
  /** The referrer host that these views belong to. */
  referrerHost: Scalars['String'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by `REFERRER_HOST` dimension. */
export type GroupedByDocsReferrerHostVisitors = DocsVisitors & Node & {
  __typename?: 'GroupedByDocsReferrerHostVisitors';
  id: Scalars['ID'];
  /** The referrer host that these views belong to. */
  referrerHost: Scalars['String'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

export type GroupedByDocsTimeViews = DocsViews & Node & {
  __typename?: 'GroupedByDocsTimeViews';
  /** The start of the time range that these views belong to. */
  from: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The end of the time range that these views belong to. */
  to: Scalars['DateTime'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if a grouping by time is provided. */
export type GroupedByDocsTimeVisitors = DocsVisitors & Node & {
  __typename?: 'GroupedByDocsTimeVisitors';
  /** The start of the time range that these visitors visited the page. */
  from: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The end of the time range that these visitors visited the page. */
  to: Scalars['DateTime'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by operating system. */
export type GroupedByOperatingSystemViews = Node & Views & {
  __typename?: 'GroupedByOperatingSystemViews';
  id: Scalars['ID'];
  /** The operating system that these views belong to. */
  operatingSystem: Scalars['String'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by operating system. */
export type GroupedByOperatingSystemVisitors = Node & Visitors & {
  __typename?: 'GroupedByOperatingSystemVisitors';
  id: Scalars['ID'];
  /** The operating system that these views belong to. */
  operatingSystem: Scalars['String'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by page. */
export type GroupedByPageViews = Node & Views & {
  __typename?: 'GroupedByPageViews';
  id: Scalars['ID'];
  /** The page that these views belong to. */
  page: StaticPage;
  pageId: Scalars['ObjectId'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by page. */
export type GroupedByPageVisitors = Node & Visitors & {
  __typename?: 'GroupedByPageVisitors';
  id: Scalars['ID'];
  /** The page that these views belong to. */
  page: StaticPage;
  pageId: Scalars['ObjectId'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by path. */
export type GroupedByPathViews = Node & Views & {
  __typename?: 'GroupedByPathViews';
  id: Scalars['ID'];
  /** The path that these views belong to. */
  path: Scalars['String'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by path. */
export type GroupedByPathVisitors = Node & Visitors & {
  __typename?: 'GroupedByPathVisitors';
  id: Scalars['ID'];
  /** The path that these views belong to. */
  path: Scalars['String'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by post. */
export type GroupedByPostViews = Node & Views & {
  __typename?: 'GroupedByPostViews';
  id: Scalars['ID'];
  /** The post that these views belong to. */
  post: Post;
  postId: Scalars['ObjectId'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by post. */
export type GroupedByPostVisitors = Node & Visitors & {
  __typename?: 'GroupedByPostVisitors';
  id: Scalars['ID'];
  /** The post that these views belong to. */
  post: Post;
  postId: Scalars['ObjectId'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if grouping by `REFERRER_HOST` dimension. */
export type GroupedByReferrerHostViews = Node & Views & {
  __typename?: 'GroupedByReferrerHostViews';
  id: Scalars['ID'];
  /** The referrer host that these views belong to. */
  referrerHost: Scalars['String'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if grouping by `REFERRER_HOST` dimension. */
export type GroupedByReferrerHostVisitors = Node & Visitors & {
  __typename?: 'GroupedByReferrerHostVisitors';
  id: Scalars['ID'];
  /** The referrer host that these views belong to. */
  referrerHost: Scalars['String'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

export type GroupedByTimeViews = Node & Views & {
  __typename?: 'GroupedByTimeViews';
  /** The start of the time range that these views belong to. */
  from: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The end of the time range that these views belong to. */
  to: Scalars['DateTime'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if a grouping by time is provided. */
export type GroupedByTimeVisitors = Node & Visitors & {
  __typename?: 'GroupedByTimeVisitors';
  /** The start of the time range that these visitors visited the page. */
  from: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The end of the time range that these visitors visited the page. */
  to: Scalars['DateTime'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

export enum GuideProvider {
  Github = 'GITHUB',
  Hashnode = 'HASHNODE'
}

export enum GuideVersionStatus {
  Deprecated = 'DEPRECATED',
  Stable = 'STABLE',
  Unstable = 'UNSTABLE'
}

export type HeadlessCmsFeature = Feature & {
  __typename?: 'HeadlessCMSFeature';
  /** A flag indicating if the Headless CMS feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

export enum HttpRedirectionType {
  /** A permanent redirect that corresponds to the 302 HTTP status code. */
  Permanent = 'PERMANENT',
  /** A temporary redirect that corresponds to the 301 HTTP status code. */
  Temporary = 'TEMPORARY'
}

export type IDocumentationNestableSidebarItem = {
  pages: Array<DocumentationSidebarItemPage>;
};

export type IDocumentationSidebarItem = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibility: DocumentationSidebarItemVisibility;
};

export type IGuide = {
  id: Scalars['ID'];
  /**
   * A guide can be locked if the subscription doesn't cover to having this guide.
   *
   * A locked guide is readonly. It can only be removed or edited after subscribing.
   */
  isLocked: Scalars['Boolean'];
  lastModified: Scalars['DateTime'];
  name: Scalars['String'];
  /** OG meta-data of the page. Contains image url used in open graph meta tags. */
  ogMetaData?: Maybe<OpenGraphMetaData>;
  provider: GuideProvider;
  /** SEO information of the page. Contains title and description used in meta tags. */
  seo?: Maybe<Seo>;
  slug: Scalars['String'];
  status: DocumentationGuideItemStatus;
  /** The ID of the default version. */
  versionId?: Maybe<Scalars['String']>;
};

export type IGuideVersion = {
  /** Internal code name for the version. */
  codeName?: Maybe<Scalars['String']>;
  /** Timestamp of when the version was created. */
  createdAt: Scalars['DateTime'];
  /** The version that this version was forked from. */
  forkedFrom?: Maybe<IGuideVersion>;
  /** Unique identifier for the guide version. */
  id: Scalars['ID'];
  /**
   * Indicates if this is the default version.
   *
   * There is always exactly one default version at a given time.
   */
  isDefault: Scalars['Boolean'];
  /** Display name of the version. */
  name: Scalars['String'];
  /** URL-friendly identifier for the version. */
  slug: Scalars['String'];
  /** Status of the guide version. */
  status: GuideVersionStatus;
  /** Timestamp of the last update to the version. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Visibility of the guide version. */
  visibility: DocumentationGuideVisibility;
};

/**
 * Contains basic information about the tag.
 * A tag is a label that categorizes posts with similar topics.
 */
export type ITag = {
  /** Total number of users following this tag. */
  followersCount: Scalars['Int'];
  /** The ID of the tag. */
  id: Scalars['ID'];
  /** Information about the tag. Contains markdown html and text version of the tag's info. */
  info?: Maybe<Content>;
  /** The logo of the tag. Shown in tag page. */
  logo?: Maybe<Scalars['String']>;
  /** The name of the tag. Shown in tag page. */
  name: Scalars['String'];
  /** Alltime usage count of this tag in posts. */
  postsCount: Scalars['Int'];
  /** The slug of the tag. Used to access tags feed.  Example https://hashnode.com/n/graphql */
  slug: Scalars['String'];
  /** The tagline of the tag. */
  tagline?: Maybe<Scalars['String']>;
};

/** Basic information about a user on Hashnode. */
export type IUser = {
  /** Whether or not the user is an ambassador. */
  ambassador: Scalars['Boolean'];
  /** The availability of the user based on tech stack and interests. Shown on the "I am available for" section in user's profile. */
  availableFor?: Maybe<Scalars['String']>;
  /** Returns a list of badges that the user has earned. Shown on blogs /badges page. Example - https://iamshadmirza.com/badges */
  badges: Array<Badge>;
  /** The bio of the user. Visible in about me section of the user's profile. */
  bio?: Maybe<Content>;
  /** The date the user joined Hashnode. */
  dateJoined?: Maybe<Scalars['DateTime']>;
  /** Whether or not the user is deactivated. */
  deactivated: Scalars['Boolean'];
  /** The users who are following this user */
  followers: UserConnection;
  /** The number of users that follow the requested user. Visible in the user's profile. */
  followersCount: Scalars['Int'];
  /** The number of users that this user is following. Visible in the user's profile. */
  followingsCount: Scalars['Int'];
  /** The users which this user is following */
  follows: UserConnection;
  /** The ID of the user. It can be used to identify the user. */
  id: Scalars['ID'];
  /** The location of the user. */
  location?: Maybe<Scalars['String']>;
  /** The name of the user. */
  name: Scalars['String'];
  /** Returns the list of posts the user has published. */
  posts: UserPostConnection;
  /** The URL to the profile picture of the user. */
  profilePicture?: Maybe<Scalars['String']>;
  /** Publications associated with the user. Includes personal and team publications. */
  publications: UserPublicationsConnection;
  /** The social media links of the user. Shown on the user's profile. */
  socialMediaLinks?: Maybe<SocialMediaLinks>;
  /** The tagline of the user. Shown on the user's profile below the name. */
  tagline?: Maybe<Scalars['String']>;
  /** Returns a list of tags that the user follows. */
  tagsFollowing: Array<Tag>;
  /** Returns list of tags from user's expertise. Shown on the user's profile. */
  techStack: UserTagsConnection;
  /** The username of the user. It is unique and tied with user's profile URL. Example - https://hashnode.com/@username */
  username: Scalars['String'];
};


/** Basic information about a user on Hashnode. */
export type IUserFollowersArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/** Basic information about a user on Hashnode. */
export type IUserFollowsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/** Basic information about a user on Hashnode. */
export type IUserPostsArgs = {
  filter?: InputMaybe<UserPostConnectionFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortBy?: InputMaybe<UserPostsSort>;
};


/** Basic information about a user on Hashnode. */
export type IUserPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserPublicationsConnectionFilter>;
  first: Scalars['Int'];
  sortBy?: InputMaybe<UserPublicationsSort>;
};


/** Basic information about a user on Hashnode. */
export type IUserTechStackArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

/** The input for the email import subscription mutation. */
export type ImportSubscribersInput = {
  /** The content of the csv file */
  csvContent: Scalars['String'];
  /** The filename of the csv file */
  filename: Scalars['String'];
  /** The publication ID for which the import has to be acknowledged. */
  publication: Scalars['ObjectId'];
};

export type InviteDocumentationProjectAdminInput = {
  invites: Array<InviteDocumentationProjectAdminInputEmail>;
  projectId: Scalars['ID'];
};

export type InviteDocumentationProjectAdminInputEmail = {
  userId: Scalars['ID'];
};

export type InviteDocumentationProjectAdminPayload = {
  __typename?: 'InviteDocumentationProjectAdminPayload';
  invitedMembers?: Maybe<Array<DocsProjectInvitedMembers>>;
  project?: Maybe<DocumentationProject>;
};

/** Input to invite users to a publication. */
export type InviteUsersToPublicationInput = {
  /** The publication ID to invite users to. */
  publicationId: Scalars['ID'];
  /** The list of users  to invite to the publication. */
  users: Array<UserInviteInput>;
};

/** Response to inviting users to a publication. */
export type InviteUsersToPublicationPayload = {
  __typename?: 'InviteUsersToPublicationPayload';
  /** Invites that failed due to an error. */
  failedInvites: Array<FailedInvite>;
  /** Signifies if the mutation was successful for all users. */
  success: Scalars['Boolean'];
  /** The number of successful invites. */
  successfulInviteCount: Scalars['Int'];
};

export type LeaveTeamPublicationInput = {
  /** The ID of the team publication to leave */
  publicationId: Scalars['ID'];
};

export type LeaveTeamPublicationPayload = {
  __typename?: 'LeaveTeamPublicationPayload';
  /** Returns the removed publication member. */
  member?: Maybe<PublicationMember>;
};

export type LikeCommentInput = {
  commentId: Scalars['ID'];
  likesCount?: InputMaybe<Scalars['Int']>;
};

export type LikeCommentPayload = {
  __typename?: 'LikeCommentPayload';
  comment?: Maybe<Comment>;
};

export type LikePostInput = {
  likesCount?: InputMaybe<Scalars['Int']>;
  postId: Scalars['ID'];
};

export type LikePostPayload = {
  __typename?: 'LikePostPayload';
  post?: Maybe<Post>;
};

export type LikeReplyInput = {
  commentId: Scalars['ID'];
  likesCount?: InputMaybe<Scalars['Int']>;
  replyId: Scalars['ID'];
};

export type LikeReplyPayload = {
  __typename?: 'LikeReplyPayload';
  reply?: Maybe<Reply>;
};

export type MapDocumentationProjectCustomDomainWwwRedirectInput = {
  projectId: Scalars['ID'];
};

export type MapDocumentationProjectCustomDomainWwwRedirectPayload = {
  __typename?: 'MapDocumentationProjectCustomDomainWwwRedirectPayload';
  /**
   * Additional DNS entries required to verify the www redirect domain.
   * There are cases where additional records in the DNS config are required to successfully verify the domain.
   */
  dnsVerificationEntries: Array<DnsVerificationEntry>;
  project?: Maybe<DocumentationProject>;
};

export type MapPublicationCustomDomainWwwRedirectInput = {
  publicationId: Scalars['ID'];
};

export type MapPublicationCustomDomainWwwRedirectPayload = {
  __typename?: 'MapPublicationCustomDomainWwwRedirectPayload';
  publication?: Maybe<Publication>;
};

export type MarkDefaultDocumentationVersionInput = {
  /** ID of the project that contains the version to be marked as default. */
  projectId: Scalars['ID'];
  /** ID of the version to be marked as default. */
  versionId: Scalars['ID'];
};

export type MarkDefaultDocumentationVersionPayload = {
  __typename?: 'MarkDefaultDocumentationVersionPayload';
  /** The updated project containing the default version. */
  project?: Maybe<DocumentationProject>;
  /** The new default version. */
  version?: Maybe<DocumentationVersion>;
};

/** Contains information about meta tags. Used for SEO purpose. */
export type MetaTagsInput = {
  /** The description of the post used in og:description for SEO. */
  description?: InputMaybe<Scalars['String']>;
  /** The image URL of the post used in og:image for SEO. */
  image?: InputMaybe<Scalars['String']>;
  /** The title of the post used in og:title for SEO. */
  title?: InputMaybe<Scalars['String']>;
};

/**
 * Money is a scalar type that represents a monetary value.
 * This is used in pro plan.
 */
export type Money = {
  __typename?: 'Money';
  /** The amount of money. */
  amount: Scalars['Decimal'];
  /** The currency code of the money. */
  currencyCode: Scalars['CurrencyCode'];
};

/** Input for moving a navbar column in the footer of a documentation project. */
export type MoveDocumentationFooterNavbarColumnInput = {
  /** The ID of the navbar column that will be moved. */
  columnId: Scalars['ID'];
  /** The new position of the navbar column. */
  position: Scalars['Int'];
  /** The ID of the project that the navbar column will be moved in. */
  projectId: Scalars['ID'];
};

/** Payload for moving a navbar column in the footer of a documentation project. */
export type MoveDocumentationFooterNavbarColumnPayload = {
  __typename?: 'MoveDocumentationFooterNavbarColumnPayload';
  /** The project that the navbar footer column was moved in. */
  project?: Maybe<DocumentationProject>;
};

/** Input for moving a navbar item in the footer of a documentation project. */
export type MoveDocumentationFooterNavbarItemInput = {
  /** The column where the item is located. */
  columnId: Scalars['ID'];
  /** The ID of the navbar item that will be moved. */
  itemId: Scalars['ID'];
  /** The new position of the navbar item. */
  position: Scalars['Int'];
  /** The ID of the project that the navbar item will be moved in. */
  projectId: Scalars['ID'];
};

/** Payload for moving a navbar item in the footer of a documentation project. */
export type MoveDocumentationFooterNavbarItemPayload = {
  __typename?: 'MoveDocumentationFooterNavbarItemPayload';
  /** The project that the navbar footer item was moved in. */
  project?: Maybe<DocumentationProject>;
};

/** Input for moving a navbar item in the header of a documentation project. */
export type MoveDocumentationHeaderNavbarItemInput = {
  /** The ID of the navbar item that will be moved. */
  itemId: Scalars['ID'];
  /** The new position of the navbar item. */
  position: Scalars['Int'];
  /** The ID of the project that the navbar item will be moved in. */
  projectId: Scalars['ID'];
};

/** Payload for moving a navbar item in the header of a documentation project. */
export type MoveDocumentationHeaderNavbarItemPayload = {
  __typename?: 'MoveDocumentationHeaderNavbarItemPayload';
  /** The project that the navbar header item was moved in. */
  project?: Maybe<DocumentationProject>;
};

export type MoveDocumentationSidebarItemInput = {
  guideSlug: Scalars['String'];
  itemId: Scalars['ID'];
  parentId?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['ID'];
};

export type MoveDocumentationSidebarItemPayload = {
  __typename?: 'MoveDocumentationSidebarItemPayload';
  guide?: Maybe<DocumentationGuide>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  /** Mutation to accept an invite to a documentation project */
  acceptInviteToDocumentationProject: AcceptInviteToDocumentationProjectPayload;
  /** Accepts an invitation to join a publication. The user is added as a member of the publication. */
  acceptInviteToPublication: AcceptInviteToPublicationPayload;
  /** Accepts a role based invite and adds the user as a member of the publication. The user is assigned the role specified in the invite. */
  acceptRoleBasedInvite: AcceptRoleBasedInvitePayload;
  acknowledgeEmailImport: AcknowledgeEmailImportPayload;
  /** Activates the free AI trial for the user. */
  activateFreeTrial: ActivateFreeTrialPayload;
  /** Adds a comment to a post. */
  addComment: AddCommentPayload;
  /** Mutation to add a prompt to the AI search */
  addDocumentationProjectAIPrompt: AddDocumentationProjectAiPromptPayload;
  addDocumentationProjectCustomDomain: AddDocumentationProjectCustomDomainPayload;
  /** Mutation to connect a documentation project to a GitHub repository for GitHub sync */
  addDocumentationProjectGitHubSyncIntegration: AddDocumentationProjectGitHubSyncIntegrationPayload;
  /** Adds a post to a series. */
  addPostToSeries: AddPostToSeriesPayload;
  /** Adds a custom domain to a publication. */
  addPublicationCustomDomain: AddPublicationCustomDomainPayload;
  /**
   * Adds publications to an existing pro plan of the user making the request.
   * The user must have enough credits to add the publications.
   */
  addPublicationsToProPlan: AddPublicationsToProPlanPayload;
  /** Adds a reply to a comment. */
  addReply: AddReplyPayload;
  /**
   * Adds additional credits to the user's pro subscription.
   * This mutation is only available to users with an active pro plan.
   * **Warning:** This changes the amount charged to the user.
   */
  buyProPlanCredits: BuyProPlanCreditsPayload;
  /** Schedules a cancelation of the publications pro plan to the end of the billing period. */
  cancelPublicationsProPlan: CancelPublicationsProPlanPayload;
  cancelScheduledDraft: CancelScheduledDraftPayload;
  /**
   * Moves the draft to a different publication.
   *
   * This resets the draft's author (if changed), co-authors and series since the new publication might not have access to those.
   */
  changeDraftPublication: ChangeDraftPublicationPayload;
  /** Changes the role of a user in a publication. */
  changePublicationMemberRole: ChangePublicationMemberRolePayload;
  /**
   * Changes the privacy state of a user in a publication.
   * PRIVATE members are not visible on the members page while PUBLIC members are visible.
   */
  changePublicationMemberVisibility: ChangePublicationMemberVisibilityPayload;
  /**
   * Converts a personal publication to a team publication.
   * WARNING: This will permanently convert personal publication to team publication. This is not reversible.
   */
  convertToTeamPublication: ConvertToTeamPublicationPayload;
  /** Create a new docs custom page. */
  createDocsCustomPage: DocsCustomPagePayload;
  createDocumentationApiReference: CreateDocumentationApiReferencePayload;
  createDocumentationGuide: CreateDocumentationGuidePayload;
  /** Create a new version of a documentation guide. */
  createDocumentationGuideVersion: CreateDocumentationGuideVersionPayload;
  createDocumentationLink: CreateDocumentationLinkPayload;
  createDocumentationNavbarColumn: CreateDocumentationNavbarColumnPayload;
  createDocumentationNavbarItemGuide: CreateDocumentationNavbarItemGuidePayload;
  createDocumentationNavbarItemLink: CreateDocumentationNavbarItemLinkPayload;
  createDocumentationNavbarItemPage: CreateDocumentationNavbarItemPagePayload;
  createDocumentationPageDraft: CreateDocumentationPageDraftPayload;
  /** Mutation to create a preview project based on an existing documentation project. */
  createDocumentationPreviewProject: CreateDocumentationPreviewProjectPayload;
  /** Mutation to create a preview project based on an existing documentation project. This is used in GitHub PRs. */
  createDocumentationPreviewProjectFromGitHub: CreateDocumentationPreviewProjectPayload;
  createDocumentationProject: CreateDocumentationProjectPayload;
  createDocumentationProjectBillingPortalUrl: CreateDocumentationProjectBillingPortalUrlPayload;
  createDocumentationProjectCheckoutUrl: CreateDocumentationProjectCheckoutUrlPayload;
  createDocumentationProjectPaymentLink: CreateDocumentationProjectPaymentLinkPayload;
  createDocumentationSection: CreateDocumentationSectionPayload;
  /** Creates a new draft for a post. */
  createDraft: CreateDraftPayload;
  /** Creates a new draft revision for a draft. */
  createDraftRevision: CreateDraftRevisionPayload;
  /** Returns PresignedPost which contains a signed image upload URL. This URL can be used to upload images to Hashnode's S3 bucket. */
  createImageUploadURL: CreateImageUploadPayload;
  /** Creates a new personal access token for the authenticated user. */
  createPersonalAccessToken: CreatePersonalAccessTokenPayload;
  /**
   * Initially sign up for a pro plan.
   * Creates a checkout session that results in a pro plan subscription after success.
   */
  createProSubscriptionCheckout: CreateProSubscriptionCheckoutPayload;
  /** Creates personal publication. */
  createPublication: CreatePublicationPayload;
  createPublicationNavbarItem: CreatePublicationNavbarItemPayload;
  createRedirectionRule: CreateRedirectionRulePayload;
  /** Creates a role based invite for a publication and returns a link to invite users to a publication. */
  createRoleBasedInviteForPublication: CreateRoleBasedInviteForPublicationPayload;
  /** Creates a new series. */
  createSeries: CreateSeriesPayload;
  /** Create a new static page. */
  createStaticPage: CreateStaticPagePayload;
  /** Creates a new team publication. */
  createTeamPublication: CreateTeamPublicationPayload;
  createWebhook: CreateWebhookPayload;
  /** Create a new widget for a publication */
  createWidget: CreateWidgetPayload;
  /** Deletes an existing draft. */
  deleteDraft: DeleteDraftPayload;
  /** Deletes the authenticated user. */
  deleteMyUser: DeleteUserPayload;
  /**
   * Deletes the publication.
   * WARNING: This will permanently remove the publication. This is not reversable.
   */
  deletePublication: DeletePublicationPayload;
  /** Deletes a role based invite. */
  deleteRoleBasedInvite: DeleteRoleBasedInvitePayload;
  deleteWebhook: DeleteWebhookPayload;
  /** Mutation to disable AI search for a documentation project */
  disableDocumentationProjectAISearch: DisableDocumentationProjectAiSearchPayload;
  disableDocumentationProjectHeadlessCms: DisableDocumentationProjectHeadlessCmsPayload;
  /** Disable Headless CMS mode on your publication. */
  disableHeadlessCMS: DisableHeadlessCmsPayload;
  /** Mutation to enable AI search for a documentation project */
  enableDocumentationProjectAISearch: EnableDocumentationProjectAiSearchPayload;
  enableDocumentationProjectHeadlessCms: EnableDocumentationProjectHeadlessCmsPayload;
  /** Enable Headless CMS mode for your publication. */
  enableHeadlessCMS: EnableHeadlessCmsPayload;
  followTags: FollowTagsPayload;
  /**
   * Will generate a authorization JWT to preview a docs project.
   * A token is required to generate the JWT.
   */
  generateDocumentationProjectPreviewAuthorizationToken: GenerateDocumentationProjectPreviewAuthorizationTokenPayload;
  /**
   * Will generate a token that can be exchanged as a JWT to preview a docs project.
   * Only the owner or editors of the project can generate the token.
   */
  generateDocumentationProjectPreviewToken: GenerateDocumentationProjectPreviewTokenPayload;
  importSubscribers: NewsletterSubscriberPayload;
  /** Mutation to invite an user to a documentation project */
  inviteDocumentationProjectAdmin: InviteDocumentationProjectAdminPayload;
  /** Invites users to a publication. Either by username or email. */
  inviteUsersToPublication: InviteUsersToPublicationPayload;
  /**
   * Leave a team publication.
   * Users can leave a team publication if they wish to not be a part of it anymore.
   */
  leaveTeamPublication: LeaveTeamPublicationPayload;
  /** Likes a comment. */
  likeComment: LikeCommentPayload;
  /** Likes a post. */
  likePost: LikePostPayload;
  /** Likes a reply. */
  likeReply: LikeReplyPayload;
  mapDocumentationProjectCustomDomainWwwRedirect: MapDocumentationProjectCustomDomainWwwRedirectPayload;
  /** Map a www redirect to a existing custom domain. */
  mapPublicationCustomDomainWwwRedirect: MapPublicationCustomDomainWwwRedirectPayload;
  /**
   * Marks a version as the default. Removes the default flag from the current default
   *
   * The default version must not be hidden.
   * Exactly one version will be the default at any time.
   */
  markDefaultDocumentationVersion: MarkDefaultDocumentationVersionPayload;
  moveDocumentationFooterNavbarColumn: MoveDocumentationFooterNavbarColumnPayload;
  moveDocumentationFooterNavbarItem: MoveDocumentationFooterNavbarItemPayload;
  moveDocumentationHeaderNavbarItem: MoveDocumentationHeaderNavbarItemPayload;
  moveDocumentationSidebarItem: MoveDocumentationSidebarItemPayload;
  publishDocumentationApiReference: PublishDocumentationApiReferencePayload;
  /**
   * Publishes the default version of the guide.
   * @deprecated Use `publishDocumentationGuideVersion` instead
   */
  publishDocumentationGuide: PublishDocumentationGuidePayload;
  publishDocumentationGuideVersion: PublishDocumentationGuideVersionPayload;
  publishDocumentationPageDraft: PublishDocumentationPageDraftPayload;
  /** Mutation to publish a documentation project from a provider */
  publishDocumentationProjectFromGitHub: PublishDocumentationProjectFromGitHubPayload;
  /** Publishes an existing draft as a post. */
  publishDraft: PublishDraftPayload;
  /** Creates a new post. */
  publishPost: PublishPostPayload;
  /** Purges the cache for a given publication */
  purgePublicationCache: PurgePublicationCachePayload;
  /** Mutation to recrate a preview project */
  reCreateDocumentationPreviewProject: RecreateDocumentationPreviewProjectPayload;
  recommendPublications: RecommendPublicationsPayload;
  /** Mutation to re-invite an user to a documentation project */
  reinviteDocumentationProjectAdmin: ReinviteDocumentationProjectAdminPayload;
  /** Resends an invitation to a user to join a publication. The user must have been previously invited. Sends an email to the user. */
  reinviteUserToPublication: ReinviteUserToPublicationPayload;
  rejectDraftSubmission: RejectDraftSubmissionPayload;
  /** Removes a comment from a post. */
  removeComment: RemoveCommentPayload;
  /** Delete docs custom page. */
  removeDocsCustomPage: DocsCustomPagePayload;
  removeDocumentationFooterNavbarColumn: RemoveDocumentationFooterNavbarColumnPayload;
  removeDocumentationGuide: RemoveDocumentationGuidePayload;
  removeDocumentationNavbarItem: RemoveDocumentationNavbarItemPayload;
  /** Mutation to remove a preview project. */
  removeDocumentationPreviewProject: RemoveDocumentationPreviewProjectPayload;
  /**
   * Mutation to remove a documentation project.
   * This will free the custom domain and subdomain and removes all guides and pages.
   */
  removeDocumentationProject: RemoveDocumentationProjectPayload;
  /** Mutation to remove a prompt from the AI search */
  removeDocumentationProjectAIPrompt: RemoveDocumentationProjectAiPromptPayload;
  removeDocumentationProjectCustomDomain: RemoveDocumentationProjectCustomDomainPayload;
  /** Mutation to remove a documentation project's github sync integration */
  removeDocumentationProjectGitHubSyncIntegration: RemoveDocumentationProjectGitHubSyncIntegrationPayload;
  /** Mutation to remove a Member from a Documentation Project */
  removeDocumentationProjectMember: RemoveDocumentationProjectMemberPayload;
  removeDocumentationSidebarItem: RemoveDocumentationSidebarItemPayload;
  removeDocumentationVersion: RemoveDocumentationVersionPayload;
  /** Remove a newsletter subscriber from a publication. */
  removeNewsletterSubscriber: RemoveNewsletterSubscriberPayload;
  /** Removes a post. */
  removePost: RemovePostPayload;
  /** Removes a custom domain from a publication. */
  removePublicationCustomDomain: RemovePublicationCustomDomainPayload;
  /** Removes a user from a teams publication. */
  removePublicationMember: RemovePublicationMemberPayload;
  removePublicationNavbarItem: RemovePublicationNavbarItemPayload;
  removeRecommendation: RemoveRecommendationPayload;
  removeRedirectionRule: RemoveRedirectionRulePayload;
  /** Removes a reply from a comment. */
  removeReply: RemoveReplyPayload;
  /** Removes a series. */
  removeSeries: RemoveSeriesPayload;
  /** Remove a static page. */
  removeStaticPage: RemoveStaticPagePayload;
  /** Remove a widget from a publication */
  removeWidget: RemoveWidgetPayload;
  renameDocumentationGuide: RenameDocumentationGuideItemPayload;
  renameDocumentationSidebarItem: RenameDocumentationSidebarItemPayload;
  /** Reschedule a draft. */
  rescheduleDraft: RescheduleDraftPayload;
  resendEmailChangeVerification: ResendEmailChangeVerificationPayload;
  resendWebhookRequest: ResendWebhookRequestPayload;
  /** Restores a deleted post. */
  restorePost: RestorePostPayload;
  retryDocumentationProjectCustomDomainVerification: RetryDocumentationProjectCustomDomainVerificationPayload;
  retryPublicationCustomDomainVerification: RetryPublicationCustomDomainVerificationPayload;
  /** Mutation to revoke documentation project invite */
  revokeInviteToDocumentationProject: RevokeInviteToDocumentationProjectPayload;
  /** Revokes a personal access token. */
  revokePersonalAccessToken: RevokePersonalAccessTokenPayload;
  /** Revokes a user invitation that was sent to join a publication. */
  revokeUserInviteToPublication: RevokeUserInviteToPublicationPayload;
  saveDocumentationPageDraftContent: SaveDocumentationPageDraftContentPayload;
  scheduleDraft: ScheduleDraftPayload;
  setDocumentationSidebarItemVisibility: SetDocumentationSidebarItemVisibilityPayload;
  signUpUser: SignUpUserPayload;
  submitDraftForReview: SubmitDraftForReviewPayload;
  subscribeConsentedUserToNewsletter: SubscribeConsentedUserToNewsletterPayload;
  subscribeToNewsletter: SubscribeToNewsletterPayload;
  /** Mutation to sync documentation API reference definition */
  syncDocumentationProjectApiDefinition: SyncDocumentationProjectApiDefinitionPayload;
  /** Toggle allowContributorEdits flag to allow or restrict external contributors to further edit published articles. */
  toggleAllowContributorEdits: ToggleAllowContributorEditsPayload;
  toggleBlogBetaFeature: ToggleBlogBetaFeaturePayload;
  /**
   * Update the follow state for the user that is provided via id or username.
   * If the authenticated user does not follow the user, the mutation will follow the user.
   * If the authenticated user already follows the user, the mutation will un-follow the user.
   * Only available to the authenticated user.
   */
  toggleFollowUser: ToggleFollowUserPayload;
  /** Toggle GPT bot crawling feature. */
  toggleGPTBotCrawling: ToggleGptBotCrawlingPayload;
  /** Toggle the newsletter subscription service for a publication. Enabling it will send newsletters to the publication subscribers. */
  toggleNewsletterSubscription: ToggleNewsletterSubscriptionPayload;
  /** Toggle the visibility of a autogenerated page. */
  togglePageVisibility: TogglePageVisibilityPayload;
  /** Toggles role based invite links' active status. Users can join the publication by the invite link only if it is active. */
  toggleRoleBasedInviteLinks: ToggleRoleBasedInviteLinksPayload;
  /** Toggle text selection sharer feature. */
  toggleTextSelectionSharer: ToggleTextSelectionSharerPayload;
  toggleUserBetaFeature: ToggleUserBetaFeaturePayload;
  /**
   * Transfers ownership of a documentation project from the current owner to another admin.
   * Only the current owner can execute this mutation.
   */
  transferDocumentationProjectOwnership: TransferDocumentationProjectOwnershipPayload;
  triggerWebhookTest: TriggerWebhookTestPayload;
  unfollowTags: UnfollowTagsPayload;
  unsubscribeFromNewsletter: UnsubscribeFromNewsletterPayload;
  /** Updates a comment on a post. */
  updateComment: UpdateCommentPayload;
  /** Update docs custom page. */
  updateDocsCustomPage: DocsCustomPagePayload;
  updateDocumentationAppearance: UpdateDocumentationAppearancePayload;
  updateDocumentationGeneralSettings: UpdateDocumentationGeneralSettingsPayload;
  updateDocumentationGuide: UpdateDocumentationGuidePayload;
  updateDocumentationGuideVersion: UpdateDocumentationGuideVersionPayload;
  updateDocumentationIntegrations: UpdateDocumentationIntegrationsPayload;
  updateDocumentationLink: UpdateDocumentationLinkPayload;
  updateDocumentationNavbarColumn: UpdateDocumentationNavbarColumnPayload;
  updateDocumentationNavbarItemGuide: UpdateDocumentationNavbarItemGuidePayload;
  updateDocumentationNavbarItemLink: UpdateDocumentationNavbarItemLinkPayload;
  updateDocumentationNavbarItemPage: UpdateDocumentationNavbarItemPagePayload;
  updateDocumentationPageSettings: UpdateDocumentationPageSettingsPayload;
  /** Mutation to update a preview project based on an existing documentation project. This is used in GitHub PRs. */
  updateDocumentationPreviewProjectFromGitHub: UpdateDocumentationPreviewProjectFromGitHubPayload;
  /** Mutation to update the AI search prompts */
  updateDocumentationProjectAIPrompt: UpdateDocumentationProjectAiPromptPayload;
  updateDocumentationProjectSubdomain: UpdateDocumentationProjectSubdomainPayload;
  /** Mutation to update a section in a guide */
  updateDocumentationSection: UpdateDocumentationSectionPayload;
  /** Updates an existing draft. */
  updateDraft: UpdateDraftPayload;
  /** Updates the email notification preferences of the authenticated user. */
  updateEmailNotificationPreferences: UpdateEmailNotificationPreferencesPayload;
  /** Updates Headless CMS base URL of your publication. Headless CMS must be enabled for the publication. */
  updateHeadlessCMSBaseURL: UpdateHeadlessBaseUrlPayload;
  updatePost: UpdatePostPayload;
  /** Updates the appearance of a publication */
  updatePublicationAppearance: UpdatePublicationAppearancePayload;
  /** Updates the integration settings of a publication */
  updatePublicationIntegrations: UpdatePublicationIntegrationsPayload;
  updatePublicationNavbarItem: UpdatePublicationNavbarItemPayload;
  updatePublicationNotificationSettings: UpdatePublicationNotificationSettingsPayload;
  updatePublicationSEO: UpdatePublicationSeoPayload;
  updatePublicationSettings: UpdatePublicationSettingsPayload;
  /** Update hashnode subdomain of a publication. */
  updatePublicationSubdomain: UpdatePublicationSubdomainPayload;
  updateRedirectionRule: UpdateRedirectionRulePayload;
  /** Updates a reply */
  updateReply: UpdateReplyPayload;
  /** Updates a role based invite for a publication. */
  updateRoleBasedInvite: UpdateRoleBasedInvitePayload;
  /** Updates a series. */
  updateSeries: UpdateSeriesPayload;
  /** Update a static page. */
  updateStaticPage: UpdateStaticPagePayload;
  /** Updates the profile of the authenticated user. */
  updateUserProfile: UpdateUserProfilePayload;
  updateWebhook: UpdateWebhookPayload;
  /** Create a new widget for a publication */
  updateWidget: UpdateWidgetPayload;
  /** Upload an image by URL. */
  uploadImageByURL: UploadImagePayload;
  verifyDocumentationProjectCustomDomain: VerifyDocumentationProjectCustomDomainPayload;
  /** Verifies the email of the authenticated user. */
  verifyEmailChange: VerifyEmailChangePayload;
  /** Try to verify the custom domain of a publication if it has not been verified yet. */
  verifyPublicationCustomDomain: VerifyPublicationCustomDomainPayload;
};


export type MutationAcceptInviteToDocumentationProjectArgs = {
  input: AcceptInviteToDocumentationProjectInput;
};


export type MutationAcceptInviteToPublicationArgs = {
  input: AcceptInviteToPublicationInput;
};


export type MutationAcceptRoleBasedInviteArgs = {
  input: AcceptRoleBasedInviteInput;
};


export type MutationAcknowledgeEmailImportArgs = {
  input: AcknowledgeEmailImportInput;
};


export type MutationAddCommentArgs = {
  input: AddCommentInput;
};


export type MutationAddDocumentationProjectAiPromptArgs = {
  input: AddDocumentationProjectAiPromptInput;
};


export type MutationAddDocumentationProjectCustomDomainArgs = {
  input: AddDocumentationProjectCustomDomainInput;
};


export type MutationAddDocumentationProjectGitHubSyncIntegrationArgs = {
  input: AddDocumentationProjectGitHubSyncIntegrationInput;
};


export type MutationAddPostToSeriesArgs = {
  input: AddPostToSeriesInput;
};


export type MutationAddPublicationCustomDomainArgs = {
  input: AddPublicationCustomDomainInput;
};


export type MutationAddPublicationsToProPlanArgs = {
  input: AddPublicationsToProPlanInput;
};


export type MutationAddReplyArgs = {
  input: AddReplyInput;
};


export type MutationBuyProPlanCreditsArgs = {
  input: BuyProPlanCreditsInput;
};


export type MutationCancelPublicationsProPlanArgs = {
  input: CancelPublicationsProPlanInput;
};


export type MutationCancelScheduledDraftArgs = {
  input: CancelScheduledDraftInput;
};


export type MutationChangeDraftPublicationArgs = {
  input: ChangeDraftPublicationInput;
};


export type MutationChangePublicationMemberRoleArgs = {
  input: ChangePublicationMemberRoleInput;
};


export type MutationChangePublicationMemberVisibilityArgs = {
  input: ChangePublicationMemberVisibilityInput;
};


export type MutationConvertToTeamPublicationArgs = {
  input: ConvertToTeamPublicationInput;
};


export type MutationCreateDocsCustomPageArgs = {
  input: CreateDocsCustomPageInput;
};


export type MutationCreateDocumentationApiReferenceArgs = {
  input: CreateDocumentationApiReferenceInput;
};


export type MutationCreateDocumentationGuideArgs = {
  input: CreateDocumentationGuideInput;
};


export type MutationCreateDocumentationGuideVersionArgs = {
  input: CreateDocumentationGuideVersionInput;
};


export type MutationCreateDocumentationLinkArgs = {
  input: CreateDocumentationLinkInput;
};


export type MutationCreateDocumentationNavbarColumnArgs = {
  input: CreateDocumentationNavbarColumnInput;
};


export type MutationCreateDocumentationNavbarItemGuideArgs = {
  input: CreateDocumentationNavbarItemGuideInput;
};


export type MutationCreateDocumentationNavbarItemLinkArgs = {
  input: CreateDocumentationNavbarItemLinkInput;
};


export type MutationCreateDocumentationNavbarItemPageArgs = {
  input: CreateDocumentationNavbarItemPageInput;
};


export type MutationCreateDocumentationPageDraftArgs = {
  input: CreateDocumentationPageDraftInput;
};


export type MutationCreateDocumentationPreviewProjectArgs = {
  input: CreateDocumentationPreviewProjectInput;
};


export type MutationCreateDocumentationPreviewProjectFromGitHubArgs = {
  input: CreateDocumentationPreviewProjectFromGitHubInput;
};


export type MutationCreateDocumentationProjectArgs = {
  input: CreateDocumentationProjectInput;
};


export type MutationCreateDocumentationProjectBillingPortalUrlArgs = {
  input: CreateDocumentationProjectBillingPortalUrlInput;
};


export type MutationCreateDocumentationProjectCheckoutUrlArgs = {
  input: CreateDocumentationProjectCheckoutUrlInput;
};


export type MutationCreateDocumentationProjectPaymentLinkArgs = {
  input: CreateDocumentationProjectPaymentLinkInput;
};


export type MutationCreateDocumentationSectionArgs = {
  input: CreateDocumentationSectionInput;
};


export type MutationCreateDraftArgs = {
  input: CreateDraftInput;
};


export type MutationCreateDraftRevisionArgs = {
  input: CreateDraftRevisionInput;
};


export type MutationCreateImageUploadUrlArgs = {
  input: CreateImageUploadInput;
};


export type MutationCreateProSubscriptionCheckoutArgs = {
  input: CreateProSubscriptionCheckoutInput;
};


export type MutationCreatePublicationArgs = {
  input: CreatePublicationInput;
};


export type MutationCreatePublicationNavbarItemArgs = {
  input: CreatePublicationNavbarItemInput;
};


export type MutationCreateRedirectionRuleArgs = {
  input: CreateRedirectionRuleInput;
};


export type MutationCreateRoleBasedInviteForPublicationArgs = {
  input: CreateRoleBasedInviteForPublicationInput;
};


export type MutationCreateSeriesArgs = {
  input: CreateSeriesInput;
};


export type MutationCreateStaticPageArgs = {
  input: CreateStaticPageInput;
};


export type MutationCreateTeamPublicationArgs = {
  input: CreateTeamPublicationInput;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationCreateWidgetArgs = {
  input: CreateWidgetInput;
};


export type MutationDeleteDraftArgs = {
  input: DeleteDraftInput;
};


export type MutationDeletePublicationArgs = {
  input: DeletePublicationInput;
};


export type MutationDeleteRoleBasedInviteArgs = {
  input: DeleteRoleBasedInviteInput;
};


export type MutationDeleteWebhookArgs = {
  id: Scalars['ID'];
};


export type MutationDisableDocumentationProjectAiSearchArgs = {
  input: DisableDocumentationProjectAiSearchInput;
};


export type MutationDisableDocumentationProjectHeadlessCmsArgs = {
  input: DisableDocumentationProjectHeadlessCmsInput;
};


export type MutationDisableHeadlessCmsArgs = {
  input: DisableHeadlessCmsInput;
};


export type MutationEnableDocumentationProjectAiSearchArgs = {
  input: EnableDocumentationProjectAiSearchInput;
};


export type MutationEnableDocumentationProjectHeadlessCmsArgs = {
  input: EnableDocumentationProjectHeadlessCmsInput;
};


export type MutationEnableHeadlessCmsArgs = {
  input: EnableHeadlessCmsInput;
};


export type MutationFollowTagsArgs = {
  input: FollowTagsInput;
};


export type MutationGenerateDocumentationProjectPreviewAuthorizationTokenArgs = {
  input: GenerateDocumentationProjectPreviewAuthorizationTokenInput;
};


export type MutationGenerateDocumentationProjectPreviewTokenArgs = {
  input: GenerateDocumentationProjectPreviewTokenInput;
};


export type MutationImportSubscribersArgs = {
  input: ImportSubscribersInput;
};


export type MutationInviteDocumentationProjectAdminArgs = {
  input: InviteDocumentationProjectAdminInput;
};


export type MutationInviteUsersToPublicationArgs = {
  input: InviteUsersToPublicationInput;
};


export type MutationLeaveTeamPublicationArgs = {
  input: LeaveTeamPublicationInput;
};


export type MutationLikeCommentArgs = {
  input: LikeCommentInput;
};


export type MutationLikePostArgs = {
  input: LikePostInput;
};


export type MutationLikeReplyArgs = {
  input: LikeReplyInput;
};


export type MutationMapDocumentationProjectCustomDomainWwwRedirectArgs = {
  input: MapDocumentationProjectCustomDomainWwwRedirectInput;
};


export type MutationMapPublicationCustomDomainWwwRedirectArgs = {
  input: MapPublicationCustomDomainWwwRedirectInput;
};


export type MutationMarkDefaultDocumentationVersionArgs = {
  input: MarkDefaultDocumentationVersionInput;
};


export type MutationMoveDocumentationFooterNavbarColumnArgs = {
  input: MoveDocumentationFooterNavbarColumnInput;
};


export type MutationMoveDocumentationFooterNavbarItemArgs = {
  input: MoveDocumentationFooterNavbarItemInput;
};


export type MutationMoveDocumentationHeaderNavbarItemArgs = {
  input: MoveDocumentationHeaderNavbarItemInput;
};


export type MutationMoveDocumentationSidebarItemArgs = {
  input: MoveDocumentationSidebarItemInput;
};


export type MutationPublishDocumentationApiReferenceArgs = {
  input: PublishDocumentationApiReferenceInput;
};


export type MutationPublishDocumentationGuideArgs = {
  input: PublishDocumentationGuideInput;
};


export type MutationPublishDocumentationGuideVersionArgs = {
  input: PublishDocumentationGuideVersionInput;
};


export type MutationPublishDocumentationPageDraftArgs = {
  input: PublishDocumentationPageDraftInput;
};


export type MutationPublishDocumentationProjectFromGitHubArgs = {
  input: PublishDocumentationProjectFromGitHubInput;
};


export type MutationPublishDraftArgs = {
  input: PublishDraftInput;
};


export type MutationPublishPostArgs = {
  input: PublishPostInput;
};


export type MutationPurgePublicationCacheArgs = {
  input: PurgePublicationCacheInput;
};


export type MutationReCreateDocumentationPreviewProjectArgs = {
  input: ReCreateDocumentationPreviewProjectInput;
};


export type MutationRecommendPublicationsArgs = {
  input: RecommendPublicationsInput;
};


export type MutationReinviteDocumentationProjectAdminArgs = {
  input: ReinviteDocumentationProjectAdminInput;
};


export type MutationReinviteUserToPublicationArgs = {
  input: ReinviteUserToPublicationInput;
};


export type MutationRejectDraftSubmissionArgs = {
  input: RejectDraftSubmissionInput;
};


export type MutationRemoveCommentArgs = {
  input: RemoveCommentInput;
};


export type MutationRemoveDocsCustomPageArgs = {
  input: RemoveDocsCustomPageInput;
};


export type MutationRemoveDocumentationFooterNavbarColumnArgs = {
  input: RemoveDocumentationFooterNavbarColumnInput;
};


export type MutationRemoveDocumentationGuideArgs = {
  input: RemoveDocumentationGuideInput;
};


export type MutationRemoveDocumentationNavbarItemArgs = {
  input: RemoveDocumentationNavbarItemInput;
};


export type MutationRemoveDocumentationPreviewProjectArgs = {
  input: RemoveDocumentationPreviewProjectInput;
};


export type MutationRemoveDocumentationProjectArgs = {
  input: RemoveDocumentationProjectInput;
};


export type MutationRemoveDocumentationProjectAiPromptArgs = {
  input: RemoveDocumentationProjectAiPromptInput;
};


export type MutationRemoveDocumentationProjectCustomDomainArgs = {
  input: RemoveDocumentationProjectCustomDomainInput;
};


export type MutationRemoveDocumentationProjectGitHubSyncIntegrationArgs = {
  input: RemoveDocumentationProjectGitHubSyncIntegrationInput;
};


export type MutationRemoveDocumentationProjectMemberArgs = {
  input: RemoveDocumentationProjectMemberInput;
};


export type MutationRemoveDocumentationSidebarItemArgs = {
  input: RemoveDocumentationSidebarItemInput;
};


export type MutationRemoveDocumentationVersionArgs = {
  input: RemoveDocumentationVersionInput;
};


export type MutationRemoveNewsletterSubscriberArgs = {
  input: RemoveNewsletterSubscriberInput;
};


export type MutationRemovePostArgs = {
  input: RemovePostInput;
};


export type MutationRemovePublicationCustomDomainArgs = {
  input: RemovePublicationCustomDomainInput;
};


export type MutationRemovePublicationMemberArgs = {
  input: RemovePublicationMemberInput;
};


export type MutationRemovePublicationNavbarItemArgs = {
  input: RemovePublicationNavbarItemInput;
};


export type MutationRemoveRecommendationArgs = {
  input: RemoveRecommendationInput;
};


export type MutationRemoveRedirectionRuleArgs = {
  input: RemoveRedirectionRuleInput;
};


export type MutationRemoveReplyArgs = {
  input: RemoveReplyInput;
};


export type MutationRemoveSeriesArgs = {
  input: RemoveSeriesInput;
};


export type MutationRemoveStaticPageArgs = {
  input: RemoveStaticPageInput;
};


export type MutationRemoveWidgetArgs = {
  input: RemoveWidgetInput;
};


export type MutationRenameDocumentationGuideArgs = {
  input: RenameDocumentationGuideItemInput;
};


export type MutationRenameDocumentationSidebarItemArgs = {
  input: RenameDocumentationSidebarItemInput;
};


export type MutationRescheduleDraftArgs = {
  input: RescheduleDraftInput;
};


export type MutationResendWebhookRequestArgs = {
  input: ResendWebhookRequestInput;
};


export type MutationRestorePostArgs = {
  input: RestorePostInput;
};


export type MutationRetryDocumentationProjectCustomDomainVerificationArgs = {
  input: RetryDocumentationProjectCustomDomainVerificationInput;
};


export type MutationRetryPublicationCustomDomainVerificationArgs = {
  input: RetryPublicationCustomDomainVerificationInput;
};


export type MutationRevokeInviteToDocumentationProjectArgs = {
  input: RevokeInviteToDocumentationProjectInput;
};


export type MutationRevokePersonalAccessTokenArgs = {
  input: RevokePersonalAccessTokenInput;
};


export type MutationRevokeUserInviteToPublicationArgs = {
  input: RevokeUserInviteToPublicationInput;
};


export type MutationSaveDocumentationPageDraftContentArgs = {
  input: SaveDocumentationPageDraftContentInput;
};


export type MutationScheduleDraftArgs = {
  input: ScheduleDraftInput;
};


export type MutationSetDocumentationSidebarItemVisibilityArgs = {
  input: SetDocumentationSidebarItemVisibilityInput;
};


export type MutationSignUpUserArgs = {
  input: SignUpUserInput;
};


export type MutationSubmitDraftForReviewArgs = {
  input: SubmitDraftForReviewInput;
};


export type MutationSubscribeConsentedUserToNewsletterArgs = {
  input: SubscribeConsentedUserToNewsletterInput;
};


export type MutationSubscribeToNewsletterArgs = {
  input: SubscribeToNewsletterInput;
};


export type MutationSyncDocumentationProjectApiDefinitionArgs = {
  input: SyncDocumentationProjectApiDefinitionInput;
};


export type MutationToggleAllowContributorEditsArgs = {
  input: ToggleAllowContributorEditsInput;
};


export type MutationToggleBlogBetaFeatureArgs = {
  input: ToggleBlogBetaFeatureInput;
};


export type MutationToggleFollowUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};


export type MutationToggleGptBotCrawlingArgs = {
  input: ToggleGptBotCrawlingInput;
};


export type MutationToggleNewsletterSubscriptionArgs = {
  publicationId: Scalars['ObjectId'];
};


export type MutationTogglePageVisibilityArgs = {
  input: TogglePageVisibilityInput;
};


export type MutationToggleRoleBasedInviteLinksArgs = {
  publicationId: Scalars['ID'];
};


export type MutationToggleTextSelectionSharerArgs = {
  input: ToggleTextSelectionSharerInput;
};


export type MutationToggleUserBetaFeatureArgs = {
  input: ToggleUserBetaFeatureInput;
};


export type MutationTransferDocumentationProjectOwnershipArgs = {
  input: TransferDocumentationProjectOwnershipInput;
};


export type MutationTriggerWebhookTestArgs = {
  input: TriggerWebhookTestInput;
};


export type MutationUnfollowTagsArgs = {
  input: UnfollowTagsInput;
};


export type MutationUnsubscribeFromNewsletterArgs = {
  input: UnsubscribeFromNewsletterInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateDocsCustomPageArgs = {
  input: UpdateDocsCustomPageInput;
};


export type MutationUpdateDocumentationAppearanceArgs = {
  input: UpdateDocumentationAppearanceInput;
};


export type MutationUpdateDocumentationGeneralSettingsArgs = {
  input: UpdateDocumentationGeneralSettingsInput;
};


export type MutationUpdateDocumentationGuideArgs = {
  input: UpdateDocumentationGuideInput;
};


export type MutationUpdateDocumentationGuideVersionArgs = {
  input: UpdateDocumentationGuideVersionInput;
};


export type MutationUpdateDocumentationIntegrationsArgs = {
  input: UpdateDocumentationIntegrationsInput;
};


export type MutationUpdateDocumentationLinkArgs = {
  input: UpdateDocumentationLinkInput;
};


export type MutationUpdateDocumentationNavbarColumnArgs = {
  input: UpdateDocumentationNavbarColumnInput;
};


export type MutationUpdateDocumentationNavbarItemGuideArgs = {
  input: UpdateDocumentationNavbarItemGuideInput;
};


export type MutationUpdateDocumentationNavbarItemLinkArgs = {
  input: UpdateDocumentationNavbarItemLinkInput;
};


export type MutationUpdateDocumentationNavbarItemPageArgs = {
  input: UpdateDocumentationNavbarItemPageInput;
};


export type MutationUpdateDocumentationPageSettingsArgs = {
  input: UpdateDocumentationPageSettingsInput;
};


export type MutationUpdateDocumentationPreviewProjectFromGitHubArgs = {
  input: UpdateDocumentationPreviewProjectFromGitHubInput;
};


export type MutationUpdateDocumentationProjectAiPromptArgs = {
  input: UpdateDocumentationProjectAiPromptInput;
};


export type MutationUpdateDocumentationProjectSubdomainArgs = {
  input: UpdateDocumentationProjectSubdomainInput;
};


export type MutationUpdateDocumentationSectionArgs = {
  input: UpdateDocumentationSectionInput;
};


export type MutationUpdateDraftArgs = {
  input: UpdateDraftInput;
};


export type MutationUpdateEmailNotificationPreferencesArgs = {
  input: UpdateEmailNotificationPreferencesInput;
};


export type MutationUpdateHeadlessCmsBaseUrlArgs = {
  input: UpdateHeadlessBaseUrlInput;
};


export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
};


export type MutationUpdatePublicationAppearanceArgs = {
  input: UpdatePublicationAppearanceInput;
};


export type MutationUpdatePublicationIntegrationsArgs = {
  input: UpdatePublicationIntegrationsInput;
};


export type MutationUpdatePublicationNavbarItemArgs = {
  input: UpdatePublicationNavbarItemInput;
};


export type MutationUpdatePublicationNotificationSettingsArgs = {
  input: UpdatePublicationNotificationSettingsInput;
};


export type MutationUpdatePublicationSeoArgs = {
  input: UpdatePublicationSeoInput;
};


export type MutationUpdatePublicationSettingsArgs = {
  input: UpdatePublicationSettingsInput;
};


export type MutationUpdatePublicationSubdomainArgs = {
  input: UpdatePublicationSubdomainInput;
};


export type MutationUpdateRedirectionRuleArgs = {
  input: UpdateRedirectionRuleInput;
};


export type MutationUpdateReplyArgs = {
  input: UpdateReplyInput;
};


export type MutationUpdateRoleBasedInviteArgs = {
  input: UpdateRoleBasedInviteInput;
};


export type MutationUpdateSeriesArgs = {
  input: UpdateSeriesInput;
};


export type MutationUpdateStaticPageArgs = {
  input: UpdateStaticPageInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type MutationUpdateWidgetArgs = {
  input: UpdateWidgetInput;
};


export type MutationUploadImageByUrlArgs = {
  input: UploadImageInput;
};


export type MutationVerifyDocumentationProjectCustomDomainArgs = {
  input: VerifyDocumentationProjectCustomDomainInput;
};


export type MutationVerifyEmailChangeArgs = {
  input: VerifyEmailChangeInput;
};


export type MutationVerifyPublicationCustomDomainArgs = {
  input: VerifyPublicationCustomDomainInput;
};

/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUser = IUser & Node & {
  __typename?: 'MyUser';
  /**
   * Whether or not the user is an ambassador.
   * @deprecated Ambassadors program no longer active. Will be removed after 02/01/2024
   */
  ambassador: Scalars['Boolean'];
  /** The availability of the user based on tech stack and interests. Shown on the "I am available for" section in user's profile. */
  availableFor?: Maybe<Scalars['String']>;
  /** Returns a list of badges that the user has earned. Shown on blogs /badges page. Example - https://iamshadmirza.com/badges */
  badges: Array<Badge>;
  /**
   * A list of beta features that the user has access to. Only available to the authenticated user.
   * @deprecated Beta features are no longer supported. Will be removed after 15/12/2024
   */
  betaFeatures: Array<BetaFeature>;
  /** The bio of the user. Visible in about me section of the user's profile. */
  bio?: Maybe<Content>;
  /** Returns if the user can update to the provided publication. */
  canUpdatePublication: Scalars['Boolean'];
  /** The date the user joined Hashnode. */
  dateJoined?: Maybe<Scalars['DateTime']>;
  /** Whether or not the user is deactivated. */
  deactivated: Scalars['Boolean'];
  /** Documentation Projects associated with the user. */
  documentationProjects: UserDocumentationProjectConnection;
  drafts: UserDraftConnection;
  /** Email address of the user. Only available to the authenticated user. */
  email: Scalars['String'];
  /** The email notification preferences of the user. */
  emailNotificationPreferences: EmailNotificationPreferences;
  /** The users who are following this user */
  followers: UserConnection;
  /** The number of users that follow the requested user. Visible in the user's profile. */
  followersCount: Scalars['Int'];
  /** The number of users that this user is following. Visible in the user's profile. */
  followingsCount: Scalars['Int'];
  /** The users which this user is following */
  follows: UserConnection;
  /** Information about the user's free trial. User can try ai features for 3 days before subscribing. Checkout https://hashnode.com/ai for more information. */
  freeTrial: FreeTrialInfo;
  /** Returns if the user has access to the provided documentation project. */
  hasDocumentationProjectAccess: Scalars['Boolean'];
  /** The ID of the user. It can be used to identify the user. */
  id: Scalars['ID'];
  /**
   * Whether or not the username of the user has been changed.
   * A user can change their username only once.
   */
  isUsernameChanged?: Maybe<Scalars['Boolean']>;
  /** The location of the user. */
  location?: Maybe<Scalars['String']>;
  /** The name of the user. */
  name: Scalars['String'];
  /** Returns the list of personal access tokens created by user. */
  personalAccessTokens: UserPersonalAccessTokenConnection;
  /** Returns the list of posts the user has published. */
  posts: UserPostConnection;
  /** Information about your pro plan. Checkout https://hashnode.com/pro for more information. */
  pro?: Maybe<UserProInfo>;
  /** The URL to the profile picture of the user. */
  profilePicture?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  /** Publications associated with the user. Includes personal and team publications. */
  publications: UserPublicationsConnection;
  /** Returns the user's role if any. */
  role: UserRole;
  /** The social media links of the user. Shown on the user's profile. */
  socialMediaLinks?: Maybe<SocialMediaLinks>;
  /** The tagline of the user. Shown on the user's profile below the name. */
  tagline?: Maybe<Scalars['String']>;
  /** Returns a list of tags that the user follows. */
  tagsFollowing: Array<Tag>;
  /** Returns list of tags from user's expertise. Shown on the user's profile. */
  techStack: UserTagsConnection;
  /** Hashnode users are subscribed to a newsletter by default. This field can be used to unsubscribe from the newsletter. Only available to the authenticated user. */
  unsubscribeCode?: Maybe<Scalars['String']>;
  /**
   * Unverified email address of the user. Only available to the authenticated user.
   * This is set when the user has tried updating their email address but it is not verified yet.
   */
  unverifiedEmail?: Maybe<Scalars['String']>;
  /** The username of the user. It is unique and tied with user's profile URL. Example - https://hashnode.com/@username */
  username: Scalars['String'];
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserCanUpdatePublicationArgs = {
  publicationId: Scalars['ID'];
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserDocumentationProjectsArgs = {
  filter?: InputMaybe<UserDocumentationProjectConnectionFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortBy?: InputMaybe<UserDocumentationProjectsSort>;
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserDraftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserFollowersArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserFollowsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserHasDocumentationProjectAccessArgs = {
  projectId: Scalars['ID'];
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserPersonalAccessTokensArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserPostsArgs = {
  filter?: InputMaybe<UserPostConnectionFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortBy?: InputMaybe<UserPostsSort>;
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserPublicationsConnectionFilter>;
  first: Scalars['Int'];
  sortBy?: InputMaybe<UserPublicationsSort>;
};


/**
 * Basic information about the authenticated user.
 * User must be authenticated to use this type.
 */
export type MyUserTechStackArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type NewDraftSubmissionNotification = Notification & {
  __typename?: 'NewDraftSubmissionNotification';
  /** A flag indicating if the notification for new draft submission to a team publication is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

/**
 * Contains the flag indicating if the newsletter feature is enabled or not.
 * User can enable or disable the newsletter feature from the publication settings.
 * Shows a newsletter prompt on blog if enabled.
 */
export type NewsletterFeature = Feature & {
  __typename?: 'NewsletterFeature';
  frequency?: Maybe<NewsletterFrequency>;
  /** A flag indicating if the newsletter feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

export enum NewsletterFrequency {
  Asap = 'asap',
  Weekly = 'weekly'
}

export type NewsletterHistoryConnection = PageConnection & {
  __typename?: 'NewsletterHistoryConnection';
  /** A list of newsletter history records */
  nodes: Array<NewsletterRecord>;
  /** Information for page based pagination in Newsletter History connection. */
  pageInfo: OffsetPageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

export type NewsletterRecord = Node & {
  __typename?: 'NewsletterRecord';
  /** The number of subscribers the newsletter was clicked by. */
  clickCount: Scalars['Int'];
  /** Delivery ID of the sent newsletter */
  id: Scalars['ID'];
  /** The number of subscribers the newsletter was opened by. */
  openCount: Scalars['Int'];
  /** Associated post it was sent with */
  post?: Maybe<Post>;
  postId: Scalars['ObjectId'];
  /** The date the newsletter was sent. */
  sentAt: Scalars['DateTime'];
  /** The number of subscribers the newsletter was sent to. */
  sentCount: Scalars['Int'];
};

export enum NewsletterSubscribeStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export type NewsletterSubscriber = Node & {
  __typename?: 'NewsletterSubscriber';
  /**
   * The date the subscriber was added.
   * @deprecated Use `subscribedAt` instead. Will be removed after 12/4/2024
   */
  createdAt: Scalars['DateTime'];
  /** The email of the subscriber. */
  email: Scalars['String'];
  id: Scalars['ID'];
  /** The status of the subscriber. */
  status: NewsletterSubscribeStatus;
  subscribedAt: Scalars['DateTime'];
};

/** The payload for the newsletter subscriber import. */
export type NewsletterSubscriberPayload = {
  __typename?: 'NewsletterSubscriberPayload';
  /** Information about the newsletter subscriber imports */
  status: EmailImportStatus;
};

export type NewsletterSubscribersConnection = PageConnection & {
  __typename?: 'NewsletterSubscribersConnection';
  /** A list of newsletter subscribers */
  nodes: Array<NewsletterSubscriber>;
  /** Information for page based pagination in Newsletter Subscribers connection. */
  pageInfo: OffsetPageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

export enum NewsletterUnsubscribeStatus {
  Unsubscribed = 'UNSUBSCRIBED'
}

/** Node is a common interface for all types example User, Post, Comment, etc. */
export type Node = {
  /** The ID of the node. */
  id: Scalars['ID'];
};

/** Common fields that describe a notification. */
export type Notification = {
  /** Whether the notification is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

/** Contains information to help in pagination for page based pagination. */
export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  /** Indicates if there are more pages. */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** Indicates if there are previous pages */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  /**
   * The page after the current page.
   * Use it to build page navigation
   */
  nextPage?: Maybe<Scalars['Int']>;
  /**
   * The page before the current page.
   * Use it to build page navigation
   */
  previousPage?: Maybe<Scalars['Int']>;
};

/** Information to help in open graph related meta tags. */
export type OpenGraphMetaData = {
  __typename?: 'OpenGraphMetaData';
  /** The image used in og:image tag for SEO purposes. */
  image?: Maybe<Scalars['String']>;
};

/**
 * A Connection for page based pagination to get a list of items.
 * Returns a list of nodes which contains the items.
 * This is a common interface for all page connections.
 */
export type PageConnection = {
  /** A list of edges of items connection. */
  nodes: Array<Node>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
};

/**
 * An edge that contains a node and is used in page based pagination.
 * This is a common interface for all edges in page based pagination.
 */
export type PageEdge = {
  /** A node in the connection. */
  node: Node;
};

/** Contains information to help in pagination. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /**
   * The cursor of the last item in the current page.
   * Use it as the after input to query the next page.
   */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates if there are more pages. */
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

/**
 * Contains the preferences publication's autogenerated pages.
 * Used to enable or disable pages like badge, newsletter and members.
 */
export type PagesPreferences = {
  __typename?: 'PagesPreferences';
  /** A flag indicating if the publication's badge page is enabled. */
  badges?: Maybe<Scalars['Boolean']>;
  /** A flag indicating if the publication's member page is enabled. */
  members?: Maybe<Scalars['Boolean']>;
  /** A flag indicating if the publication's newsletter page is enabled. */
  newsletter?: Maybe<Scalars['Boolean']>;
};

/** Specified payment information. */
export type Payment = {
  __typename?: 'Payment';
  /** The date the payment was or will be made. */
  date: Scalars['Date'];
  /** The total amount of the payment including taxes. */
  total: Money;
};

/** Contains the pending invite information. */
export type PendingInvite = Node & {
  __typename?: 'PendingInvite';
  /** The email of the user that was invited. */
  email?: Maybe<Scalars['String']>;
  /** The ID of the pending invite. */
  id: Scalars['ID'];
  /** The role assigned to the user in the publication. */
  role: UserPublicationRole;
  /** Invited Hashnode user, returns null if the user is not a Hashnode user. */
  user?: Maybe<User>;
  /** The userId of the Hashnode user who was invited. */
  userId?: Maybe<Scalars['ObjectId']>;
};

export type PendingInviteConnection = PageConnection & {
  __typename?: 'PendingInviteConnection';
  /** A list of invites */
  nodes: Array<PendingInvite>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
  /** The total number of invites. */
  totalDocuments: Scalars['Int'];
};

/** The period for which to retrieve popular tags. */
export enum Period {
  /** Included all the record since the beginning. */
  AllTime = 'AllTime',
  /** The last 30 days. */
  Month = 'Month',
  /** The last 7 days. */
  Week = 'Week'
}

/** Personal access token for the user. */
export type PersonalAccessToken = Node & {
  __typename?: 'PersonalAccessToken';
  /** The date the token was created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the token. */
  id: Scalars['ID'];
  /** The token value. */
  value: Scalars['String'];
};

/** Contains basic information about the tag returned by popularTags query. */
export type PopularTag = ITag & Node & {
  __typename?: 'PopularTag';
  /** Total number of users following this tag. */
  followersCount: Scalars['Int'];
  /** The ID of the tag. */
  id: Scalars['ID'];
  /** Information about the tag. Contains markdown html and text version of the tag's info. */
  info?: Maybe<Content>;
  /** The logo of the tag. Shown in tag page. */
  logo?: Maybe<Scalars['String']>;
  /** The name of the tag. Shown in tag page. */
  name: Scalars['String'];
  /** Alltime usage count of this tag in posts. */
  postsCount: Scalars['Int'];
  /** The number of posts published in the given period that use this tag. */
  postsCountInPeriod: Scalars['Int'];
  /** The slug of the tag. Used to access tags feed.  Example https://hashnode.com/n/graphql */
  slug: Scalars['String'];
  /** The tagline of the tag. */
  tagline?: Maybe<Scalars['String']>;
};

/** Contains a tag and a cursor for pagination. */
export type PopularTagEdge = Edge & {
  __typename?: 'PopularTagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The node holding the Tag information */
  node: PopularTag;
};

/**
 * Connection for tags popular in given time frame. Contains a list of edges containing nodes.
 * Each node is a tag.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type PopularTagsConnection = Connection & {
  __typename?: 'PopularTagsConnection';
  /** A list of edges containing Tag information */
  edges: Array<PopularTagEdge>;
  /** Information for pagination in popular Tags connection. */
  pageInfo: PageInfo;
};

export type PopularTagsFilter = {
  /** The period for which to retrieve popular tags. Defaults to Week. */
  period?: InputMaybe<Period>;
  /**
   * Determinate how to sort the results. Defaults to posts
   * This will only be applied to Period = AllTime
   */
  sortBy?: InputMaybe<PopularTagsSort>;
};

export type PopularTagsFilterV2 = {
  /** The period for which to retrieve popular tags. Defaults to Week. */
  period?: InputMaybe<Period>;
  /**
   * Determinate how to sort the results. Defaults to posts
   * This will only be applied to Period = AllTime
   */
  sortBy?: InputMaybe<PopularTagsSort>;
};

/** The field by which to sort the popular tags. */
export enum PopularTagsSort {
  /** Sorts by followers, used in Trending tag feed. */
  Followers = 'followers',
  /** Sorts by popularity, used in Hot tag feed. */
  Posts = 'posts'
}

/**
 * Contains basic information about the post.
 * A post is a published article on Hashnode.
 */
export type Post = Node & {
  __typename?: 'Post';
  /**
   * Returns male and female audio url of the post. Available in case the Audioblog is enabled.
   * @deprecated Audio Blogs are not supported anymore. This field will be removed 18/04/23
   */
  audioUrls?: Maybe<AudioUrls>;
  /** Returns the user details of the author of the post. */
  author: User;
  /**
   * Flag to indicate if the post is bookmarked by the requesting user.
   *
   * Returns `false` if the user is not authenticated.
   */
  bookmarked: Scalars['Boolean'];
  /** Brief is a short description of the post extracted from the content of the post. It's 250 characters long sanitized string. */
  brief: Scalars['String'];
  /** Canonical URL set by author in case of republished posts. */
  canonicalUrl?: Maybe<Scalars['String']>;
  coAuthorIds?: Maybe<Array<Scalars['ObjectId']>>;
  /**
   * Returns the user details of the co-authors of the post.
   * Hashnode users can add up to 4 co-authors as collaborators to their posts.
   * This functionality is limited to teams publication.
   */
  coAuthors?: Maybe<Array<User>>;
  /** List of users who have commented on the post. */
  commenters: PostCommenterConnection;
  commentersLookup?: Maybe<Array<Scalars['ObjectId']>>;
  /** A list of comments on the post. */
  comments: PostCommentConnection;
  /** Content of the post. Contains HTML and Markdown version of the post content. */
  content: Content;
  /**
   * A list of contributors of the post. Contributors are users who have commented or replied to the post.
   * @deprecated Will be removed on 10th Oct 2023. Use `commenters` instead.
   */
  contributors: Array<User>;
  /** The cover image preference of the post. Contains cover image URL and other details. */
  coverImage?: Maybe<PostCoverImage>;
  /** Unique ID to identify post, used internally by hashnode. */
  cuid?: Maybe<Scalars['String']>;
  /** Flag to indicate if the post is featured on Hashnode feed. */
  featured: Scalars['Boolean'];
  /** The date and time the post was featured. Used along with featured flag to determine if the post is featured. */
  featuredAt?: Maybe<Scalars['DateTime']>;
  /** Post feature-related fields. */
  features: PostFeatures;
  /** A flag to indicate if the post contains LaTeX. Latex is used to write mathematical equations. */
  hasLatexInPost: Scalars['Boolean'];
  /** The ID of the post. Used to uniquely identify the post. */
  id: Scalars['ID'];
  isAskMeAnything: Scalars['Boolean'];
  /** Whether or not the post has automatically been published via RSS feed. */
  isAutoPublishedFromRSS: Scalars['Boolean'];
  /**
   * Whether or not the authenticated user is following this post.
   *
   * Returns `null` if the user is not authenticated.
   */
  isFollowed?: Maybe<Scalars['Boolean']>;
  isShadowBanned: Scalars['Boolean'];
  /** A list of users who liked the post. */
  likedBy: PostLikerConnection;
  /** OG meta-data of the post. Contains image url used in open graph meta tags. */
  ogMetaData?: Maybe<OpenGraphMetaData>;
  /** Preference settings for the post. Contains information about if the post is pinned to blog, comments are disabled, etc. */
  preferences: PostPreferences;
  /**
   * The previous slugs of the post. Only present if the slug has been changed.
   *
   * This could be used to create redirects for all posts from all previous slugs to the current slug.
   *
   * The latest slug is always the first element in the array.
   */
  previousSlugs: Array<Scalars['String']>;
  /** The publication the post belongs to. */
  publication?: Maybe<Publication>;
  /** The date and time the post was published. */
  publishedAt: Scalars['DateTime'];
  /** The number of hearts on the post. Shows how many users liked the post. */
  reactionCount: Scalars['Int'];
  /** The estimated time to read the post in minutes. */
  readTimeInMinutes: Scalars['Int'];
  /** The number of replies on the post. */
  replyCount: Scalars['Int'];
  /** The number of comments on the post. */
  responseCount: Scalars['Int'];
  /** SEO information of the post. Contains title and description used in meta tags. */
  seo?: Maybe<Seo>;
  /** Information of the series the post belongs to. */
  series?: Maybe<Series>;
  seriesId?: Maybe<Scalars['ObjectId']>;
  /** The slug of the post. Used as address of the post on blog. Example - https://johndoe.com/my-post-slug */
  slug: Scalars['String'];
  /** Boolean flag to identify whether or not the post is sourced from GitHub. */
  sourcedFromGithub: Scalars['Boolean'];
  /** The subtitle of the post. Subtitle is a short description of the post which is also used in SEO if meta tags are not provided. */
  subtitle?: Maybe<Scalars['String']>;
  /** Returns list of tags added to the post. Contains tag id, name, slug, etc. */
  tags?: Maybe<Array<Tag>>;
  /** The title of the post. */
  title: Scalars['String'];
  /** The date and time the post was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Complete URL of the post including the domain name. Example - https://johndoe.com/my-post-slug */
  url: Scalars['String'];
  /** The number of views on the post. Can be used to show the popularity of the post. */
  views: Scalars['Int'];
};


/**
 * Contains basic information about the post.
 * A post is a published article on Hashnode.
 */
export type PostCommentersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  sortBy?: InputMaybe<PostCommenterSortBy>;
};


/**
 * Contains basic information about the post.
 * A post is a published article on Hashnode.
 */
export type PostCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  sortBy?: InputMaybe<PostCommentSortBy>;
};


/**
 * Contains basic information about the post.
 * A post is a published article on Hashnode.
 */
export type PostLikedByArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PostLikerFilter>;
  first: Scalars['Int'];
};

/** The author type of a post from a user's perspective */
export enum PostAuthorType {
  /** The user has authored the post. */
  Author = 'AUTHOR',
  /** The user is a co-author of post. */
  CoAuthor = 'CO_AUTHOR'
}

export type PostBadge = Node & {
  __typename?: 'PostBadge';
  /** Unique identifier. */
  id: Scalars['ID'];
  /** The type of the badge. */
  type: PostBadgeType;
};

export enum PostBadgeType {
  FeaturedDailyDotDev = 'FEATURED_DAILY_DOT_DEV',
  FeaturedHashnode = 'FEATURED_HASHNODE'
}

export type PostBadgesFeature = Feature & {
  __typename?: 'PostBadgesFeature';
  /** Whether or not the user has chosen to show badges on the post. */
  isEnabled: Scalars['Boolean'];
  items: Array<PostBadge>;
};

/**
 * Connection for comments. Contains a list of edges containing nodes.
 * Each node holds a comment.
 * Page info contains information about pagination like hasNextPage and endCursor.
 * Total documents contains the total number of comments.
 */
export type PostCommentConnection = Connection & {
  __typename?: 'PostCommentConnection';
  /** A list of edges containing comments as nodes. */
  edges: Array<PostCommentEdge>;
  /** Information about pagination in a connection. */
  pageInfo: PageInfo;
  /** Total number of nodes available i.e. number of comments. */
  totalDocuments: Scalars['Int'];
};

/** A comment on the post. Contains information about the content of the comment, user who commented, etc. */
export type PostCommentEdge = Edge & {
  __typename?: 'PostCommentEdge';
  /** The cursor for this node used for pagination. */
  cursor: Scalars['String'];
  /** The comment on the post. */
  node: Comment;
};

/** Sorting options for comments. Used to sort comments by top or recent. */
export enum PostCommentSortBy {
  /** Sorts comments by recency. */
  Recent = 'RECENT',
  /** Sorts comments by popularity. */
  Top = 'TOP'
}

/**
 * Connection for commenters (users). Contains a list of edges containing nodes.
 * Each node holds commenter.
 * Page info contains information about pagination like hasNextPage and endCursor.
 * Total documents contains the total number of commenters.
 */
export type PostCommenterConnection = Connection & {
  __typename?: 'PostCommenterConnection';
  /** A list of edges containing commenters as nodes. */
  edges: Array<PostCommenterEdge>;
  /** Information about pagination in a connection. */
  pageInfo: PageInfo;
  /** Total number of nodes available i.e. number of commenters. */
  totalDocuments: Scalars['Int'];
};

/** A commenter on the post. Contains information about the user who commented. */
export type PostCommenterEdge = Edge & {
  __typename?: 'PostCommenterEdge';
  /** The cursor for this node used for pagination. */
  cursor: Scalars['String'];
  /** The commenter on the post. */
  node: User;
};

/** Sorting options for commenters. Used to sort commenters by popularity or recency. */
export enum PostCommenterSortBy {
  /** Sorts commenters by popularity. */
  Popular = 'POPULAR',
  /** Sorts commenters by recency. */
  Recent = 'RECENT'
}

/** Contains information about the cover image of the post. */
export type PostCoverImage = {
  __typename?: 'PostCoverImage';
  /** Provides attribution information for the cover image, if available. */
  attribution?: Maybe<Scalars['String']>;
  /** True if the image attribution should be hidden. */
  isAttributionHidden: Scalars['Boolean'];
  /** Indicates whether the cover image is in portrait orientation. */
  isPortrait: Scalars['Boolean'];
  /** The name of the photographer who captured the cover image. */
  photographer?: Maybe<Scalars['String']>;
  /** The URL of the cover image. */
  url: Scalars['String'];
};

/** Contains a post and a cursor for pagination. */
export type PostEdge = Edge & {
  __typename?: 'PostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The node holding the Post information */
  node: Post;
};

export type PostFeatures = {
  __typename?: 'PostFeatures';
  badges: PostBadgesFeature;
  tableOfContents: TableOfContentsFeature;
};

/**
 * Connection for users who liked the post. Contains a list of edges containing nodes.
 * Each node is a user who liked the post.
 * Page info contains information about pagination like hasNextPage and endCursor.
 * Total documents contains the total number of users who liked the post.
 */
export type PostLikerConnection = Connection & {
  __typename?: 'PostLikerConnection';
  /** A list of edges containing users as nodes */
  edges: Array<PostLikerEdge>;
  /** Information about pagination in a connection. */
  pageInfo: PageInfo;
  /** Total number of nodes available i.e. number of users who liked the post. */
  totalDocuments: Scalars['Int'];
};

/** A user who liked the post. Contains information about the user and number of reactions added by the user. */
export type PostLikerEdge = Edge & {
  __typename?: 'PostLikerEdge';
  /** The cursor for this node used for pagination. */
  cursor: Scalars['String'];
  /** The user who liked the post. */
  node: User;
  /** The number of reaction added by the user. */
  reactionCount: Scalars['Int'];
};

export type PostLikerFilter = {
  /** Only return likes from users with the given user IDs. */
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Contains Post preferences. Used to determine if the post is pinned to blog, comments are disabled, or cover image is sticked to bottom. */
export type PostPreferences = {
  __typename?: 'PostPreferences';
  /** A flag to indicate if the comments are disabled for the post. */
  disableComments: Scalars['Boolean'];
  /** Whether or not the post is hidden from the Hashnode community. */
  isDelisted: Scalars['Boolean'];
  /** A flag to indicate if the post is pinned to blog. Pinned post is shown on top of the blog. */
  pinnedToBlog: Scalars['Boolean'];
  /** A flag to indicate if the cover image is shown below title of the post. Default position of cover is top of title. */
  stickCoverToBottom: Scalars['Boolean'];
};

/** Contains the publication's preferences for layout, theme and other personalisations. */
export type Preferences = {
  __typename?: 'Preferences';
  /** The publication's darkmode preferences. Can be used to load blog in dark mode by default and add a custom dark mode logo. */
  darkMode?: Maybe<DarkModePreferences>;
  /** A flag indicating if the hashnode's footer branding is disabled for the publication. */
  disableFooterBranding?: Maybe<Scalars['Boolean']>;
  /** An object containing pages enabled for the publication. */
  enabledPages?: Maybe<PagesPreferences>;
  /** A flag indicating if subscription popup needs to be shown to be shown for the publication */
  isSubscriptionModalDisabled?: Maybe<Scalars['Boolean']>;
  /** The selected publication's layout, can be stacked, grid or magazine. */
  layout?: Maybe<PublicationLayout>;
  /** The publication's logo url. */
  logo?: Maybe<Scalars['String']>;
  /** The items in the publication's navigation bar. */
  navbarItems: Array<PublicationNavbarItem>;
};

/** Contains signing information about the image upload. */
export type PresignedPost = {
  __typename?: 'PresignedPost';
  /** The fields to include in the POST request. */
  fields: Scalars['JSONObject'];
  /** The Presigned URL to upload the image to. */
  url: Scalars['String'];
};

export type Price = {
  __typename?: 'Price';
  /** Price with taxes. */
  gross: Money;
  /** Price without taxes. */
  net: Money;
  /** The tax amount. */
  tax: Money;
};

export type ProPricing = {
  __typename?: 'ProPricing';
  /** Price for each additional publication added to the pro plan. */
  addOn: Price;
  /** Price of the base pro plan. */
  base: Price;
};

export type ProPricingInput = {
  /** The billing interval for which to get the pricing. */
  billingInterval: BillingInterval;
  /** Provide the two character ISO country code in order to be able to get the pricing with taxes. */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The coupon code to apply to the pricing, used to get discount during checkout. */
  couponCode?: InputMaybe<Scalars['String']>;
};

export type ProTeamFeature = Feature & {
  __typename?: 'ProTeamFeature';
  /** A flag indicating if the Pro team feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

export type ProjectViewEdge = Edge & {
  __typename?: 'ProjectViewEdge';
  cursor: Scalars['String'];
  node: DocsViews;
};

export type ProjectViewsConnection = Connection & {
  __typename?: 'ProjectViewsConnection';
  edges: Array<ProjectViewEdge>;
  pageInfo: PageInfo;
};

/**
 * Filter for project views.
 *
 * Individual filters are combined with an AND condition whereas multiple values for the same filter are combined with an OR condition.
 *
 * Example: `documentationGuideIds: ["1", "2"], operatingSystems: ["Mac OS"]` will return views for posts with ID 1 or 2 AND operating system Mac OS.
 */
export type ProjectViewsFilter = {
  /**
   * Filter by one or multiple api reference guide IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  apiReferenceGuideIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple browsers.
   *
   * If multiple browsers are provided, the filter will be applied as an OR condition.
   */
  browsers?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple countries.
   *
   * If multiple countries are provided, the filter will be applied as an OR condition.
   */
  countries?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple device types.
   *
   * If multiple device types are provided, the filter will be applied as an OR condition.
   */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /**
   * Filter by one or multiple documentation guide IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  documentationGuideIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple operating systems.
   *
   * If multiple operating systems are provided, the filter will be applied as an OR condition.
   */
  operatingSystems?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple page IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  pageIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple paths.
   *
   * If multiple paths are provided, the filter will be applied as an OR condition.
   */
  paths?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple referrer hosts.
   *
   * If multiple referrer hosts are provided, the filter will be applied as an OR condition.
   */
  referrerHosts?: InputMaybe<Array<Scalars['String']>>;
  /** Filter based on time range. */
  time?: InputMaybe<TimeFilter>;
};

export type ProjectViewsGroupBy = {
  /**
   * Group by one analytics dimensions.
   *
   * Can not be used together with `granularity`.
   */
  dimension?: InputMaybe<DocsAnalyticsDimension>;
  /**
   * Group by time. Without this, all views over time will be aggregated.
   *
   * Can not be used together with `dimension`.
   */
  granularity?: InputMaybe<TimeGranularity>;
};

export type ProjectViewsOptions = {
  /**
   * The timezone that is used for grouping the views by time.
   * E.g. if you group by day, the timezone will be used to determine the start of the day as indicated by `to` and `from`.
   *
   * It has no effect outside of time grouping.
   *
   * Default is `UTC`.
   */
  groupingTimezone?: InputMaybe<Scalars['TimeZone']>;
};

export type ProjectViewsSortBy = {
  /** Sort the views by the total number of views. Can only be used when grouped by `dimension`. */
  viewCount: SortOrder;
};

export type ProjectVisitorsConnection = Connection & {
  __typename?: 'ProjectVisitorsConnection';
  edges: Array<ProjectVisitorsEdge>;
  pageInfo: PageInfo;
};

export type ProjectVisitorsEdge = Edge & {
  __typename?: 'ProjectVisitorsEdge';
  cursor: Scalars['String'];
  node: DocsVisitors;
};

/**
 * Filter for project visitors.
 *
 * Individual filters are combined with an AND condition whereas multiple values for the same filter are combined with an OR condition.
 *
 * Example: `documentationGuideIds: ["1", "2"], operatingSystems: ["Mac OS"]` will return visitors for posts with ID 1 or 2 AND operating system Mac OS.
 */
export type ProjectVisitorsFilter = {
  /**
   * Filter by one or multiple api reference guide IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  apiReferenceGuideIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple browsers.
   *
   * If multiple browsers are provided, the filter will be applied as an OR condition.
   */
  browsers?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple countries.
   *
   * If multiple countries are provided, the filter will be applied as an OR condition.
   */
  countries?: InputMaybe<Array<CountryCodeAlpha2>>;
  /**
   * Filter by one or multiple device types.
   *
   * If multiple device types are provided, the filter will be applied as an OR condition.
   */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /**
   * Filter by one or multiple documentation guide IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  documentationGuideIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple operating systems.
   *
   * If multiple operating systems are provided, the filter will be applied as an OR condition.
   */
  operatingSystems?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple page IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  pageIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple paths.
   *
   * If multiple paths are provided, the filter will be applied as an OR condition.
   */
  paths?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple referrer hosts.
   *
   * If multiple referrer hosts are provided, the filter will be applied as an OR condition.
   */
  referrerHosts?: InputMaybe<Array<Scalars['String']>>;
  /** Filter based on time range. */
  time?: InputMaybe<TimeFilter>;
};

export type ProjectVisitorsGroupBy = {
  /**
   * Group by one analytics dimensions.
   *
   * Can not be used together with `granularity`.
   */
  dimension?: InputMaybe<DocsAnalyticsDimension>;
  /**
   * Group by time. Without this, all views over time will be aggregated.
   *
   * Can not be used together with `dimension`.
   */
  granularity?: InputMaybe<TimeGranularity>;
};

export type ProjectVisitorsOptions = {
  /**
   * The timezone that is used for grouping the views by time.
   * E.g. if you group by day, the timezone will be used to determine the start of the day as indicated by `to` and `from`.
   *
   * It has no effect outside of time grouping.
   *
   * Default is `UTC`.
   */
  groupingTimezone?: InputMaybe<Scalars['TimeZone']>;
};

/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type Publication = Node & {
  __typename?: 'Publication';
  /** The about section of the publication. */
  about?: Maybe<Content>;
  /** Returns the list of drafts in the publication */
  allDrafts: DraftConnection;
  /** Returns all the scheduled drafts of the publication. */
  allScheduledDrafts: DraftConnection;
  /** Boolean flag indicating if the publication allows edits by contributors */
  allowContributorEdits: Scalars['Boolean'];
  /** Analytics information for the publication. */
  analytics: PublicationAnalytics;
  areRoleBasedInviteLinksActive: Scalars['Boolean'];
  /** The author who owns the publication. */
  author: User;
  /** The canonical URL of the publication. */
  canonicalURL: Scalars['String'];
  /** The description of the publication, used in og:description meta tag. Fall backs to Publication.about.text if no SEO description is provided. */
  descriptionSEO?: Maybe<Scalars['String']>;
  /** The title of the publication. Shown in blog home page. */
  displayTitle?: Maybe<Scalars['String']>;
  /** Domain information of the publication. */
  domainInfo: DomainInfo;
  /** Returns the list of drafts of the authenticated user in the publication. */
  drafts: DraftConnection;
  /** Returns the publication's email imports, used with newsletter feature. */
  emailImport?: Maybe<EmailImport>;
  /** The favicon of the publication. Used in browser tab. */
  favicon?: Maybe<Scalars['String']>;
  /** Object containing information about beta features enabled for the publication. */
  features: PublicationFeatures;
  /** Total number of followers of the publication. */
  followersCount?: Maybe<Scalars['Int']>;
  /** Whether the publication has earned any badges or not. */
  hasBadges: Scalars['Boolean'];
  /** Color code of the header color of the publication. Used to style header of blog. */
  headerColor?: Maybe<Scalars['String']>;
  /** The ID of the publication. */
  id: Scalars['ID'];
  /**
   * Summary of the contact information and information related to copyrights, usually used in German-speaking countries.
   * @deprecated Use `imprintV2` instead. Will be removed after 16/12/2023.
   */
  imprint?: Maybe<Scalars['String']>;
  /** Summary of the contact information and information related to copyrights, usually used in German-speaking countries. */
  imprintV2?: Maybe<Content>;
  /** The integrations connected to the publication. */
  integrations?: Maybe<PublicationIntegrations>;
  /** Details of publication invites. Returns null if publication is not a team publication. */
  invites?: Maybe<PublicationInvite>;
  /** Returns true if the publication is active and false if deleted. */
  isActive?: Maybe<Scalars['Boolean']>;
  /**
   * Whether or not the authenticated user is following this publication.
   *
   * Returns `null` if the user is not authenticated.
   */
  isFollowedByMe?: Maybe<Scalars['Boolean']>;
  /** Returns true if GitHub backup is configured and active and false otherwise. */
  isGitHubBackupEnabled: Scalars['Boolean'];
  /** Returns whether the publication's GitHub source repo is connected. */
  isGithubAsSourceConnected: Scalars['Boolean'];
  /** A flag to indicate if the publication is using Headless CMS. This can be used to check if the post redirect needs authentication. */
  isHeadless: Scalars['Boolean'];
  /** Flag indicating if the publication is using the legacy pro plan. */
  isLegacyPro: Scalars['Boolean'];
  /** True if the publication is a team publication and false otherwise. */
  isTeam: Scalars['Boolean'];
  /** Links to the publication's social media profiles. */
  links?: Maybe<PublicationLinks>;
  members: PublicationMemberConnection;
  /** The meta tags associated with the publication. */
  metaTags?: Maybe<Scalars['String']>;
  /** Details of publication's newsletter. Returns null if newsletter service is not enabled. */
  newsletter?: Maybe<PublicationNewsletter>;
  /** The publication's notification settings. */
  notificationSettings?: Maybe<PublicationNotificationSettings>;
  /** Information about the publication's Open Graph metadata i.e. image. */
  ogMetaData: OpenGraphMetaData;
  /** Returns the pinned post of the publication. */
  pinnedPost?: Maybe<Post>;
  /** Returns the post with the given slug. */
  post?: Maybe<Post>;
  /** Returns the list of posts in the publication. */
  posts: PublicationPostConnection;
  /**
   * Total number of posts in the publication. This included published posts under this blog.
   * @deprecated Use `posts.totalDocuments` instead.
   */
  postsCount?: Maybe<Scalars['Int']>;
  postsViaPage: PublicationPostPageConnection;
  /** The publication preferences around layout, theme and other personalisations. */
  preferences: Preferences;
  /** Returns information about the publication's pro status. */
  pro?: Maybe<PublicationProInfo>;
  /** Publications that are recommended by this publication. */
  recommendedPublications: Array<UserRecommendedPublicationEdge>;
  /** Publications that are recommending this publication. */
  recommendingPublications: PublicationUserRecommendingPublicationConnection;
  /**
   * Returns a post by a previous slug. It does not resolve a post by its current slug.
   *
   * If a slug has been changed, we'll create a redirect from the old slug to the new one.
   * With `redirectedPost` you can resolve a post by the old slug.
   *
   * This can be used to redirect a user to the new post slug (via `redirectedPost.slug`).
   */
  redirectedPost?: Maybe<Post>;
  /** Configured redirection rules for the publication. */
  redirectionRules: Array<RedirectionRule>;
  /** Configurations for the RSS import. Used to automatically import posts by hashnode feed. */
  rssImport?: Maybe<RssImport>;
  /** Returns the scheduled drafts of the publication by the authenticated user. */
  scheduledDrafts: DraftConnection;
  /** Returns series by slug in the publication. */
  series?: Maybe<Series>;
  /** Returns the list of series in the publication. */
  seriesList: SeriesConnection;
  /** Contains the publication's sponsorships information. */
  sponsorship?: Maybe<PublicationSponsorship>;
  /** Returns the static page with the given slug. */
  staticPage?: Maybe<StaticPage>;
  /** Returns a list of static pages in the publication. */
  staticPages: StaticPageConnection;
  /** Returns the list of submitted drafts in the publication. */
  submittedDrafts: DraftConnection;
  /**
   * The title of the publication.
   * Title is used as logo if logo is not provided.
   */
  title: Scalars['String'];
  /** The total amount of recommended publications by this publication. */
  totalRecommendedPublications: Scalars['Int'];
  /** The domain of the publication. Used to access publication. Example https://johndoe.com */
  url: Scalars['String'];
  /** Determines the structure of the post URLs. */
  urlPattern: UrlPattern;
  /** Is the recommendations feature enabled on this publication */
  webhooks: Array<Webhook>;
  /** Returns the widget with the by widget ID. */
  widget?: Maybe<Widget>;
  widgets: PublicationWidgetConnection;
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationAllDraftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PublicationSearchableDraftConnectionFilter>;
  first: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationAllScheduledDraftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PublicationSearchableDraftConnectionFilter>;
  first: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationDraftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PublicationDraftConnectionFilter>;
  first: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationMembersArgs = {
  filter?: InputMaybe<PublicationMemberConnectionFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationPostArgs = {
  slug: Scalars['String'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PublicationPostConnectionFilter>;
  first: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationPostsViaPageArgs = {
  filter?: InputMaybe<PublicationPostsViaPageFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationRecommendingPublicationsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationRedirectedPostArgs = {
  slug: Scalars['String'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationScheduledDraftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PublicationDraftConnectionFilter>;
  first: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationSeriesArgs = {
  slug: Scalars['String'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationSeriesListArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationStaticPageArgs = {
  slug: Scalars['String'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationStaticPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationSubmittedDraftsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PublicationDraftConnectionFilter>;
  first: Scalars['Int'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationWidgetArgs = {
  widgetId: Scalars['String'];
};


/**
 * Contains basic information about the publication.
 * A publication is a blog that can be created for a user or a team.
 */
export type PublicationWidgetsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type PublicationAnalytics = {
  __typename?: 'PublicationAnalytics';
  averageVisitTimeInSeconds: Scalars['Int'];
  publicationId: Scalars['ObjectId'];
  views: PublicationViewsConnection;
  visitors: PublicationVisitorsConnection;
};


export type PublicationAnalyticsAverageVisitTimeInSecondsArgs = {
  filter?: InputMaybe<AverageVisitTimeFilter>;
};


export type PublicationAnalyticsViewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PublicationViewsFilter>;
  first: Scalars['Int'];
  groupBy?: InputMaybe<PublicationViewsGroupBy>;
  options?: InputMaybe<PublicationViewsOptions>;
};


export type PublicationAnalyticsVisitorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PublicationVisitorsFilter>;
  first: Scalars['Int'];
  groupBy?: InputMaybe<PublicationVisitorsGroupBy>;
  options?: InputMaybe<PublicationVisitorsOptions>;
};

/**
 * Connection to get list of drafts in publications.
 * Returns a list of edges which contains the drafts in publication and cursor to the last item of the previous page.
 */
export type PublicationDraftConnectionFilter = {
  /** Search filter will be applied to the title of a draft */
  search?: InputMaybe<Scalars['String']>;
};

export type PublicationFathomInput = {
  customDomain?: InputMaybe<Scalars['String']>;
  enableCustomDomain?: InputMaybe<Scalars['Boolean']>;
  siteID?: InputMaybe<Scalars['String']>;
};

/** Contains the publication's beta features. */
export type PublicationFeatures = {
  __typename?: 'PublicationFeatures';
  /**
   * Audio player for blog posts.
   * @deprecated Audio Blogs are not supported anymore. This field will be removed 18/04/23
   */
  audioBlog: AudioBlogFeature;
  /** Individual styling for the publication. */
  customCSS: CustomCssFeature;
  /** GPT Bot crawler to index the publication. */
  gptBotCrawling: GptBotCrawlingFeature;
  /** Headless CMS for the publication. */
  headlessCMS: HeadlessCmsFeature;
  /** Newsletter feature for the publication which adds a `/newsletter` route for collecting subscribers and allows sending out newsletters. */
  newsletter: NewsletterFeature;
  /** Flag to denote if publication is a pro team's publication. */
  proTeam: ProTeamFeature;
  /** Show the read time for blog posts. */
  readTime: ReadTimeFeature;
  /** Widget that shows up if a text on a blog post is selected. Allows for easy sharing or copying of the selected text. */
  textSelectionSharer: TextSelectionSharerFeature;
  /** Show the view count for blog posts. */
  viewCount: ViewCountFeature;
};

/**
 * Contains the publication's integrations.
 * Used to connect the publication with third party services like Google Analytics, Facebook Pixel, etc.
 */
export type PublicationIntegrations = {
  __typename?: 'PublicationIntegrations';
  /** Custom domain for integration with Fathom Analytics. */
  fathomCustomDomain?: Maybe<Scalars['String']>;
  /** A flag indicating if the custom domain is enabled for integration with Fathom Analytics. */
  fathomCustomDomainEnabled?: Maybe<Scalars['Boolean']>;
  /** Fathom Analytics Site ID for integration with Fathom Analytics. */
  fathomSiteID?: Maybe<Scalars['String']>;
  /** FB Pixel ID for integration with Facebook Pixel. */
  fbPixelID?: Maybe<Scalars['String']>;
  /** Google Tag Manager ID for integration with Google Tag Manager. */
  gTagManagerID?: Maybe<Scalars['String']>;
  /** Google Analytics Tracking ID for integration with Google Analytics. */
  gaTrackingID?: Maybe<Scalars['String']>;
  /** Hotjar Site ID for integration with Hotjar. */
  hotjarSiteID?: Maybe<Scalars['String']>;
  /** Koala Public Key for integration with Koala. */
  koalaPublicKey?: Maybe<Scalars['String']>;
  /** Matomo Site ID for integration with Matomo Analytics. */
  matomoSiteID?: Maybe<Scalars['String']>;
  /** Matomo URL for integration with Matomo Analytics. */
  matomoURL?: Maybe<Scalars['String']>;
  /** MS Clarity ID for integration with Microsoft Clarity. */
  msClarityID?: Maybe<Scalars['String']>;
  /** A flag indicating if the custom domain is enabled for integration with Plausible Analytics. */
  plausibleAnalyticsEnabled?: Maybe<Scalars['Boolean']>;
  /** The share ID for the Hashnode-provided Umami analytics instance. */
  umamiShareId?: Maybe<Scalars['String']>;
  /** The ID for the Hashnode-provided Umami analytics instance. */
  umamiWebsiteUUID?: Maybe<Scalars['String']>;
  /** Web Monetization Payment Pointer for integration with Web Monetization. */
  wmPaymentPointer?: Maybe<Scalars['String']>;
};

/** Contains the publication invite information. */
export type PublicationInvite = {
  __typename?: 'PublicationInvite';
  /**
   * Signifies if invite links in role-based invites are active.
   * Users trying to join by role-based invite can only join if this is enabled.
   */
  areRoleBasedInviteLinksActive: Scalars['Boolean'];
  pendingInvites: PendingInviteConnection;
  /** The ID of the publication. */
  publicationId: Scalars['ObjectId'];
  /** The paginated list of role based invites. */
  roleBasedInvites: RoleBasedInviteConnection;
};


/** Contains the publication invite information. */
export type PublicationInvitePendingInvitesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/** Contains the publication invite information. */
export type PublicationInviteRoleBasedInvitesArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

/** Contains publication's layout choices. */
export enum PublicationLayout {
  /** Changes the layout of blog into grid 3 post cards per row. */
  Grid = 'grid',
  /**
   * Changes the layout of blog into magazine style.
   * This is the newest layout.
   */
  Magazine = 'magazine',
  /** Changes the layout of blog into stacked list of posts. */
  Stacked = 'stacked'
}

/** Contains the publication's social media links. */
export type PublicationLinks = {
  __typename?: 'PublicationLinks';
  /** Bluesky URL of the publication. */
  bluesky?: Maybe<Scalars['String']>;
  /** Daily.dev URL of the publication. */
  dailydev?: Maybe<Scalars['String']>;
  /** Facebook URL of the publication. */
  facebook?: Maybe<Scalars['String']>;
  /** GitHub URL of the publication. */
  github?: Maybe<Scalars['String']>;
  /** Hashnode profile of author of the publication. */
  hashnode?: Maybe<Scalars['String']>;
  /** Instagram URL of the publication. */
  instagram?: Maybe<Scalars['String']>;
  /** LinkedIn URL of the publication. */
  linkedin?: Maybe<Scalars['String']>;
  /** Mastodon URL of the publication. */
  mastodon?: Maybe<Scalars['String']>;
  /** Twitter URL of the publication. */
  twitter?: Maybe<Scalars['String']>;
  /** Website URL of the publication. */
  website?: Maybe<Scalars['String']>;
  /** YouTube URL of the publication. */
  youtube?: Maybe<Scalars['String']>;
};

export type PublicationLinksInput = {
  bluesky?: InputMaybe<Scalars['String']>;
  dailydev?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  github?: InputMaybe<Scalars['String']>;
  hashnode?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  mastodon?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
};

export type PublicationLogoInput = {
  darkModeImageURL?: InputMaybe<Scalars['String']>;
  lightModeImageURL?: InputMaybe<Scalars['String']>;
};

export type PublicationMatomoInput = {
  siteID?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Contains the publication member information. */
export type PublicationMember = Node & {
  __typename?: 'PublicationMember';
  /** The ID of the publication member. */
  id: Scalars['ID'];
  /**
   * Denotes if the member is public or private
   * A private member is not visible on members page
   */
  privacyState?: Maybe<PublicationMemberPrivacyState>;
  /** The role of the user in the publication. */
  role: UserPublicationRole;
  /** The user who is a member of the publication. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export type PublicationMemberConnection = PageConnection & {
  __typename?: 'PublicationMemberConnection';
  /** A list of members */
  nodes: Array<PublicationMember>;
  /** Information for page based pagination in Member connection. */
  pageInfo: OffsetPageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/** The filter for the publication member connection. */
export type PublicationMemberConnectionFilter = {
  /** Search filter can be used to filter members by their username or email. */
  search?: InputMaybe<Scalars['String']>;
};

/** Publication member privacy state on members page */
export enum PublicationMemberPrivacyState {
  /** The member is private and not visible on the members page. */
  Private = 'PRIVATE',
  /** The member is public and visible on the members page. */
  Public = 'PUBLIC'
}

/** Contains the publication's navbar items. */
export type PublicationNavbarItem = {
  __typename?: 'PublicationNavbarItem';
  /** The unique identifier of the navbar item. */
  id: Scalars['ID'];
  /** The label of the navbar item. */
  label?: Maybe<Scalars['String']>;
  /** The static page added to the navbar item. */
  page?: Maybe<StaticPage>;
  /**
   * The order of the navbar item.
   * @deprecated Navbar items are already returned in the correct order. Priority value is not needed and might be 0 in most cases.
   */
  priority?: Maybe<Scalars['Int']>;
  /** The series added to the navbar item. */
  series?: Maybe<Series>;
  /** The type of the navbar item, can be series, link or page. */
  type: PublicationNavigationType;
  /** The URL of the navbar item. */
  url?: Maybe<Scalars['String']>;
};

/** The type of the navbar item, can be series, link or page. */
export enum PublicationNavigationType {
  /** The navbar item is a link. */
  Link = 'link',
  /** The navbar item is a static page. */
  Page = 'page',
  /** The navbar item is a series. */
  Series = 'series'
}

export type PublicationNewsletter = {
  __typename?: 'PublicationNewsletter';
  history: NewsletterHistoryConnection;
  publicationId: Scalars['ObjectId'];
  subscribers: NewsletterSubscribersConnection;
};


export type PublicationNewsletterHistoryArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type PublicationNewsletterSubscribersArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

/** Contains the publication's notification settings. */
export type PublicationNotificationSettings = {
  __typename?: 'PublicationNotificationSettings';
  newDraftSubmission: NewDraftSubmissionNotification;
};

/**
 * Connection for posts within a publication. Contains a list of edges containing nodes.
 * Each node is a post.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type PublicationPostConnection = Connection & {
  __typename?: 'PublicationPostConnection';
  /** A list of edges containing Post information */
  edges: Array<PostEdge>;
  /** Information for pagination in Post connection. */
  pageInfo: PageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/**
 * Connection to get list of posts in publications.
 * Returns a list of edges which contains the posts in publication and cursor to the last item of the previous page.
 */
export type PublicationPostConnectionFilter = {
  /** Only return posts that are deleted. Query returns active posts by default, set this to true to return deleted posts. */
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
  /** Remove pinned post from the result set. */
  excludePinnedPost?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filtering by tag slugs and tag IDs will return posts that match either of the filters.
   *
   * It is an "OR" filter and not an "AND" filter.
   */
  tagSlugs?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filtering by tag slugs and tag IDs will return posts that match either of the filters.
   *
   * It is an "OR" filter and not an "AND" filter.
   */
  tags?: InputMaybe<Array<Scalars['ObjectId']>>;
};

export type PublicationPostPageConnection = PageConnection & {
  __typename?: 'PublicationPostPageConnection';
  /** The posts belonging to the publication. */
  nodes: Array<Post>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
  /** The total number of posts. */
  totalDocuments: Scalars['Int'];
};

export type PublicationPostsViaPageFilter = {
  /** Remove pinned post from the result set. */
  excludePinnedPosts?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filtering by tag slugs and tag IDs will return posts that match either of the filters.
   *
   * It is an "OR" filter and not an "AND" filter.
   */
  tagSlugs?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filtering by tag slugs and tag IDs will return posts that match either of the filters.
   *
   * It is an "OR" filter and not an "AND" filter.
   */
  tags?: InputMaybe<Array<Scalars['ID']>>;
};

/** Returns information about the publication's pro plan status. */
export type PublicationProInfo = {
  __typename?: 'PublicationProInfo';
  /** The day the pro plan has or will be canceled. */
  cancelationEffectiveDate?: Maybe<Scalars['Date']>;
  /** The point in time when the pro plan was canceled. */
  canceledAt?: Maybe<Scalars['DateTime']>;
  /** Indicates if the publication is allowed to use pro features. */
  hasProAccess: Scalars['Boolean'];
};

/**
 * ConnectionFilter to get list of drafts in publications.
 * The filters are combined with an "AND" operation.
 */
export type PublicationSearchableDraftConnectionFilter = {
  /** An array of author Ids to filter the drafts. */
  authorIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Search filter will be applied to the title of a draft */
  search?: InputMaybe<Scalars['String']>;
  /** An array of tag Ids to filter the drafts. */
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter based on time range. */
  time?: InputMaybe<TimeFilter>;
};

/**
 * Contains the publication's Sponsorship information.
 * User can sponsor their favorite publications and pay them directly using Stripe.
 */
export type PublicationSponsorship = {
  __typename?: 'PublicationSponsorship';
  /**
   * The content shared by author of the publication to their sponsors.
   * This is used as note to inform that author is open for sponsorship.
   */
  content?: Maybe<Content>;
  /** The Stripe configuration of the publication's Sponsorship. */
  stripe?: Maybe<StripeConfiguration>;
};

export type PublicationUserRecommendingPublicationConnection = PageConnection & {
  __typename?: 'PublicationUserRecommendingPublicationConnection';
  /** A list of edges containing Post information */
  edges: Array<UserRecommendingPublicationEdge>;
  /** Publications recommending this publication. */
  nodes: Array<Publication>;
  /** Information for page based pagination in Post connection. */
  pageInfo: OffsetPageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

export type PublicationViewEdge = Edge & {
  __typename?: 'PublicationViewEdge';
  cursor: Scalars['String'];
  node: Views;
};

export type PublicationViewsConnection = Connection & {
  __typename?: 'PublicationViewsConnection';
  edges: Array<PublicationViewEdge>;
  pageInfo: PageInfo;
};

/**
 * Filter for publication views.
 *
 * Individual filters are combined with an AND condition whereas multiple values for the same filter are combined with an OR condition.
 *
 * Example: `postIds: ["1", "2"], operatingSystems: ["Mac OS"]` will return views for posts with ID 1 or 2 AND operating system Mac OS.
 */
export type PublicationViewsFilter = {
  /**
   * Filter by one or multiple browsers.
   *
   * If multiple browsers are provided, the filter will be applied as an OR condition.
   */
  browsers?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple countries.
   *
   * If multiple countries are provided, the filter will be applied as an OR condition.
   */
  countries?: InputMaybe<Array<CountryCodeAlpha2>>;
  /**
   * Filter by one or multiple device types.
   *
   * If multiple device types are provided, the filter will be applied as an OR condition.
   */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /**
   * Filter by one or multiple operating systems.
   *
   * If multiple operating systems are provided, the filter will be applied as an OR condition.
   */
  operatingSystems?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple page IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  pageIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple paths.
   *
   * If multiple paths are provided, the filter will be applied as an OR condition.
   */
  paths?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple post IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  postIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple referrer hosts.
   *
   * If multiple referrer hosts are provided, the filter will be applied as an OR condition.
   */
  referrerHosts?: InputMaybe<Array<Scalars['String']>>;
  /** Filter based on time range. */
  time?: InputMaybe<TimeFilter>;
};

export type PublicationViewsGroupBy = {
  /**
   * Group by one analytics dimensions.
   *
   * Can not be used together with `granularity`.
   */
  dimension?: InputMaybe<AnalyticsDimension>;
  /**
   * Group by time. Without this, all views over time will be aggregated.
   *
   * Can not be used together with `dimension`.
   */
  granularity?: InputMaybe<TimeGranularity>;
};

export type PublicationViewsOptions = {
  /**
   * The timezone that is used for grouping the views by time.
   * E.g. if you group by day, the timezone will be used to determine the start of the day as indicated by `to` and `from`.
   *
   * It has no effect outside of time grouping.
   *
   * Default is `UTC`.
   */
  groupingTimezone?: InputMaybe<Scalars['TimeZone']>;
};

export type PublicationVisitorsConnection = Connection & {
  __typename?: 'PublicationVisitorsConnection';
  edges: Array<PublicationVisitorsEdge>;
  pageInfo: PageInfo;
};

export type PublicationVisitorsEdge = Edge & {
  __typename?: 'PublicationVisitorsEdge';
  cursor: Scalars['String'];
  node: Visitors;
};

/**
 * Filter for publication visitors.
 *
 * Individual filters are combined with an AND condition whereas multiple values for the same filter are combined with an OR condition.
 *
 * Example: `postIds: ["1", "2"], operatingSystems: ["Mac OS"]` will return visitors for posts with ID 1 or 2 AND operating system Mac OS.
 */
export type PublicationVisitorsFilter = {
  /**
   * Filter by one or multiple browsers.
   *
   * If multiple browsers are provided, the filter will be applied as an OR condition.
   */
  browsers?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple countries.
   *
   * If multiple countries are provided, the filter will be applied as an OR condition.
   */
  countries?: InputMaybe<Array<CountryCodeAlpha2>>;
  /**
   * Filter by one or multiple device types.
   *
   * If multiple device types are provided, the filter will be applied as an OR condition.
   */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /**
   * Filter by one or multiple operating systems.
   *
   * If multiple operating systems are provided, the filter will be applied as an OR condition.
   */
  operatingSystems?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple page IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  pageIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple paths.
   *
   * If multiple paths are provided, the filter will be applied as an OR condition.
   */
  paths?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filter by one or multiple post IDs.
   *
   * If multiple IDs are provided, the filter will be applied as an OR condition.
   */
  postIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter by one or multiple referrer hosts.
   *
   * If multiple referrer hosts are provided, the filter will be applied as an OR condition.
   */
  referrerHosts?: InputMaybe<Array<Scalars['String']>>;
  /** Filter based on time range. */
  time?: InputMaybe<TimeFilter>;
};

export type PublicationVisitorsGroupBy = {
  /**
   * Group by one analytics dimensions.
   *
   * Can not be used together with `granularity`.
   */
  dimension?: InputMaybe<AnalyticsDimension>;
  /**
   * Group by time. Without this, all views over time will be aggregated.
   *
   * Can not be used together with `dimension`.
   */
  granularity?: InputMaybe<TimeGranularity>;
};

export type PublicationVisitorsOptions = {
  /**
   * The timezone that is used for grouping the visitors by time.
   * E.g. if you group by day, the timezone will be used to determine the start of the day as indicated by `to` and `from`.
   *
   * It has no effect outside of time grouping.
   *
   * Default is `UTC`.
   */
  groupingTimezone?: InputMaybe<Scalars['TimeZone']>;
};

export type PublicationWidgetConnection = PageConnection & {
  __typename?: 'PublicationWidgetConnection';
  /** A list of widgets */
  nodes: Array<Widget>;
  /** Information for page based pagination in Widget connection. */
  pageInfo: OffsetPageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

export type PublishDocumentationApiReferenceInput = {
  guideSlug: Scalars['String'];
  projectId: Scalars['ID'];
};

export type PublishDocumentationApiReferencePayload = {
  __typename?: 'PublishDocumentationApiReferencePayload';
  guide?: Maybe<DocumentationApiReference>;
};

export type PublishDocumentationGuideInput = {
  guideSlug: Scalars['String'];
  projectId: Scalars['ID'];
};

export type PublishDocumentationGuidePayload = {
  __typename?: 'PublishDocumentationGuidePayload';
  guide?: Maybe<DocumentationGuide>;
};

export type PublishDocumentationGuideVersionInput = {
  /** Slug of the guide that contains the version to be published. */
  guideSlug: Scalars['String'];
  /** ID of the project that contains the version to be published. */
  projectId: Scalars['ID'];
  /**
   * Slug of the version to be published.
   *
   * Defaults to the default version.
   */
  versionSlug?: InputMaybe<Scalars['String']>;
};

export type PublishDocumentationGuideVersionPayload = {
  __typename?: 'PublishDocumentationGuideVersionPayload';
  /** The published version. */
  version?: Maybe<DocumentationVersion>;
};

export type PublishDocumentationPageDraftInput = {
  guideSlug: Scalars['String'];
  pageId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type PublishDocumentationPageDraftPayload = {
  __typename?: 'PublishDocumentationPageDraftPayload';
  guide?: Maybe<DocumentationGuide>;
  page?: Maybe<DocumentationPage>;
};

export type PublishDocumentationProjectFromGitHubInput = {
  /** The ID of the documentation project */
  projectId: Scalars['ID'];
};

/** The payload for publishing a documentation project from a provider */
export type PublishDocumentationProjectFromGitHubPayload = {
  __typename?: 'PublishDocumentationProjectFromGitHubPayload';
  errors?: Maybe<Array<GitHubSyncError>>;
  project?: Maybe<DocumentationProject>;
};

export type PublishDraftInput = {
  /** The id of the draft that should be published */
  draftId: Scalars['ObjectId'];
};

export type PublishDraftPayload = {
  __typename?: 'PublishDraftPayload';
  /** The newly created post based on the draft */
  post?: Maybe<Post>;
};

/** Contains information about the post to be published. */
export type PublishPostInput = {
  /** Ids of the co-authors of the post. */
  coAuthors?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** Content of the post in markdown format. */
  contentMarkdown: Scalars['String'];
  /** Options for the cover image of the post. */
  coverImageOptions?: InputMaybe<CoverImageOptionsInput>;
  /** A flag to indicate if the comments are disabled for the post. */
  disableComments?: InputMaybe<Scalars['Boolean']>;
  /**
   * The ID of the draft to be published.
   * If an ID is provided, all other input fields are ignored. The corresponding draft is used to create the post.
   * @deprecated Will be removed on 15th Dec 2023. Use `publishDraft` instead.
   */
  draftId?: InputMaybe<Scalars['ObjectId']>;
  /** Information about the meta tags added to the post, used for SEO purpose. */
  metaTags?: InputMaybe<MetaTagsInput>;
  /** The URL of the original article if the post is imported from an external source. */
  originalArticleURL?: InputMaybe<Scalars['String']>;
  /** The ID of publication the post belongs to. */
  publicationId: Scalars['ObjectId'];
  /**
   * Publish the post on behalf of another user who is a member of the publication.
   *
   * Only applicable for team publications.
   */
  publishAs?: InputMaybe<Scalars['ObjectId']>;
  /** Date when the post is published. */
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** Providing a seriesId will add the post to that series. */
  seriesId?: InputMaybe<Scalars['ObjectId']>;
  /** Settings for the post like table of contents and newsletter activation. */
  settings?: InputMaybe<PublishPostSettingsInput>;
  /** Slug of the post. */
  slug?: InputMaybe<Scalars['String']>;
  /** The subtitle of the post. */
  subtitle?: InputMaybe<Scalars['String']>;
  /**
   * A list of tags to add to the post. You can get a list of popular tags available on Hashnode here.
   * https://github.com/Hashnode/support/blob/main/misc/tags.json
   */
  tags?: InputMaybe<Array<PublishPostTagInput>>;
  /** The title of the post. */
  title: Scalars['String'];
};

export type PublishPostPayload = {
  __typename?: 'PublishPostPayload';
  post?: Maybe<Post>;
};

export type PublishPostSettingsInput = {
  /** A flag to indicate if the post is delisted, used to hide the post from public feed. */
  delisted?: InputMaybe<Scalars['Boolean']>;
  /** A flag to indicate if the post contains table of content */
  enableTableOfContent?: InputMaybe<Scalars['Boolean']>;
  /** Whether to send a newsletter for this post. */
  isNewsletterActivated?: InputMaybe<Scalars['Boolean']>;
  /** A flag to indicate if the post is scheduled. */
  scheduled?: InputMaybe<Scalars['Boolean']>;
  /** Flag to indicate if the slug is overridden by the user. */
  slugOverridden?: InputMaybe<Scalars['Boolean']>;
};

export type PublishPostTagInput = {
  /**
   * A tag id that is referencing an existing tag.
   *
   * Either this or name and slug should be provided. If both are provided, the id will be used.
   */
  id?: InputMaybe<Scalars['ObjectId']>;
  /**
   * A name of a new tag to create.
   *
   * Either this and slug or id should be provided. If both are provided, the id will be used.
   */
  name?: InputMaybe<Scalars['String']>;
  /**
   * A slug of a new tag to create.
   *
   * Either this and name or id should be provided. If both are provided, the id will be used.
   */
  slug?: InputMaybe<Scalars['String']>;
};

export type PurgePublicationCacheInput = {
  id: Scalars['ID'];
};

export type PurgePublicationCachePayload = {
  __typename?: 'PurgePublicationCachePayload';
  success: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  /** Returns a list of beta features. */
  blogsWithBetaFeatures: Array<BlogWithBetaFeatures>;
  checkCustomDomainAvailability: CheckCustomDomainAvailabilityResult;
  checkSubdomainAvailability: CheckSubdomainAvailabilityResult;
  /**
   * Returns a paginated list of comments. Passing $first is mandatory.
   * Used in Hashnode discussions feed.
   */
  discussions: FeedPostConnection;
  documentationProject?: Maybe<DocumentationProject>;
  documentationProjectPricing: Array<DocumentationProjectProductPricing>;
  /**
   * Returns a draft by ID.
   * Draft is a post that is not published yet.
   */
  draft?: Maybe<Draft>;
  /**
   * Returns a paginated list of posts based on the provided filter.
   * Used in Hashnode home feed.
   */
  feed: FeedPostConnection;
  /** Returns the current authenticated user. Only available to the authenticated user. */
  me: MyUser;
  /** Returns Tags sorted by their usage in posts within the given period. */
  popularTags: PopularTagsConnection;
  /**
   * Returns a list of Tags sorted by their usage in posts within the given period.
   * @deprecated Use popularTags instead
   */
  popularTagsV2: PopularTagsConnection;
  /** Returns post by ID. Can be used to render post page on blog. */
  post?: Maybe<Post>;
  /** Get the pricing for the pro plan. */
  proPricing: ProPricing;
  /**
   * Returns the publication with the given ID or host.
   * User can pass anyone of them.
   */
  publication?: Maybe<Publication>;
  /** Returns the recommended publication to follow. */
  recommendedPublications: RecommendedPublicationsConnection;
  /** Returns Tags to recommend based on usage and popularity. */
  recommendedTags: PopularTagsConnection;
  /** Get a scheduled post by ID. */
  scheduledPost?: Maybe<ScheduledPost>;
  /** Returns a paginated list of posts based on search query for a particular publication id. */
  searchPostsOfPublication: SearchPostConnection;
  /**
   * Search for publications by title, Hashnode subdomain or exact custom domain.
   *
   * Returns at most 10 publications.
   */
  searchPublications: Array<Publication>;
  /** Search for users by name, username, or email. */
  searchUsers: SearchUserConnection;
  /** Returns tag details by its slug. */
  tag?: Maybe<Tag>;
  /** Returns users who have most actively participated in discussions by commenting in the last 7 days. */
  topCommenters: CommenterUserConnection;
  /**
   * Returns a paginated list of comments. Passing $first is mandatory.
   * Used in Hashnode discussions feed.
   * Used for widgets on hashnode main. This is a hack to get around the urql cache issue.
   * TODO: ⚠️ Remove this query once the cache issue is fixed.
   * https://linear.app/hashnode/issue/HE-2629/urql-relay-pagination-issue
   */
  topDiscussions: FeedPostConnection;
  /** Returns the user with the username. */
  user?: Maybe<User>;
  webhook?: Maybe<Webhook>;
  /**
   * Returns a widget by id
   * @deprecated Use Publication.widget instead
   */
  widget?: Maybe<Widget>;
};


export type QueryCheckCustomDomainAvailabilityArgs = {
  input: CheckCustomDomainAvailabilityInput;
};


export type QueryCheckSubdomainAvailabilityArgs = {
  subdomain: Scalars['String'];
};


export type QueryDiscussionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


export type QueryDocumentationProjectArgs = {
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryDraftArgs = {
  id: Scalars['ObjectId'];
};


export type QueryFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<FeedFilter>;
  first: Scalars['Int'];
};


export type QueryPopularTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PopularTagsFilter>;
  first: Scalars['Int'];
};


export type QueryPopularTagsV2Args = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PopularTagsFilterV2>;
  first: Scalars['Int'];
};


export type QueryPostArgs = {
  id: Scalars['ID'];
};


export type QueryProPricingArgs = {
  input: ProPricingInput;
};


export type QueryPublicationArgs = {
  host?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ObjectId']>;
};


export type QueryRecommendedPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


export type QueryRecommendedTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


export type QueryScheduledPostArgs = {
  id?: InputMaybe<Scalars['ObjectId']>;
};


export type QuerySearchPostsOfPublicationArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter: SearchPostsOfPublicationFilter;
  first: Scalars['Int'];
};


export type QuerySearchPublicationsArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchUsersArgs = {
  filter?: InputMaybe<SearchUsersFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  searchTerm: Scalars['String'];
};


export type QueryTagArgs = {
  slug: Scalars['String'];
};


export type QueryTopCommentersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


export type QueryTopDiscussionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


export type QueryUserArgs = {
  username: Scalars['String'];
};


export type QueryWebhookArgs = {
  id: Scalars['ID'];
};


export type QueryWidgetArgs = {
  publicationId: Scalars['ID'];
  widgetId: Scalars['String'];
};

export type RssImport = Node & {
  __typename?: 'RSSImport';
  id: Scalars['ID'];
  /** Indicates whether posts should be imported as drafts or not */
  importAsDrafts: Scalars['Boolean'];
  /** RSS Tag name to be considered as the post content for automatic import. */
  rssTagName?: Maybe<Scalars['String']>;
  /** The URL pointing to the RSS feed. */
  rssURL: Scalars['String'];
  /** Indicates whether the posts should be scraped or not */
  scrapePosts: Scalars['Boolean'];
};

/** The input for recreating a documentation project preview */
export type ReCreateDocumentationPreviewProjectInput = {
  /** The input for the new api references. All api references will be overwritten */
  apiReferences: Array<CreateDocumentationPreviewApiReferenceInput>;
  /** The input the guides. All guides will be overwritten */
  guides: Array<CreateDocumentationPreviewGuideInput>;
  /** The ID of the preview project to recreate */
  projectId: Scalars['ID'];
};

/**
 * Contains the flag indicating if the read time feature is enabled or not.
 * User can enable or disable the read time feature from the publication settings.
 * Shows read time on blogs if enabled.
 */
export type ReadTimeFeature = Feature & {
  __typename?: 'ReadTimeFeature';
  /** A flag indicating if the read time feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

export type RecommendPublicationsInput = {
  recommendedPublicationIds: Array<Scalars['ID']>;
  recommendingPublicationId: Scalars['ID'];
};

export type RecommendPublicationsPayload = {
  __typename?: 'RecommendPublicationsPayload';
  recommendedPublications?: Maybe<Array<UserRecommendedPublicationEdge>>;
};

/** Contains a publication and a cursor for pagination. */
export type RecommendedPublicationEdge = Edge & {
  __typename?: 'RecommendedPublicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The node holding the Publication information */
  node: Publication;
};

/**
 * Connection for recommended publication in given time frame. Contains a list of edges containing nodes.
 * Each node is a tag.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type RecommendedPublicationsConnection = Connection & {
  __typename?: 'RecommendedPublicationsConnection';
  /** A list of edges containing Tag information */
  edges: Array<RecommendedPublicationEdge>;
  /** Information for pagination in popular Tags connection. */
  pageInfo: PageInfo;
};

/**
 * Connection for recommended tags for user. Contains a list of edges containing nodes.
 * Each node is a tag.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type RecommendedTagsConnection = Connection & {
  __typename?: 'RecommendedTagsConnection';
  /** A list of edges containing Tag information */
  edges: Array<TagEdge>;
  /** Information for pagination in popular Tags connection. */
  pageInfo: PageInfo;
};

/** The response to recreating a documentation project preview */
export type RecreateDocumentationPreviewProjectPayload = {
  __typename?: 'RecreateDocumentationPreviewProjectPayload';
  /** The preview project that was recreated */
  project?: Maybe<DocumentationProject>;
};

export type RedirectionRule = Node & {
  __typename?: 'RedirectionRule';
  /** The destination URL of the redirection rule. */
  destination: Scalars['URL'];
  id: Scalars['ID'];
  /** The source URL of the redirection rule. */
  source: Scalars['String'];
  /** The type of the redirection rule. */
  type: HttpRedirectionType;
};

/** The input for resending invite to documentation project. */
export type ReinviteDocumentationProjectAdminInput = {
  /** The ID of the invite to be resent. */
  inviteId: Scalars['ID'];
  /** The ID of the documentation project */
  projectId: Scalars['ID'];
};

/** The response to resending invite to documentation project. */
export type ReinviteDocumentationProjectAdminPayload = {
  __typename?: 'ReinviteDocumentationProjectAdminPayload';
  /** Signifies if the mutation was successful. */
  success: Scalars['Boolean'];
};

/** Input to reinvite a user to a publication. */
export type ReinviteUserToPublicationInput = {
  /** The ID of the invitation to resend. */
  inviteId: Scalars['ID'];
  /** The publication ID to resend the invitation from. */
  publicationId: Scalars['ID'];
};

/** Response to reinviting a user to a publication. */
export type ReinviteUserToPublicationPayload = {
  __typename?: 'ReinviteUserToPublicationPayload';
  /** Signifies if the mutation was successful. */
  success: Scalars['Boolean'];
};

export type RejectDraftSubmissionInput = {
  /** ID of the draft to be published. */
  draftId: Scalars['ID'];
};

export type RejectDraftSubmissionPayload = {
  __typename?: 'RejectDraftSubmissionPayload';
  draft?: Maybe<Draft>;
};

export type RelativeTimeRange = {
  /** The number of time periods to go back in time. */
  n: Scalars['Int'];
  /** The type of time range to be used. */
  relative: TimePeriod;
};

export type RemoveCommentInput = {
  id: Scalars['ID'];
};

export type RemoveCommentPayload = {
  __typename?: 'RemoveCommentPayload';
  comment?: Maybe<Comment>;
};

export type RemoveDocsCustomPageInput = {
  /** ID of the docs custom page to be removed. */
  id: Scalars['ID'];
  /** Project ID to which the docs custom page belongs. */
  projectId: Scalars['ID'];
};

/** Input for removing a navbar column in the footer of a documentation project. */
export type RemoveDocumentationFooterNavbarColumnInput = {
  /** The ID of the navbar column that will be removed. */
  columnId: Scalars['ID'];
  /** The ID of the project that the navbar column will be removed from. */
  projectId: Scalars['ID'];
};

/** Payload for removing a navbar column in the footer of a documentation project. */
export type RemoveDocumentationFooterNavbarColumnPayload = {
  __typename?: 'RemoveDocumentationFooterNavbarColumnPayload';
  /** The project that the navbar column was removed from. */
  project?: Maybe<DocumentationProject>;
};

export type RemoveDocumentationGuideInput = {
  guideSlug: Scalars['String'];
  projectId: Scalars['ID'];
};

export type RemoveDocumentationGuidePayload = {
  __typename?: 'RemoveDocumentationGuidePayload';
  guide?: Maybe<DocumentationGuideItem>;
};

/** Input for removing a navbar item from a documentation project. */
export type RemoveDocumentationNavbarItemInput = {
  /** The ID of the navbar item that will be removed. */
  itemId: Scalars['ID'];
  /** The ID of the project that the navbar item will be removed from. */
  projectId: Scalars['ID'];
};

/** Payload for removing a navbar item from a documentation project. */
export type RemoveDocumentationNavbarItemPayload = {
  __typename?: 'RemoveDocumentationNavbarItemPayload';
  /** The project that the navbar item was removed from. */
  project?: Maybe<DocumentationProject>;
};

/** The input for removing a documentation project preview */
export type RemoveDocumentationPreviewProjectInput = {
  /** The ID of the preview project to remove */
  projectId: Scalars['ID'];
};

/** The response to removing a documentation project preview */
export type RemoveDocumentationPreviewProjectPayload = {
  __typename?: 'RemoveDocumentationPreviewProjectPayload';
  /** The preview project that was removed */
  project?: Maybe<DocumentationProject>;
};

/** The input for removing a prompt from the AI search */
export type RemoveDocumentationProjectAiPromptInput = {
  projectId: Scalars['ID'];
  promptId: Scalars['ID'];
};

/** Response to removing a prompt from the AI search */
export type RemoveDocumentationProjectAiPromptPayload = {
  __typename?: 'RemoveDocumentationProjectAIPromptPayload';
  project: DocumentationProject;
};

export type RemoveDocumentationProjectCustomDomainInput = {
  projectId: Scalars['ID'];
};

export type RemoveDocumentationProjectCustomDomainPayload = {
  __typename?: 'RemoveDocumentationProjectCustomDomainPayload';
  project?: Maybe<DocumentationProject>;
};

/** The input for removing the GitHub integration from a documentation project */
export type RemoveDocumentationProjectGitHubSyncIntegrationInput = {
  projectId: Scalars['ID'];
};

/** The payload for removing github integration from a documentation project. */
export type RemoveDocumentationProjectGitHubSyncIntegrationPayload = {
  __typename?: 'RemoveDocumentationProjectGitHubSyncIntegrationPayload';
  project?: Maybe<DocumentationProject>;
};

/** The input for removing a documentation project. */
export type RemoveDocumentationProjectInput = {
  /** The ID of the documentation project that should be removed. */
  projectId: Scalars['ID'];
};

/** The input for the removal of a member from a documentation */
export type RemoveDocumentationProjectMemberInput = {
  projectId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveDocumentationProjectMemberPayload = {
  __typename?: 'RemoveDocumentationProjectMemberPayload';
  project?: Maybe<DocumentationProject>;
  removedMember?: Maybe<DocumentationProjectMember>;
};

/** The payload for removing a documentation project. */
export type RemoveDocumentationProjectPayload = {
  __typename?: 'RemoveDocumentationProjectPayload';
  /** The documentation project that was removed. */
  project?: Maybe<DocumentationProject>;
};

export type RemoveDocumentationSidebarItemInput = {
  guideSlug: Scalars['String'];
  itemId: Scalars['ID'];
  projectId: Scalars['ID'];
};

export type RemoveDocumentationSidebarItemPayload = {
  __typename?: 'RemoveDocumentationSidebarItemPayload';
  guide?: Maybe<DocumentationGuide>;
};

export type RemoveDocumentationVersionInput = {
  /** ID of the project to remove the guide version from. */
  projectId: Scalars['ID'];
  /** ID of the version to remove. */
  versionId: Scalars['ID'];
};

export type RemoveDocumentationVersionPayload = {
  __typename?: 'RemoveDocumentationVersionPayload';
  /** The updated project containing the new version. */
  project?: Maybe<DocumentationProject>;
  /** The removed guide version. */
  version?: Maybe<DocumentationVersion>;
};

export type RemoveNewsletterSubscriberInput = {
  /** The email that is currently subscribed. */
  email: Scalars['String'];
  /** The ID of the publication to remove the subscriber from. */
  publicationId: Scalars['ID'];
};

export type RemoveNewsletterSubscriberPayload = {
  __typename?: 'RemoveNewsletterSubscriberPayload';
  publication: Publication;
};

export type RemovePostInput = {
  /** The ID of the post to remove. */
  id: Scalars['ID'];
};

export type RemovePostPayload = {
  __typename?: 'RemovePostPayload';
  /** The deleted post. */
  post?: Maybe<Post>;
};

export type RemovePublicationCustomDomainInput = {
  publicationId: Scalars['ID'];
};

export type RemovePublicationCustomDomainPayload = {
  __typename?: 'RemovePublicationCustomDomainPayload';
  publication?: Maybe<Publication>;
};

/** Input to remove a user from a publication. */
export type RemovePublicationMemberInput = {
  /** The publication ID the user is a member of. */
  publicationId: Scalars['ID'];
  /** The username of the user to remove from the publication. */
  username: Scalars['String'];
};

/** Response to removing a user from a publication. */
export type RemovePublicationMemberPayload = {
  __typename?: 'RemovePublicationMemberPayload';
  /** Returns the removed publication member. */
  member: PublicationMember;
};

export type RemovePublicationNavbarItemInput = {
  id: Scalars['ID'];
  publicationId: Scalars['ID'];
};

export type RemovePublicationNavbarItemPayload = {
  __typename?: 'RemovePublicationNavbarItemPayload';
  navbarItem: PublicationNavbarItem;
};

export type RemoveRecommendationInput = {
  recommendedPublicationId: Scalars['ID'];
  recommendingPublicationId: Scalars['ID'];
};

export type RemoveRecommendationPayload = {
  __typename?: 'RemoveRecommendationPayload';
  recommendedPublication: Publication;
};

export type RemoveRedirectionRuleInput = {
  id: Scalars['ID'];
  publicationId: Scalars['ID'];
};

export type RemoveRedirectionRulePayload = {
  __typename?: 'RemoveRedirectionRulePayload';
  redirectionRule: RedirectionRule;
};

export type RemoveReplyInput = {
  commentId: Scalars['ID'];
  replyId: Scalars['ID'];
};

export type RemoveReplyPayload = {
  __typename?: 'RemoveReplyPayload';
  reply?: Maybe<Reply>;
};

export type RemoveSeriesInput = {
  /** The id of the series to remove. */
  id: Scalars['ID'];
};

export type RemoveSeriesPayload = {
  __typename?: 'RemoveSeriesPayload';
  /** Returns the updated series. */
  series: Series;
};

/** Input to remove a static page. */
export type RemoveStaticPageInput = {
  /** id of the static page to remove. */
  id: Scalars['ID'];
};

export type RemoveStaticPagePayload = {
  __typename?: 'RemoveStaticPagePayload';
  /** Returns the removed static page. */
  staticPage: StaticPage;
};

export type RemoveWidgetInput = {
  /** ObjectID of the widget */
  id: Scalars['ID'];
};

export type RemoveWidgetPayload = {
  __typename?: 'RemoveWidgetPayload';
  /** Removed widget details */
  widget: Widget;
};

export type RenameDocumentationGuideItemInput = {
  guideSlug: Scalars['String'];
  name: Scalars['String'];
  projectId: Scalars['ID'];
};

export type RenameDocumentationGuideItemPayload = {
  __typename?: 'RenameDocumentationGuideItemPayload';
  guide?: Maybe<DocumentationGuideItem>;
};

export type RenameDocumentationSidebarItemInput = {
  guideSlug: Scalars['String'];
  itemId: Scalars['ID'];
  label: Scalars['String'];
  projectId: Scalars['ID'];
};

export type RenameDocumentationSidebarItemPayload = {
  __typename?: 'RenameDocumentationSidebarItemPayload';
  guide?: Maybe<DocumentationGuide>;
  item?: Maybe<DocumentationSidebarItem>;
};

/**
 * Contains basic information about the reply.
 * A reply is a response to a comment.
 */
export type Reply = Node & {
  __typename?: 'Reply';
  /** The author of the reply. */
  author: User;
  authorId: Scalars['ID'];
  /** The content of the reply in markdown and html format. */
  content: Content;
  /** The date the reply was created. */
  dateAdded: Scalars['DateTime'];
  /** The ID of the reply. */
  id: Scalars['ID'];
  /** Total number of reactions on the reply by the authenticated user. User must be authenticated to use this field. */
  myTotalReactions: Scalars['Int'];
  /**
   * A unique string identifying the reply. Used as element id in the DOM on hashnode blogs.
   * It can be used to scroll to the reply in browser.
   */
  stamp?: Maybe<Scalars['String']>;
  /** Total number of reactions on the reply. Reactions are hearts added to any reply. */
  totalReactions: Scalars['Int'];
};

export type RescheduleDraftInput = {
  /** The Draft ID of the scheduled draft. */
  draftId: Scalars['ID'];
  /** New scheduled date for the draft to be rescheduled. */
  publishAt: Scalars['DateTime'];
};

export type RescheduleDraftPayload = {
  __typename?: 'RescheduleDraftPayload';
  /** Payload returned in response of reschedulePost mutation. */
  scheduledPost: ScheduledPost;
};

/** Payload for resending the email change verification. */
export type ResendEmailChangeVerificationPayload = {
  __typename?: 'ResendEmailChangeVerificationPayload';
  /** Indicates if the email change verification was resent successfully. */
  success: Scalars['Boolean'];
};

export type ResendWebhookRequestInput = {
  webhookId: Scalars['ID'];
  webhookMessageId: Scalars['ID'];
};

export type ResendWebhookRequestPayload = {
  __typename?: 'ResendWebhookRequestPayload';
  webhookMessage?: Maybe<WebhookMessage>;
};

export type RestorePostInput = {
  id: Scalars['ID'];
};

export type RestorePostPayload = {
  __typename?: 'RestorePostPayload';
  post?: Maybe<Post>;
};

export type RetryDocumentationProjectCustomDomainVerificationInput = {
  projectId: Scalars['ID'];
};

export type RetryDocumentationProjectCustomDomainVerificationPayload = {
  __typename?: 'RetryDocumentationProjectCustomDomainVerificationPayload';
  project?: Maybe<DocumentationProject>;
};

export type RetryPublicationCustomDomainVerificationInput = {
  publicationId: Scalars['ID'];
};

export type RetryPublicationCustomDomainVerificationPayload = {
  __typename?: 'RetryPublicationCustomDomainVerificationPayload';
  publication?: Maybe<Publication>;
};

/** Input to revoke a user invitation to join a documentation project. */
export type RevokeInviteToDocumentationProjectInput = {
  /** The ID of the invite to revoke. */
  inviteId: Scalars['ID'];
  /** The ID of the documentation project. */
  projectId: Scalars['ID'];
};

/** Response to revoking an invitation to join a documentation project. */
export type RevokeInviteToDocumentationProjectPayload = {
  __typename?: 'RevokeInviteToDocumentationProjectPayload';
  /** The documentation project that was associated with the invite. */
  project?: Maybe<DocumentationProject>;
  /** Signifies the success of the mutation. */
  success: Scalars['Boolean'];
};

/** Input for revoking a personal access token. */
export type RevokePersonalAccessTokenInput = {
  /** The ID of the token to revoke. */
  tokenId: Scalars['ID'];
};

/** Returns the revoked personal access token. */
export type RevokePersonalAccessTokenPayload = {
  __typename?: 'RevokePersonalAccessTokenPayload';
  personalAccessToken?: Maybe<PersonalAccessToken>;
};

/** Input to revoke a user invitation to a publication. */
export type RevokeUserInviteToPublicationInput = {
  /** The invite ID to revoke. */
  inviteId: Scalars['ID'];
  /** The publication ID to revoke the invite from. */
  publicationId: Scalars['ID'];
};

/** Response to revoking a user invitation to a publication. */
export type RevokeUserInviteToPublicationPayload = {
  __typename?: 'RevokeUserInviteToPublicationPayload';
  /** Signifies if the mutation was successful. */
  success: Scalars['Boolean'];
};

/** Contains the role based invite information. */
export type RoleBasedInvite = Node & {
  __typename?: 'RoleBasedInvite';
  /** The capacity of how many members to be invited by the link. */
  capacity?: Maybe<Scalars['Int']>;
  /** The date the invite was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The expiry date of the invite. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the role based invite. */
  id: Scalars['ID'];
  /** Invite link of the role based invite. */
  inviteLink?: Maybe<Scalars['String']>;
  /** Boolean that signifies if the invite has unlimited capacity. */
  isUnlimitedCapacity?: Maybe<Scalars['Boolean']>;
  /** The role assigned to the user in the publication. */
  role: UserPublicationRole;
  /** The number of members that have already used the link to join the team. */
  usedCapacity?: Maybe<Scalars['Int']>;
};

export type RoleBasedInviteConnection = PageConnection & {
  __typename?: 'RoleBasedInviteConnection';
  /** A list of invites */
  nodes: Array<RoleBasedInvite>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
  /** The total number of invites. */
  totalDocuments: Scalars['Int'];
};

/** Information to help in seo related meta tags. */
export type Seo = {
  __typename?: 'SEO';
  /** The description used in og:description tag for SEO purposes. */
  description?: Maybe<Scalars['String']>;
  /** Whether or not the page should be indexed. */
  shouldNotIndex: Scalars['Boolean'];
  /** The title used in og:title tag for SEO purposes. */
  title?: Maybe<Scalars['String']>;
};

export type SaveDocumentationPageDraftContentInput = {
  content?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  guideId?: InputMaybe<Scalars['ID']>;
  guideSlug?: InputMaybe<Scalars['String']>;
  pageId: Scalars['ID'];
  projectId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type SaveDocumentationPageDraftContentPayload = {
  __typename?: 'SaveDocumentationPageDraftContentPayload';
  page?: Maybe<DocumentationPage>;
};

export type ScheduleDraftInput = {
  /** The Author ID of the draft that should be published */
  authorId: Scalars['ID'];
  /** The id of the draft that should be published */
  draftId: Scalars['ID'];
  /** The date the draft should be published */
  publishAt: Scalars['DateTime'];
};

export type ScheduleDraftPayload = {
  __typename?: 'ScheduleDraftPayload';
  /** Payload returned in response of reschedulePost mutation. */
  scheduledPost: ScheduledPost;
};

/**
 * Contains basic information about the scheduled post.
 * A scheduled post is a post that is scheduled to be published in the future.
 */
export type ScheduledPost = Node & {
  __typename?: 'ScheduledPost';
  /** The date the scheduled post was created. */
  author: User;
  authorId: Scalars['ID'];
  /** Returns the draft associated with the scheduled post. */
  draft?: Maybe<Draft>;
  draftId: Scalars['ID'];
  /** The ID of the scheduled post. */
  id: Scalars['ID'];
  /** Returns the publication the post is scheduled for. */
  publication: Publication;
  publicationId: Scalars['ID'];
  /** Returns user who scheduled the post. This is usually the author of the post. */
  scheduledBy?: Maybe<User>;
  scheduledById: Scalars['ID'];
  /** The scheduled date for the post to be published. This is the date the post will be published. */
  scheduledDate: Scalars['DateTime'];
};

/** Enum of all the scopes that can be used with the @requireAuth directive. */
export enum Scope {
  AcknowledgeEmailImport = 'acknowledge_email_import',
  ActiveProUser = 'active_pro_user',
  AssignProPublications = 'assign_pro_publications',
  ChangeProSubscription = 'change_pro_subscription',
  CreatePro = 'create_pro',
  DeleteDraft = 'delete_draft',
  DocsAdminOrOwner = 'docs_admin_or_owner',
  DocsOwner = 'docs_owner',
  ImportSubscribersToPublication = 'import_subscribers_to_publication',
  InvitedDocsAdmin = 'invited_docs_admin',
  InvitedTeamUser = 'invited_team_user',
  MoveDraft = 'move_draft',
  PublicationAdmin = 'publication_admin',
  PublicationAuthor = 'publication_author',
  PublicationMember = 'publication_member',
  PublishComment = 'publish_comment',
  PublishDraft = 'publish_draft',
  PublishPost = 'publish_post',
  PublishReply = 'publish_reply',
  RecommendPublications = 'recommend_publications',
  RejectDraftSubmission = 'reject_draft_submission',
  RemoveComment = 'remove_comment',
  RemoveReply = 'remove_reply',
  RestorePost = 'restore_post',
  Signup = 'signup',
  SubmitDraft = 'submit_draft',
  TeamHashnode = 'team_hashnode',
  UpdateComment = 'update_comment',
  UpdateDraft = 'update_draft',
  UpdatePost = 'update_post',
  UpdateReply = 'update_reply',
  WebhookAdmin = 'webhook_admin',
  WriteAiSearchPrompt = 'write_ai_search_prompt',
  WriteDraft = 'write_draft',
  WriteDraftRevision = 'write_draft_revision',
  WritePost = 'write_post',
  WriteSeries = 'write_series',
  WriteStaticPage = 'write_static_page',
  WriteWidget = 'write_widget'
}

/**
 * Connection for posts within a publication search. Contains a list of edges containing nodes.
 * Each node is a post.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type SearchPostConnection = Connection & {
  __typename?: 'SearchPostConnection';
  /** A list of edges containing Post information */
  edges: Array<PostEdge>;
  /** Information for pagination in Post connection. */
  pageInfo: PageInfo;
};

export type SearchPostsOfPublicationFilter = {
  /** An array of author Ids to filter the posts. */
  authorIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Only return posts that are deleted. Query returns active posts by default, set this to true to return deleted posts. */
  deletedOnly?: InputMaybe<Scalars['Boolean']>;
  /** The ID of publications to search from. */
  publicationId: Scalars['ObjectId'];
  /** The query to be searched in post. */
  query?: InputMaybe<Scalars['String']>;
  /** An array of tag Ids to filter the posts. */
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter based on time range. */
  time?: InputMaybe<TimeFilter>;
};

export type SearchUser = Node & {
  __typename?: 'SearchUser';
  /** ID of the user. */
  id: Scalars['ID'];
  /** Signifies if the user has a pending invite to the publication. Returned when the filter has pendingInviteStatus set to true. */
  pendingInviteStatus?: Maybe<Scalars['Boolean']>;
  /** User node containing the user information. */
  user: User;
};

export type SearchUserConnection = PageConnection & {
  __typename?: 'SearchUserConnection';
  /** A list user nodes. */
  nodes: Array<SearchUser>;
  /** Information to aid in pagination. */
  pageInfo: OffsetPageInfo;
};

/** Filter for the search users query. */
export type SearchUsersFilter = {
  /** Search for users who are not currently member of the publication. */
  excludeMembersOfPublication?: InputMaybe<Scalars['ID']>;
  /** Boolean to show pending invite status of the user to the publication. Used in conjunction with excludeMembersOfPublication. */
  showPendingInviteStatus?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Contains basic information about the series.
 * A series is a collection of posts that are related to each other.
 */
export type Series = Node & {
  __typename?: 'Series';
  /** Returns the user who is author of the series. */
  author: User;
  /** The cover image of the series. */
  coverImage?: Maybe<Scalars['String']>;
  /** The date and time the series was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier for the series. */
  cuid?: Maybe<Scalars['ID']>;
  /** The description of the series. Contains markdown and html version of the series's description. */
  description?: Maybe<Content>;
  /** The ID of the series. */
  id: Scalars['ID'];
  /** The name of the series. Shown in series page. */
  name: Scalars['String'];
  /** Returns a list of posts in the series. */
  posts: SeriesPostConnection;
  /** The slug of the series. Used to access series page.  Example https://johndoe.com/series/series-slug */
  slug: Scalars['String'];
  /** The sort order of the series, determines if the latest posts should appear first or last in series. */
  sortOrder: SortOrder;
};


/**
 * Contains basic information about the series.
 * A series is a collection of posts that are related to each other.
 */
export type SeriesPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};

/**
 * Connection for Series. Contains a list of edges containing nodes.
 * Each node is a Series.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type SeriesConnection = Connection & {
  __typename?: 'SeriesConnection';
  /** A list of edges containing Series information */
  edges: Array<SeriesEdge>;
  /** Information for pagination in SeriesList connection. */
  pageInfo: PageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/** Contains a Series and a cursor for pagination. */
export type SeriesEdge = Edge & {
  __typename?: 'SeriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The node holding the Series information */
  node: Series;
};

/**
 * Connection for posts within a series. Contains a list of edges containing nodes.
 * Each node is a post.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type SeriesPostConnection = Connection & {
  __typename?: 'SeriesPostConnection';
  /** A list of edges containing Post information */
  edges: Array<PostEdge>;
  /** Information for pagination in Post connection. */
  pageInfo: PageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

export type SetDocumentationSidebarItemVisibilityInput = {
  guideSlug: Scalars['String'];
  itemId: Scalars['ID'];
  projectId: Scalars['ID'];
  visibility: DocumentationSidebarItemVisibility;
};

export type SetDocumentationSidebarItemVisibilityPayload = {
  __typename?: 'SetDocumentationSidebarItemVisibilityPayload';
  guide?: Maybe<DocumentationGuide>;
  item?: Maybe<DocumentationSidebarItem>;
};

export type SignUpUserInput = {
  name: Scalars['String'];
  photo?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type SignUpUserPayload = {
  __typename?: 'SignUpUserPayload';
  profile: MyUser;
  ssoAuthUrl: Scalars['String'];
};

/** Available social media links. */
export type SocialMediaLinks = {
  __typename?: 'SocialMediaLinks';
  /** The user's Bluesky profile. */
  bluesky?: Maybe<Scalars['String']>;
  /** The user's Facebook profile. */
  facebook?: Maybe<Scalars['String']>;
  /** The user's GitHub profile. */
  github?: Maybe<Scalars['String']>;
  /** The user's Instagram profile. */
  instagram?: Maybe<Scalars['String']>;
  /** The user's LinkedIn profile. */
  linkedin?: Maybe<Scalars['String']>;
  /** The user's StackOverflow profile. */
  stackoverflow?: Maybe<Scalars['String']>;
  /** The user's Twitter profile. */
  twitter?: Maybe<Scalars['String']>;
  /** The user's website. */
  website?: Maybe<Scalars['String']>;
  /** The user's YouTube profile. */
  youtube?: Maybe<Scalars['String']>;
};

export type SocialMediaLinksInput = {
  bluesky?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  github?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  stackoverflow?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
};

/** SortOrder is a common enum for all types that can be sorted. */
export enum SortOrder {
  Asc = 'asc',
  Dsc = 'dsc'
}

/**
 * Contains basic information about the static page.
 * Static pages are pages that are written in markdown and can be added to blog.
 */
export type StaticPage = Node & {
  __typename?: 'StaticPage';
  /** Content of the static page. Contains markdown and html version of the static page's content. */
  content: Content;
  /** A flag to determine if the static page is hidden from public or not, this is used to hide the page instead of deleting it. */
  hidden: Scalars['Boolean'];
  /** The ID of the static page. */
  id: Scalars['ID'];
  /** Information about the static page's Open Graph metadata i.e. image. */
  ogMetaData?: Maybe<OpenGraphMetaData>;
  /** Information about the static page's SEO metadata i.e. title and description. */
  seo?: Maybe<Seo>;
  /** The slug of the static page. Used to access static page. Example `https://johndoe.com/my-page`. */
  slug: Scalars['String'];
  /** The title of the static page. Shown in nav bar. */
  title: Scalars['String'];
};

/**
 * Connection to get list of static pages.
 * Returns a list of edges which contains the static page and cursor to the last item of the previous page.
 */
export type StaticPageConnection = Connection & {
  __typename?: 'StaticPageConnection';
  /** A list of edges containing nodes in the connection. */
  edges: Array<StaticPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/** An edge that contains a node of type static page and cursor to the node. */
export type StaticPageEdge = Edge & {
  __typename?: 'StaticPageEdge';
  /** A cursor to the last item of the previous page. */
  cursor: Scalars['String'];
  /** The node containing a static page. */
  node: StaticPage;
};

/** Contains the publication's Stripe configuration. */
export type StripeConfiguration = {
  __typename?: 'StripeConfiguration';
  /** The Stripe account ID of the publication. */
  accountId?: Maybe<Scalars['String']>;
  /** A flag indicating if the publication is connected to Stripe. */
  connected: Scalars['Boolean'];
  /** The country of origin of the publication. */
  country?: Maybe<Scalars['String']>;
};

export type SubmitDraftForReviewInput = {
  /** ID of the draft to be submitted. */
  draftId: Scalars['ID'];
};

export type SubmitDraftForReviewPayload = {
  __typename?: 'SubmitDraftForReviewPayload';
  draft?: Maybe<Draft>;
};

export type SubscribeConsentedUserToNewsletterInput = {
  /** The email of the consented subscriber. */
  email: Scalars['String'];
  /** The ID of the publication to subscribe to. */
  publicationId: Scalars['ID'];
};

export type SubscribeConsentedUserToNewsletterPayload = {
  __typename?: 'SubscribeConsentedUserToNewsletterPayload';
  subscriber: NewsletterSubscriber;
};

export type SubscribeToNewsletterInput = {
  /** The email of the subscriber. */
  email: Scalars['String'];
  /** The ID of the publication to subscribe to. */
  publicationId: Scalars['ObjectId'];
};

export type SubscribeToNewsletterPayload = {
  __typename?: 'SubscribeToNewsletterPayload';
  status?: Maybe<NewsletterSubscribeStatus>;
};

/** The input for syncing API reference definitions */
export type SyncDocumentationProjectApiDefinitionInput = {
  /** The ID of the docs API reference */
  apiReferenceId: Scalars['ID'];
  /** The ID of the documentation project */
  projectId: Scalars['ID'];
  /** The ID of the reference version */
  versionId: Scalars['ID'];
};

/** The response to syncing documentation project API Reference definition */
export type SyncDocumentationProjectApiDefinitionPayload = {
  __typename?: 'SyncDocumentationProjectApiDefinitionPayload';
  /** Signifies if the mutation was successful. */
  success: Scalars['Boolean'];
};

export type TableOfContentsFeature = Feature & {
  __typename?: 'TableOfContentsFeature';
  /** Whether or not the user has chosen to show a table of contents on the post. */
  isEnabled: Scalars['Boolean'];
  /** The content of the table of contents. */
  items: Array<TableOfContentsItem>;
};

export type TableOfContentsItem = Node & {
  __typename?: 'TableOfContentsItem';
  /** Unique identifier. */
  id: Scalars['ID'];
  /** The level of nesting. Refers to the heading level in the post. */
  level: Scalars['Int'];
  /** ID of the `TableOfContentsItem` that is one level higher in the hierarchy. `null` if this is a top level item. */
  parentId?: Maybe<Scalars['ID']>;
  /** The slug of the referenced headline. */
  slug: Scalars['String'];
  /** The title of the referenced headline. */
  title: Scalars['String'];
};

export type Tag = ITag & Node & {
  __typename?: 'Tag';
  /** Total number of users following this tag. */
  followersCount: Scalars['Int'];
  /** The ID of the tag. */
  id: Scalars['ID'];
  /** Information about the tag. Contains markdown html and text version of the tag's info. */
  info?: Maybe<Content>;
  /** The logo of the tag. Shown in tag page. */
  logo?: Maybe<Scalars['String']>;
  /** The name of the tag. Shown in tag page. */
  name: Scalars['String'];
  /** Paginated list of posts published under this tag */
  posts: FeedPostConnection;
  /** Alltime usage count of this tag in posts. */
  postsCount: Scalars['Int'];
  /** The slug of the tag. Used to access tags feed.  Example https://hashnode.com/n/graphql */
  slug: Scalars['String'];
  /** The tagline of the tag. */
  tagline?: Maybe<Scalars['String']>;
};


export type TagPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter: TagPostConnectionFilter;
  first: Scalars['Int'];
};

/** Contains a tag and a cursor for pagination. */
export type TagEdge = Edge & {
  __typename?: 'TagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The node holding the Tag information */
  node: Tag;
};

export type TagPostConnectionFilter = {
  /** Sort tag feed by recents, popular, or trending. Defaults to recents. */
  sortBy?: InputMaybe<TagPostsSort>;
};

/** The field by which to sort the tag feed. */
export enum TagPostsSort {
  /** Sorts by popularity, used in Hot tag feed. */
  Popular = 'popular',
  /** Determinate how to sort the results. Defaults to recents, used in New tag feed. */
  Recent = 'recent',
  /** Trending is particular used to fetch top posts trending within a week time under a tag */
  Trending = 'trending'
}

/**
 * Contains the flag indicating if the text selection sharer feature is enabled or not.
 * User can enable or disable the text selection sharer feature from the publication settings.
 * Shows a widget if a text on a blog post is selected. Allows for easy sharing or copying of the selected text.
 */
export type TextSelectionSharerFeature = Feature & {
  __typename?: 'TextSelectionSharerFeature';
  /** A flag indicating if the text selection sharer feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

export type TimeFilter = {
  /**
   * Narrow the time range to a specific period.
   *
   * Can't be used with `relative`.
   */
  absolute?: InputMaybe<AbsoluteTimeRange>;
  /**
   * Narrow the time range to a specific period.
   *
   * Can't be used with `absolute`.
   */
  relative?: InputMaybe<RelativeTimeRange>;
};

export enum TimeGranularity {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum TimePeriod {
  LastNDays = 'LAST_N_DAYS',
  LastNHours = 'LAST_N_HOURS',
  LastNMonths = 'LAST_N_MONTHS',
  LastNWeeks = 'LAST_N_WEEKS',
  LastNYears = 'LAST_N_YEARS'
}

export type ToggleAllowContributorEditsInput = {
  publicationId: Scalars['ID'];
};

export type ToggleAllowContributorEditsPayload = {
  __typename?: 'ToggleAllowContributorEditsPayload';
  publication?: Maybe<Publication>;
};

/** Input for toggling a beta feature for a blog. */
export type ToggleBlogBetaFeatureInput = {
  blogId: Scalars['ObjectId'];
  key: Scalars['String'];
};

/** Payload for toggling a beta feature for a blog. */
export type ToggleBlogBetaFeaturePayload = {
  __typename?: 'ToggleBlogBetaFeaturePayload';
  betaFeature: BetaFeature;
};

/** Payload for the toggleFollowingUser mutation. */
export type ToggleFollowUserPayload = {
  __typename?: 'ToggleFollowUserPayload';
  /** The user that was followed/unfollowed. */
  user?: Maybe<User>;
};

export type ToggleGptBotCrawlingInput = {
  publicationId: Scalars['ID'];
};

export type ToggleGptBotCrawlingPayload = {
  __typename?: 'ToggleGPTBotCrawlingPayload';
  publication?: Maybe<Publication>;
};

export type ToggleNewsletterSubscriptionInput = {
  publicationId: Scalars['ObjectId'];
};

export type ToggleNewsletterSubscriptionPayload = {
  __typename?: 'ToggleNewsletterSubscriptionPayload';
  /** Returns updated publication */
  publication: Publication;
};

/** Input to toggle the visibility of a autogenerated page. */
export type TogglePageVisibilityInput = {
  /** Key of the autogenerated page to hide or show. Can be BADGES, NEWSLETTER or MEMBERS. */
  page: AutogeneratedPage;
  /** The id of the publication the page belongs to. */
  publicationId: Scalars['ID'];
};

export type TogglePageVisibilityPayload = {
  __typename?: 'TogglePageVisibilityPayload';
  /** Returns the updated publication. */
  publication: Publication;
};

/** Response to toggling role based invite links. */
export type ToggleRoleBasedInviteLinksPayload = {
  __typename?: 'ToggleRoleBasedInviteLinksPayload';
  /** Signifies the status of invite links after toggling. */
  areRoleBasedInviteLinksActive: Scalars['Boolean'];
};

export type ToggleTextSelectionSharerInput = {
  publicationId: Scalars['ID'];
};

export type ToggleTextSelectionSharerPayload = {
  __typename?: 'ToggleTextSelectionSharerPayload';
  publication?: Maybe<Publication>;
};

/** Input for toggling a beta feature for a user. */
export type ToggleUserBetaFeatureInput = {
  key: Scalars['String'];
};

/** Payload for toggling a beta feature for a user. */
export type ToggleUserBetaFeaturePayload = {
  __typename?: 'ToggleUserBetaFeaturePayload';
  betaFeature: BetaFeature;
};

export type TransferDocumentationProjectOwnershipInput = {
  newOwnerUserId: Scalars['ID'];
  projectId: Scalars['ID'];
};

/** The payload for transferring ownership of a documentation project. */
export type TransferDocumentationProjectOwnershipPayload = {
  __typename?: 'TransferDocumentationProjectOwnershipPayload';
  project?: Maybe<DocumentationProject>;
};

export type TriggerWebhookTestInput = {
  webhookId: Scalars['ID'];
};

export type TriggerWebhookTestPayload = {
  __typename?: 'TriggerWebhookTestPayload';
  webhook?: Maybe<Webhook>;
};

export type UnfollowTagsInput = {
  /** List of tag ids to unfollow. */
  ids: Array<Scalars['ID']>;
};

export type UnfollowTagsPayload = {
  __typename?: 'UnfollowTagsPayload';
  /** List of tags unfollowed by the user. */
  tags?: Maybe<Array<Tag>>;
};

/** Views implementation that will be returned if no grouping is applied. */
export type UngroupedDocsViews = DocsViews & Node & {
  __typename?: 'UngroupedDocsViews';
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if no grouping is applied. */
export type UngroupedDocsVisitors = DocsVisitors & Node & {
  __typename?: 'UngroupedDocsVisitors';
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

/** Views implementation that will be returned if no grouping is applied. */
export type UngroupedViews = Node & Views & {
  __typename?: 'UngroupedViews';
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

/** Visitors implementation that will be returned if no grouping is applied. */
export type UngroupedVisitors = Node & Visitors & {
  __typename?: 'UngroupedVisitors';
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

export type UnsubscribeFromNewsletterInput = {
  /** The email that is currently subscribed. */
  email: Scalars['String'];
  /** The ID of the publication to unsubscribe from. */
  publicationId: Scalars['ObjectId'];
};

export type UnsubscribeFromNewsletterPayload = {
  __typename?: 'UnsubscribeFromNewsletterPayload';
  status?: Maybe<NewsletterUnsubscribeStatus>;
};

export type UpdateCommentInput = {
  contentMarkdown: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  comment?: Maybe<Comment>;
};

export type UpdateDocsCustomPageInput = {
  /** Content of the docs custom page. Accepts mdx version of the docs custom page's content.	 */
  content?: InputMaybe<Scalars['String']>;
  /** ID of the docs custom page to be updated.	 */
  id: Scalars['ID'];
  /** OG Image URL of the docs custom page	 */
  ogImage?: InputMaybe<Scalars['URL']>;
  /** Project ID to which the docs custom page belongs. */
  projectId: Scalars['ID'];
  /** Description of the docs custom page for SEO.	 */
  seoDescription?: InputMaybe<Scalars['String']>;
  /** Slug of the docs custom page.	 */
  slug?: InputMaybe<Scalars['String']>;
  /** Title of the docs custom page.	 */
  title?: InputMaybe<Scalars['String']>;
  /** Visibility of the docs custom page.		 */
  visibility?: InputMaybe<DocumentationSidebarItemVisibility>;
};

export type UpdateDocumentationAppearanceInput = {
  appearance: DocumentationProjectAppearanceInput;
  projectId: Scalars['ID'];
};

export type UpdateDocumentationAppearancePayload = {
  __typename?: 'UpdateDocumentationAppearancePayload';
  project?: Maybe<DocumentationProject>;
};

export type UpdateDocumentationGeneralSettingsInput = {
  description?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<DocumentationProjectLinksInput>;
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  settings?: InputMaybe<DocumentationProjectSettingsInput>;
};

export type UpdateDocumentationGeneralSettingsPayload = {
  __typename?: 'UpdateDocumentationGeneralSettingsPayload';
  project?: Maybe<DocumentationProject>;
};

export type UpdateDocumentationGuideInput = {
  guideId: Scalars['ID'];
  metaTags?: InputMaybe<MetaTagsInput>;
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
};

export type UpdateDocumentationGuidePayload = {
  __typename?: 'UpdateDocumentationGuidePayload';
  guide?: Maybe<DocumentationGuide>;
};

export type UpdateDocumentationGuideVersionInput = {
  /** Internal code name for the version. */
  codeName?: InputMaybe<Scalars['String']>;
  /** Name of the version. */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the project to update the guide version in. */
  projectId: Scalars['ID'];
  /** URL-friendly identifier for the version. */
  slug?: InputMaybe<Scalars['String']>;
  /** Status of the guide version. */
  status?: InputMaybe<GuideVersionStatus>;
  /** ID of the version to update. */
  versionId: Scalars['ID'];
  /** Visibility setting for the version. */
  visibility?: InputMaybe<DocumentationGuideVisibility>;
};

export type UpdateDocumentationGuideVersionPayload = {
  __typename?: 'UpdateDocumentationGuideVersionPayload';
  /** The updated project containing the updated version. */
  project?: Maybe<DocumentationProject>;
  /** The newly updated guide version. */
  version?: Maybe<DocumentationGuideVersion>;
};

export type UpdateDocumentationIntegrationsInput = {
  integrations: DocumentationProjectIntegrationsInput;
  projectId: Scalars['ID'];
};

export type UpdateDocumentationIntegrationsPayload = {
  __typename?: 'UpdateDocumentationIntegrationsPayload';
  project?: Maybe<DocumentationProject>;
};

export type UpdateDocumentationLinkInput = {
  guideSlug: Scalars['String'];
  label: Scalars['String'];
  linkId: Scalars['ID'];
  projectId: Scalars['ID'];
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateDocumentationLinkPayload = {
  __typename?: 'UpdateDocumentationLinkPayload';
  guide?: Maybe<DocumentationGuide>;
  link?: Maybe<DocumentationLink>;
};

/** Input for updating a navbar column for a docs project. */
export type UpdateDocumentationNavbarColumnInput = {
  /** The ID of the column that will be updated. */
  columnId: Scalars['ID'];
  /** The new label of the column. */
  label: Scalars['String'];
  /** The ID of the project that the column will be updated in. */
  projectId: Scalars['ID'];
};

/** Payload for updating a navbar column for a docs project. */
export type UpdateDocumentationNavbarColumnPayload = {
  __typename?: 'UpdateDocumentationNavbarColumnPayload';
  /** The updated column. */
  column?: Maybe<DocumentationNavbarColumn>;
  /** The project that the column was updated in. */
  project?: Maybe<DocumentationProject>;
};

/** Input for updating a navbar guide item for a documentation project. */
export type UpdateDocumentationNavbarItemGuideInput = {
  /** The new guide id that the navbar item will point to. */
  guideId?: InputMaybe<Scalars['ID']>;
  /** The ID of the navbar item that will be updated. */
  itemId: Scalars['ID'];
  /** The new label of the navbar item. */
  label?: InputMaybe<Scalars['String']>;
  /** The ID of the project that the navbar item will be updated in. */
  projectId: Scalars['ID'];
};

/** Payload for updating a navbar guide item for a documentation project. */
export type UpdateDocumentationNavbarItemGuidePayload = {
  __typename?: 'UpdateDocumentationNavbarItemGuidePayload';
  /** The updated navbar guide item. */
  item?: Maybe<DocumentationNavbarItemGuide>;
  /** The project that the navbar item was updated in. */
  project?: Maybe<DocumentationProject>;
};

/** Input for updating a navbar link item for a documentation project. */
export type UpdateDocumentationNavbarItemLinkInput = {
  /** The ID of the navbar item that will be updated. */
  itemId: Scalars['ID'];
  /** The new label of the navbar item. */
  label?: InputMaybe<Scalars['String']>;
  /** Whether the link should open in a new tab. */
  openInNewTab?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the project that the navbar item will be updated in. */
  projectId: Scalars['ID'];
  /** The new URL that the navbar item will link to. */
  url?: InputMaybe<Scalars['URL']>;
};

/** Payload for updating a navbar link item for a documentation project. */
export type UpdateDocumentationNavbarItemLinkPayload = {
  __typename?: 'UpdateDocumentationNavbarItemLinkPayload';
  /** The updated navbar link item. */
  item?: Maybe<DocumentationNavbarItemLink>;
  /** The project that the navbar item was updated in. */
  project?: Maybe<DocumentationProject>;
};

/** Input for updating a navbar page item for a documentation project. */
export type UpdateDocumentationNavbarItemPageInput = {
  /** The ID of the navbar item that will be updated. */
  itemId: Scalars['ID'];
  /** The new label of the navbar item. */
  label?: InputMaybe<Scalars['String']>;
  /** The new page id that the navbar item will point to. */
  pageId?: InputMaybe<Scalars['ID']>;
  /** The ID of the project that the navbar item will be updated in. */
  projectId: Scalars['ID'];
};

/** Payload for updating a navbar page item for a documentation project. */
export type UpdateDocumentationNavbarItemPagePayload = {
  __typename?: 'UpdateDocumentationNavbarItemPagePayload';
  /** The updated navbar page item. */
  item?: Maybe<DocumentationNavbarItemPage>;
  /** The project that the navbar item was updated in. */
  project?: Maybe<DocumentationProject>;
};

export type UpdateDocumentationPageSettingsInput = {
  guideSlug: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  metaTags?: InputMaybe<MetaTagsInput>;
  pageId: Scalars['ID'];
  projectId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<DocumentationSidebarItemVisibility>;
};

export type UpdateDocumentationPageSettingsPayload = {
  __typename?: 'UpdateDocumentationPageSettingsPayload';
  guide?: Maybe<DocumentationGuide>;
  page?: Maybe<DocumentationPage>;
  sidebarItem?: Maybe<DocumentationSidebarItemPage>;
};

export type UpdateDocumentationPreviewProjectFromGitHubInput = {
  /** The branch name of the commit */
  branchName: Scalars['String'];
  /** The ID of the preview project */
  projectId: Scalars['ID'];
};

/** The response to updating a documentation project preview */
export type UpdateDocumentationPreviewProjectFromGitHubPayload = {
  __typename?: 'UpdateDocumentationPreviewProjectFromGitHubPayload';
  /** The preview project that was updated */
  project?: Maybe<DocumentationProject>;
};

/** The input for updating the AI search prompts */
export type UpdateDocumentationProjectAiPromptInput = {
  /** The ID of the documentation project */
  projectId: Scalars['ID'];
  /** The prompt text */
  prompt: Scalars['String'];
  /** The ID of the prompt to update */
  promptId: Scalars['ID'];
};

/** Response to updating the AI search prompts */
export type UpdateDocumentationProjectAiPromptPayload = {
  __typename?: 'UpdateDocumentationProjectAIPromptPayload';
  project?: Maybe<DocumentationProject>;
};

export type UpdateDocumentationProjectSubdomainInput = {
  projectId: Scalars['ID'];
  subdomain: Scalars['String'];
};

export type UpdateDocumentationProjectSubdomainPayload = {
  __typename?: 'UpdateDocumentationProjectSubdomainPayload';
  project?: Maybe<DocumentationProject>;
};

export type UpdateDocumentationSectionInput = {
  guideSlug: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  sectionId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<DocumentationSidebarItemVisibility>;
};

export type UpdateDocumentationSectionPayload = {
  __typename?: 'UpdateDocumentationSectionPayload';
  guide?: Maybe<DocumentationGuide>;
  section?: Maybe<DocumentationSection>;
};

export type UpdateDraftInput = {
  /** Ids of the co-authors of the resulting draft. */
  coAuthors?: InputMaybe<Array<Scalars['ID']>>;
  /** Content of the draft in markdown format. */
  contentMarkdown?: InputMaybe<Scalars['String']>;
  /** Options for the cover image of the resulting draft. */
  coverImageOptions?: InputMaybe<CoverImageOptionsInput>;
  /** A flag to indicate if the comments are disabled for the resulting draft. */
  disableComments?: InputMaybe<Scalars['Boolean']>;
  /** ID of the draft to be updated. */
  draftId: Scalars['ID'];
  /** Information about the meta tags added to the resulting draft, used for SEO purpose. */
  metaTags?: InputMaybe<MetaTagsInput>;
  /** The URL of the original article if the draft is imported from an external source. */
  originalArticleURL?: InputMaybe<Scalars['String']>;
  /**
   * Publish the draft on behalf of another user who is a member of the publication.
   *
   * Only applicable for team publications.
   */
  publishAs?: InputMaybe<Scalars['ID']>;
  /** Date when the draft is published. */
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** Providing a seriesId will add the resulting draft to that series. */
  seriesId?: InputMaybe<Scalars['ID']>;
  /** Settings for the resulting draft like table of contents and newsletter activation. */
  settings?: InputMaybe<CreateDraftSettingsInput>;
  /** Slug of the resulting draft. */
  slug?: InputMaybe<Scalars['String']>;
  /** The subtitle of the draft. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** A list of tags added to the resulting draft. */
  tags?: InputMaybe<Array<CreateDraftTagInput>>;
  /** The title of the draft. */
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateDraftPayload = {
  __typename?: 'UpdateDraftPayload';
  draft?: Maybe<Draft>;
};

/** Specifies the input for updating the user email notification preferences. */
export type UpdateEmailNotificationPreferencesInput = {
  /** Indicates if the user has opted in to receive activity notifications. */
  activityNotifications?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if the user has opted in to receive general announcements. */
  generalAnnouncements?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if the user has opted in to receive monthly blog performance stats. */
  monthlyBlogStats?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if the user has opted in to receive new followers weekly. */
  newFollowersWeekly?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if the user has opted in to receive the Hashnode Weekly newsletter. */
  weeklyNewsletterEmails?: InputMaybe<Scalars['Boolean']>;
};

/** Payload for updating the user email notification preferences */
export type UpdateEmailNotificationPreferencesPayload = {
  __typename?: 'UpdateEmailNotificationPreferencesPayload';
  user?: Maybe<MyUser>;
};

export type UpdateHeadlessBaseUrlInput = {
  headlessInstallationBaseUrl: Scalars['String'];
  publicationId: Scalars['ID'];
};

export type UpdateHeadlessBaseUrlPayload = {
  __typename?: 'UpdateHeadlessBaseURLPayload';
  publication?: Maybe<Publication>;
};

export type UpdatePostInput = {
  /**
   * Update co-authors of the post.
   * Must be a member of the publication.
   */
  coAuthors?: InputMaybe<Array<Scalars['ObjectId']>>;
  /** The publication the post is published to. */
  contentMarkdown?: InputMaybe<Scalars['String']>;
  /** Options for the cover image of the post. */
  coverImageOptions?: InputMaybe<CoverImageOptionsInput>;
  /** The id of the post to update. */
  id: Scalars['ID'];
  /** Information about the meta tags added to the post, used for SEO purpose. */
  metaTags?: InputMaybe<MetaTagsInput>;
  /** Canonical URL of the original article. */
  originalArticleURL?: InputMaybe<Scalars['String']>;
  /** If the publication should be changed this is the new Publication ID */
  publicationId?: InputMaybe<Scalars['ObjectId']>;
  /**
   * Set a different author for the post than the requesting user.
   * Must be a member of the publication.
   */
  publishAs?: InputMaybe<Scalars['ObjectId']>;
  /** Backdated publish date. */
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Providing a seriesId will add the post to that series.
   * Must be a series of the publication.
   */
  seriesId?: InputMaybe<Scalars['ObjectId']>;
  /** Whether or not to enable the table of content. */
  settings?: InputMaybe<UpdatePostSettingsInput>;
  /** Slug of the post. Only if you want to override the slug that will be generated based on the title. */
  slug?: InputMaybe<Scalars['String']>;
  /** The subtitle of the post */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Tags to add to the post. New tags will be created if they don't exist. It overrides the existing tags. */
  tags?: InputMaybe<Array<PublishPostTagInput>>;
  /** The new title of the post */
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePostPayload = {
  __typename?: 'UpdatePostPayload';
  post?: Maybe<Post>;
};

export type UpdatePostSettingsInput = {
  /** A flag to indicate if the post is delisted, used to hide the post from public feed. */
  delisted?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not comments should be disabled. */
  disableComments?: InputMaybe<Scalars['Boolean']>;
  /** A flag to indicate if the post contains table of content */
  isTableOfContentEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Pin the post to the blog homepage. */
  pinToBlog?: InputMaybe<Scalars['Boolean']>;
};

export type UpdatePublicationAppearanceInput = {
  disableFooterBranding?: InputMaybe<Scalars['Boolean']>;
  disableSubscriptionModal?: InputMaybe<Scalars['Boolean']>;
  enableDarkTheme?: InputMaybe<Scalars['Boolean']>;
  enableReadTime?: InputMaybe<Scalars['Boolean']>;
  enableViewCount?: InputMaybe<Scalars['Boolean']>;
  favicon?: InputMaybe<Scalars['String']>;
  headerColor?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  layout?: InputMaybe<PublicationLayout>;
  logo?: InputMaybe<PublicationLogoInput>;
  ogImage?: InputMaybe<Scalars['String']>;
};

export type UpdatePublicationAppearancePayload = {
  __typename?: 'UpdatePublicationAppearancePayload';
  publication: Publication;
};

export type UpdatePublicationIntegrationsInput = {
  enablePlausibleAnalytics?: InputMaybe<Scalars['Boolean']>;
  fathom?: InputMaybe<PublicationFathomInput>;
  fbPixelID?: InputMaybe<Scalars['String']>;
  gTagManagerID?: InputMaybe<Scalars['String']>;
  gaTrackingID?: InputMaybe<Scalars['String']>;
  hotjarSiteID?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  koalaPublicKey?: InputMaybe<Scalars['String']>;
  matomo?: InputMaybe<PublicationMatomoInput>;
  metaTags?: InputMaybe<Scalars['String']>;
  msClarityID?: InputMaybe<Scalars['String']>;
  /** @deprecated This is not used anymore */
  wmPaymentPointer?: InputMaybe<Scalars['String']>;
};

export type UpdatePublicationIntegrationsPayload = {
  __typename?: 'UpdatePublicationIntegrationsPayload';
  publication: Publication;
};

export type UpdatePublicationNavbarItemInput = {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  publicationId: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PublicationNavigationType>;
  url?: InputMaybe<Scalars['URL']>;
};

export type UpdatePublicationNavbarItemPayload = {
  __typename?: 'UpdatePublicationNavbarItemPayload';
  navbarItem: PublicationNavbarItem;
};

export type UpdatePublicationNotificationSettingsInput = {
  enableNewDraftSubmission?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type UpdatePublicationNotificationSettingsPayload = {
  __typename?: 'UpdatePublicationNotificationSettingsPayload';
  publication: Publication;
};

export type UpdatePublicationSeoInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePublicationSeoPayload = {
  __typename?: 'UpdatePublicationSEOPayload';
  publication: Publication;
};

export type UpdatePublicationSettingsInput = {
  aboutMarkdown?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imprintMarkdown?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<PublicationLinksInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePublicationSettingsPayload = {
  __typename?: 'UpdatePublicationSettingsPayload';
  publication: Publication;
};

export type UpdatePublicationSubdomainInput = {
  publicationId: Scalars['ID'];
  subdomain: Scalars['String'];
};

export type UpdatePublicationSubdomainPayload = {
  __typename?: 'UpdatePublicationSubdomainPayload';
  publication?: Maybe<Publication>;
};

export type UpdateRedirectionRuleInput = {
  destination?: InputMaybe<Scalars['URL']>;
  id: Scalars['ID'];
  publicationId: Scalars['ID'];
  source?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<HttpRedirectionType>;
};

export type UpdateRedirectionRulePayload = {
  __typename?: 'UpdateRedirectionRulePayload';
  redirectionRule: RedirectionRule;
};

export type UpdateReplyInput = {
  commentId: Scalars['ID'];
  contentMarkdown: Scalars['String'];
  replyId: Scalars['ID'];
};

export type UpdateReplyPayload = {
  __typename?: 'UpdateReplyPayload';
  reply?: Maybe<Reply>;
};

/** Input to update a role based invite. */
export type UpdateRoleBasedInviteInput = {
  /** The capacity of how many members to be invited by the link. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** Boolean to enable unlimited capacity. */
  enableUnlimitedCapacity?: InputMaybe<Scalars['Boolean']>;
  /** The expiry date of the invite. */
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the role based invite. */
  inviteId: Scalars['ID'];
  publicationId: Scalars['ID'];
  /** The role to assign to the user in the publication. */
  role?: InputMaybe<UserPublicationInviteRole>;
};

/** Response to updating a role based invite for a publication. */
export type UpdateRoleBasedInvitePayload = {
  __typename?: 'UpdateRoleBasedInvitePayload';
  /** The updated role based invite. */
  invite: RoleBasedInvite;
};

export type UpdateSeriesInput = {
  /** The cover image of the series. */
  coverImage?: InputMaybe<Scalars['String']>;
  /** The description of the series. Accepts markdown. */
  descriptionMarkdown?: InputMaybe<Scalars['String']>;
  /** The id of the series to update. */
  id: Scalars['ID'];
  /** The name of the series. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the series. Used to access series page.  Example https://johndoe.com/series/series-slug */
  slug?: InputMaybe<Scalars['String']>;
  /** The sort order of the series, determines if the latest posts should appear first or last in series. */
  sortOrder?: InputMaybe<SortOrder>;
};

export type UpdateSeriesPayload = {
  __typename?: 'UpdateSeriesPayload';
  /** Returns the updated series. */
  series: Series;
};

/** Input to updating a static page. */
export type UpdateStaticPageInput = {
  /** Content of the static page. Accepts markdown. */
  contentMarkdown?: InputMaybe<Scalars['String']>;
  /** id of the static page to update. */
  id: Scalars['ID'];
  /** Accepts og image url for the static page. */
  ogImage?: InputMaybe<Scalars['URL']>;
  /** The description of the static page for SEO. */
  seoDescription?: InputMaybe<Scalars['String']>;
  /** The slug of the static page. Used to access static page.  Example `https://johndoe.com/my-page`. */
  slug?: InputMaybe<Scalars['String']>;
  /** The title of the static page. */
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateStaticPagePayload = {
  __typename?: 'UpdateStaticPagePayload';
  /** Returns the updated static page. */
  staticPage: StaticPage;
};

/** Specifies the input for updating the user profile. */
export type UpdateUserProfileInput = {
  /** The availability of the user based on tech stack and interests. Shown on the "I am available for" section in user's profile. */
  availableFor?: InputMaybe<Scalars['String']>;
  /** The bio of the user. Visible in about me section of the user's profile. */
  bioMarkdown?: InputMaybe<Scalars['String']>;
  /** The email of the user. Has to be verified by user via magic link. */
  email?: InputMaybe<Scalars['String']>;
  /** The location of the user. */
  location?: InputMaybe<Scalars['String']>;
  /** The name of the user. */
  name?: InputMaybe<Scalars['String']>;
  /** The URL to the profile picture of the user. */
  profilePicture?: InputMaybe<Scalars['String']>;
  /** The social media links of the user. Shown on the user's profile. */
  socialMediaLinks?: InputMaybe<SocialMediaLinksInput>;
  /** The tagline of the user. Shown on the user's profile below the name. */
  tagline?: InputMaybe<Scalars['String']>;
  /**
   * IDs of tech stack of the user. Shown on the user's profile to indicate the user's expertise.
   * IDs of tag has to be passed. You can query tag by slug to get the ID using `tag` query.
   */
  techStack?: InputMaybe<Array<Scalars['ID']>>;
  /** The username of the user. Can be updated only once. */
  username?: InputMaybe<Scalars['String']>;
};

/** Payload for updating the user profile. */
export type UpdateUserProfilePayload = {
  __typename?: 'UpdateUserProfilePayload';
  user?: Maybe<MyUser>;
};

export type UpdateWebhookInput = {
  events?: InputMaybe<Array<WebhookEvent>>;
  id: Scalars['ID'];
  secret?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateWebhookPayload = {
  __typename?: 'UpdateWebhookPayload';
  webhook?: Maybe<Webhook>;
};

export type UpdateWidgetInput = {
  /** Content of the widget, can be a simple string or HTML */
  content?: InputMaybe<Scalars['String']>;
  /** ObjectID of the widget */
  id: Scalars['ID'];
  /** Widget pin details describing if it should be pinned on articles and location of the widget */
  pinSettings?: InputMaybe<WidgetPinSettingsInput>;
  /** WidgetId, can be embedded as %%[widgetId] in the article */
  widgetId?: InputMaybe<Scalars['String']>;
};

export type UpdateWidgetPayload = {
  __typename?: 'UpdateWidgetPayload';
  widget: Widget;
};

export type UploadImageInput = {
  /**
   * Required for Unsplash images.
   * Used for Unsplash attribution.
   */
  unsplashImageId?: InputMaybe<Scalars['String']>;
  /** URL of image, it can be from unsplash.com or hashnode's cdn. */
  url: Scalars['URL'];
};

export type UploadImagePayload = {
  __typename?: 'UploadImagePayload';
  imageURL: Scalars['URL'];
};

export enum UrlPattern {
  /** Post URLs contain the slug (for example `my slug`) and a random id (like `1234`) , e.g. "/my-slug-1234". */
  Default = 'DEFAULT',
  /** Post URLs only contain the slug, e.g. "/my-slug". */
  Simple = 'SIMPLE'
}

/** Basic information about a user on Hashnode. */
export type User = IUser & Node & {
  __typename?: 'User';
  /**
   * Whether or not the user is an ambassador.
   * @deprecated Ambassadors program no longer active. Will be removed after 02/01/2024
   */
  ambassador: Scalars['Boolean'];
  /** The availability of the user based on tech stack and interests. Shown on the "I am available for" section in user's profile. */
  availableFor?: Maybe<Scalars['String']>;
  /** Returns a list of badges that the user has earned. Shown on blogs /badges page. Example - https://iamshadmirza.com/badges */
  badges: Array<Badge>;
  /** The bio of the user. Visible in about me section of the user's profile. */
  bio?: Maybe<Content>;
  /**
   * The bio of the user. Visible in about me section of the user's profile.
   * @deprecated Will be removed on 26/10/2023. Use bio instead of bioV2
   */
  bioV2?: Maybe<Content>;
  /** The date the user joined Hashnode. */
  dateJoined?: Maybe<Scalars['DateTime']>;
  /** Whether or not the user is deactivated. */
  deactivated: Scalars['Boolean'];
  /** The users who are following this user */
  followers: UserConnection;
  /** The number of users that follow the requested user. Visible in the user's profile. */
  followersCount: Scalars['Int'];
  /**
   * Whether or not the authenticated user follows this user.
   * Returns false if the authenticated user this user.
   */
  following: Scalars['Boolean'];
  /** The number of users that this user is following. Visible in the user's profile. */
  followingsCount: Scalars['Int'];
  /** The users which this user is following */
  follows: UserConnection;
  /**
   * Whether or not this user follows the authenticated user.
   * Returns false if the authenticated user this user.
   */
  followsBack: Scalars['Boolean'];
  /** The ID of the user. It can be used to identify the user. */
  id: Scalars['ID'];
  /** Whether or not this is a pro user. */
  isPro: Scalars['Boolean'];
  /** The location of the user. */
  location?: Maybe<Scalars['String']>;
  /** The name of the user. */
  name: Scalars['String'];
  /** Returns the list of posts the user has published. */
  posts: UserPostConnection;
  /** The URL to the profile picture of the user. */
  profilePicture?: Maybe<Scalars['String']>;
  /** Publications associated with the user. Includes personal and team publications. */
  publications: UserPublicationsConnection;
  /** The social media links of the user. Shown on the user's profile. */
  socialMediaLinks?: Maybe<SocialMediaLinks>;
  /** The tagline of the user. Shown on the user's profile below the name. */
  tagline?: Maybe<Scalars['String']>;
  /** Returns a list of tags that the user follows. */
  tagsFollowing: Array<Tag>;
  /** Returns list of tags from user's expertise. Shown on the user's profile. */
  techStack: UserTagsConnection;
  /** The username of the user. It is unique and tied with user's profile URL. Example - https://hashnode.com/@username */
  username: Scalars['String'];
};


/** Basic information about a user on Hashnode. */
export type UserFollowersArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/** Basic information about a user on Hashnode. */
export type UserFollowsArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


/** Basic information about a user on Hashnode. */
export type UserPostsArgs = {
  filter?: InputMaybe<UserPostConnectionFilter>;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortBy?: InputMaybe<UserPostsSort>;
};


/** Basic information about a user on Hashnode. */
export type UserPublicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserPublicationsConnectionFilter>;
  first: Scalars['Int'];
  sortBy?: InputMaybe<UserPublicationsSort>;
};


/** Basic information about a user on Hashnode. */
export type UserTechStackArgs = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};

/**
 * Connection for users to another user. Contains a list of nodes.
 * Each node is a user.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type UserConnection = PageConnection & {
  __typename?: 'UserConnection';
  /** A list of users */
  nodes: Array<User>;
  /** Information for page based pagination in users connection. */
  pageInfo: OffsetPageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/**
 * Connection to get a list of documentation projects
 * Returns a list of edges which contains the documentation projects and page information as well as total documents.
 */
export type UserDocumentationProjectConnection = PageConnection & {
  __typename?: 'UserDocumentationProjectConnection';
  /** A list of edges containing documentation project information */
  edges: Array<UserDocumentationProjectEdge>;
  /** A list of documentation projects */
  nodes: Array<DocumentationProject>;
  /** Information for page based pagination in documentation project connection. */
  pageInfo: OffsetPageInfo;
};

/** Filter to apply to the documentation projects. */
export type UserDocumentationProjectConnectionFilter = {
  /** Only include documentation projects in which the user has one of the provided roles. */
  roles?: InputMaybe<Array<DocumentationMemberRole>>;
};

/** Contains a documentation project and the member roles. */
export type UserDocumentationProjectEdge = {
  __typename?: 'UserDocumentationProjectEdge';
  /** The node holding the documentation project information. */
  node: DocumentationProject;
  /** Indicates the role of the user within the documentation project */
  role: DocumentationMemberRole;
};

/** Sorting for the documentation project of a user. */
export enum UserDocumentationProjectsSort {
  /** Oldest documentation project first. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Newest documentation project first. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  /** Recently updated documentation project last. */
  DateUpdatedAsc = 'DATE_UPDATED_ASC',
  /** Recently updated documentation project first. */
  DateUpdatedDesc = 'DATE_UPDATED_DESC'
}

/** Drafts that belong to a user. */
export type UserDraftConnection = Connection & {
  __typename?: 'UserDraftConnection';
  /** A list of edges. */
  edges: Array<UserDraftEdge>;
  /** Generic information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/** A generic type which holds a draft during pagination. */
export type UserDraftEdge = Edge & {
  __typename?: 'UserDraftEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of UserDraftEdge. */
  node: Draft;
};

/** Contains a node of type user and cursor for pagination. */
export type UserEdge = Edge & {
  __typename?: 'UserEdge';
  /** The cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The node containing User information */
  node: User;
};

export type UserInviteInput = {
  /** The email of the user to invite to the publication. */
  email?: InputMaybe<Scalars['String']>;
  /** The role to assign to the user in the publication. */
  role: UserPublicationInviteRole;
  /** Username of the user to invite to the publication. */
  username?: InputMaybe<Scalars['String']>;
};

export enum UserInviteStatus {
  Invited = 'INVITED',
  NotInvited = 'NOT_INVITED'
}

/**
 * Connection to get a list of personal access tokens
 * Returns a list of nodes which contains the tokens, page information and total documents.
 */
export type UserPersonalAccessTokenConnection = PageConnection & {
  __typename?: 'UserPersonalAccessTokenConnection';
  /** A list of documentation projects */
  nodes: Array<PersonalAccessToken>;
  /** Information for page based pagination in documentation project connection. */
  pageInfo: OffsetPageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/**
 * Connection for posts written by a single user. Contains a list of edges containing nodes.
 * Each node is a post.
 * Page info contains information about pagination like hasNextPage and endCursor.
 */
export type UserPostConnection = PageConnection & {
  __typename?: 'UserPostConnection';
  /** A list of edges containing Post information */
  edges: Array<UserPostEdge>;
  /** A list of posts */
  nodes: Array<Post>;
  /** Information for page based pagination in Post connection. */
  pageInfo: OffsetPageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

/** Filter for the posts of a user. */
export type UserPostConnectionFilter = {
  /** Filtering by author status. Either all posts the user has authored or co-authored are returned or the authored posts only. */
  authorType?: InputMaybe<UserPostsAuthorTypeFilter>;
  /** Filtering by publication IDs will return posts from the author within the publication. */
  publications?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Only include posts that reference the provided tag slugs.
   *
   * Filtering by `tags` and `tagSlugs` will filter posts that match either of those two filters.
   */
  tagSlugs?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Only include posts that reference the provided tag IDs.
   *
   *
   * Filtering by `tags` and `tagSlugs` will filter posts that match either of those two filters.
   */
  tags?: InputMaybe<Array<Scalars['ID']>>;
};

/** Contains a post and the author status. */
export type UserPostEdge = {
  __typename?: 'UserPostEdge';
  /** Indicates weather the user is the author or co-author of the post. */
  authorType: PostAuthorType;
  /** The node holding the Post information. */
  node: Post;
};

/** Filter for the posts of a user. */
export enum UserPostsAuthorTypeFilter {
  /** Only posts that are authored by the user. */
  AuthorOnly = 'AUTHOR_ONLY',
  /** Only posts that are co-authored by the user. */
  CoAuthorOnly = 'CO_AUTHOR_ONLY'
}

/** Sorting for the posts of a user. */
export enum UserPostsSort {
  /** Oldest posts first. */
  DatePublishedAsc = 'DATE_PUBLISHED_ASC',
  /** Newest posts first. */
  DatePublishedDesc = 'DATE_PUBLISHED_DESC'
}

/** Specifies the billing interval for a pro plan. */
export type UserProBillingInfo = {
  __typename?: 'UserProBillingInfo';
  /**
   * The two-letter ISO country code of the user's billing address.
   * Can be used to retrieve pricing information with the applicable taxes.
   */
  countryCode?: Maybe<Scalars['String']>;
  /** The coupon code that was used to get a discount on the subscription. */
  couponCode?: Maybe<Scalars['String']>;
  /** Specifies invoicing frequency. */
  interval: BillingInterval;
  /** The last payment that has been made for the subscription. */
  lastPayment?: Maybe<Payment>;
  /** The next payment that will be made for the subscription. */
  nextPayment?: Maybe<Payment>;
};

/** Information about the user's pro plan. */
export type UserProInfo = {
  __typename?: 'UserProInfo';
  /** Billing information for the user's pro plan. */
  billing: UserProBillingInfo;
  /** Indicates if the user has access to pro features. */
  hasProAccess: Scalars['Boolean'];
  /** Information about the user's publication credits. */
  publicationCredits: UserProPublicationCredits;
  /** Information about the user's pro subscription. */
  subscription: UserProSubscriptionInfo;
};

/**
 * Information about the user's publication credits.
 * Used to determine how many publications can be added to the user's pro plan without paying extra.
 */
export type UserProPublicationCredits = {
  __typename?: 'UserProPublicationCredits';
  /** Determines how many publications can be added to the user's pro plan without paying extra. */
  available: Scalars['Int'];
  /** The total amount of publications that can be added to the user's pro plan. */
  total: Scalars['Int'];
  /** Credits that are used and not scheduled for cancelation. */
  usedUncanceled: Scalars['Int'];
};

/** Information about the user's pro subscription. */
export type UserProSubscriptionInfo = {
  __typename?: 'UserProSubscriptionInfo';
  /** The date the cancelation of the user's pro plan subscription will take effect. */
  cancelAt?: Maybe<Scalars['DateTime']>;
  /** The URL of a page where the user can cancel the subscription. */
  cancelUrl: Scalars['String'];
  /** The date the user's pro plan subscription was canceled. */
  canceledAt?: Maybe<Scalars['DateTime']>;
  /** Time at which the user subscribed to the pro plan. */
  signedUpAt: Scalars['DateTime'];
  /** The current status of the user's pro plan subscription. */
  status: UserProSubscriptionStatus;
  /** The URL of a page where the user can update the subscription (e.g. payment details). */
  updateUrl: Scalars['String'];
};

/** Specifies subscription status. */
export enum UserProSubscriptionStatus {
  /** The user has an active pro plan subscription. */
  Active = 'ACTIVE',
  /** The user has a pro plan subscription that is canceled. */
  Deleted = 'DELETED',
  /** The user has a pro plan subscription that is past due. */
  PastDue = 'PAST_DUE'
}

/** The invited role of the user in the publication. */
export enum UserPublicationInviteRole {
  /** Contributors can join the publication and contribute an article. They cannot directly publish a new article. */
  Contributor = 'CONTRIBUTOR',
  /**
   * The editor has access to the publication dashboard to customize the blog and approve/reject posts.
   * They also have access to the member panel to add/modify/remove members. Editors cannot remove other editors or update their roles.
   */
  Editor = 'EDITOR'
}

/** The role of the user in the publication. */
export enum UserPublicationRole {
  /** Contributors can join the publication and contribute an article. They cannot directly publish a new article. */
  Contributor = 'CONTRIBUTOR',
  /**
   * The editor has access to the publication dashboard to customize the blog and approve/reject posts.
   * They also have access to the member panel to add/modify/remove members. Editors cannot remove other editors or update their roles.
   */
  Editor = 'EDITOR',
  /** The owner is the creator of the publication and can do all things, including delete publication. */
  Owner = 'OWNER'
}

/**
 * Connection to get list of publications.
 * Returns a list of edges which contains the publications and cursor to the last item of the previous page.
 */
export type UserPublicationsConnection = Connection & {
  __typename?: 'UserPublicationsConnection';
  /** A list of edges of publications connection. */
  edges: Array<UserPublicationsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total amount of publications taking into account the filter. */
  totalDocuments: Scalars['Int'];
};

/** Filter to apply to the publications. */
export type UserPublicationsConnectionFilter = {
  /** Only return pro publications. */
  isPro?: InputMaybe<Scalars['Boolean']>;
  /** Only include publication in which the user has one of the provided roles. */
  roles?: InputMaybe<Array<UserPublicationRole>>;
};

/** An edge that contains a node of type publication and cursor to the node. */
export type UserPublicationsEdge = Edge & {
  __typename?: 'UserPublicationsEdge';
  /** The cursor to the node. */
  cursor: Scalars['String'];
  /** Node containing the publication. */
  node: Publication;
  /** The role of the user in the publication. */
  role: UserPublicationRole;
};

/** Sorting for the publications of a user. */
export enum UserPublicationsSort {
  /** Oldest publication first. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Newest publication first. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  /** Recently updated publication last. */
  DateUpdatedAsc = 'DATE_UPDATED_ASC',
  /** Recently updated publication first. */
  DateUpdatedDesc = 'DATE_UPDATED_DESC'
}

export type UserRecommendedPublicationEdge = {
  __typename?: 'UserRecommendedPublicationEdge';
  /** The publication that is recommended by the publication this connection originates from. */
  node: Publication;
  /** The amount of followers the publication referenced in `node` has gained by recommendations from the publication. */
  totalFollowersGained: Scalars['Int'];
};

export type UserRecommendingPublicationEdge = {
  __typename?: 'UserRecommendingPublicationEdge';
  /** The publication that is recommending the publication this connection originates from. */
  node: Publication;
  /** The amount of followers the publication has gained by recommendations from the publication referenced in `node`. */
  totalFollowersGained: Scalars['Int'];
};

/** Role of the user within Hashnode */
export enum UserRole {
  Moderator = 'MODERATOR',
  Superuser = 'SUPERUSER',
  User = 'USER'
}

export type UserTagsConnection = PageConnection & {
  __typename?: 'UserTagsConnection';
  /** A list of tags */
  nodes: Array<Tag>;
  /** Information for page based pagination in users connection. */
  pageInfo: OffsetPageInfo;
  /** The total number of documents in the connection. */
  totalDocuments: Scalars['Int'];
};

export type VerifyDocumentationProjectCustomDomainInput = {
  projectId: Scalars['ID'];
};

export type VerifyDocumentationProjectCustomDomainPayload = {
  __typename?: 'VerifyDocumentationProjectCustomDomainPayload';
  /**
   * Additional DNS entries required to verify the domain.
   * There are cases where additional records in the DNS config are required to successfully verify the domain.
   */
  dnsVerificationEntries: Array<DnsVerificationEntry>;
  /**
   * The documentation project where the custom domain should be verified.
   * Note, that the verification can also fail.
   */
  project?: Maybe<DocumentationProject>;
};

/** Input for verifying the email change. */
export type VerifyEmailChangeInput = {
  /** The id sent to the user's email. */
  magicLinkId: Scalars['String'];
};

/** Payload for verifying the email change. */
export type VerifyEmailChangePayload = {
  __typename?: 'VerifyEmailChangePayload';
  /** Signifies if the mutation was successful. */
  success: Scalars['Boolean'];
  /** The user whose email was updated. */
  user?: Maybe<MyUser>;
};

export type VerifyPublicationCustomDomainInput = {
  publicationId: Scalars['ID'];
};

export type VerifyPublicationCustomDomainPayload = {
  __typename?: 'VerifyPublicationCustomDomainPayload';
  /**
   * Additional DNS entries required to verify the domain.
   * There are cases where additional records in the DNS config are required to successfully verify the domain.
   */
  dnsVerificationEntries: Array<DnsVerificationEntry>;
  /**
   * The publication where the custom domain should be verified.
   * Note, that the verification can also fail.
   */
  publication: Publication;
};

/** Contains the flag indicating if the Versioning feature is enabled or not. */
export type VersioningFeature = Feature & {
  __typename?: 'VersioningFeature';
  /** A flag indicating if the Versioning feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

/**
 * Contains the flag indicating if the view count feature is enabled or not.
 * User can enable or disable the view count feature from the publication settings.
 * Shows total views on blogs if enabled.
 */
export type ViewCountFeature = Feature & {
  __typename?: 'ViewCountFeature';
  /** A flag indicating if the view count feature is enabled or not. */
  isEnabled: Scalars['Boolean'];
};

export type Views = {
  id: Scalars['ID'];
  /** The aggregated views. */
  total: Scalars['Int'];
};

export type Visitors = {
  id: Scalars['ID'];
  /** The aggregated number of visitors. */
  total: Scalars['Int'];
};

export type Webhook = Node & {
  __typename?: 'Webhook';
  createdAt: Scalars['DateTime'];
  events: Array<WebhookEvent>;
  /** The ID of the post. Used to uniquely identify the post. */
  id: Scalars['ID'];
  /**
   * Messages that has been sent via this webhook.
   * Messages include the request and eventual response.
   */
  messages: WebhookMessageConnection;
  publication: Publication;
  publicationId: Scalars['ID'];
  secret: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};


export type WebhookMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};

export enum WebhookEvent {
  PostDeleted = 'POST_DELETED',
  PostPublished = 'POST_PUBLISHED',
  PostUpdated = 'POST_UPDATED',
  StaticPageDeleted = 'STATIC_PAGE_DELETED',
  StaticPageEdited = 'STATIC_PAGE_EDITED',
  StaticPagePublished = 'STATIC_PAGE_PUBLISHED'
}

export type WebhookMessage = Node & {
  __typename?: 'WebhookMessage';
  createdAt: Scalars['DateTime'];
  event: WebhookEvent;
  id: Scalars['ID'];
  /** True if either the request failed or the response status code was not 2xx. */
  isError: Scalars['Boolean'];
  /** True if the message was resent. */
  isResent: Scalars['Boolean'];
  /** True if the message was sent as a test. */
  isTest: Scalars['Boolean'];
  request: WebhookMessageRequest;
  response?: Maybe<WebhookMessageResponse>;
  url: Scalars['String'];
};

export type WebhookMessageConnection = Connection & {
  __typename?: 'WebhookMessageConnection';
  edges: Array<WebhookMessageEdge>;
  pageInfo: PageInfo;
};

export type WebhookMessageEdge = Edge & {
  __typename?: 'WebhookMessageEdge';
  cursor: Scalars['String'];
  node: WebhookMessage;
};

export type WebhookMessageRequest = {
  __typename?: 'WebhookMessageRequest';
  body: Scalars['String'];
  error?: Maybe<WebhookMessageRequestError>;
  headers: Scalars['String'];
  /** Unique identifier of the request. Can be used to deduplicate requests. */
  uuid: Scalars['String'];
};

export type WebhookMessageRequestError = {
  __typename?: 'WebhookMessageRequestError';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type WebhookMessageResponse = {
  __typename?: 'WebhookMessageResponse';
  body?: Maybe<Scalars['String']>;
  headers?: Maybe<Scalars['String']>;
  httpStatus: Scalars['Int'];
  /** The time it took from the moment the request has been send until the first byte of the response has been received. */
  timeToFirstByteMilliseconds?: Maybe<Scalars['Int']>;
};

export type Widget = Node & {
  __typename?: 'Widget';
  /** Content of the widget, can be a simple string or HTML */
  content: Scalars['String'];
  /** The date and time the widget was created. */
  createdAt: Scalars['DateTime'];
  /** The unique identifier of the widget */
  id: Scalars['ID'];
  pinSettings?: Maybe<WidgetPinSettings>;
  /** WidgetId, can be embedded as %%[widgetId] in the article */
  widgetId: Scalars['String'];
};

export enum WidgetPinLocation {
  Bottom = 'BOTTOM',
  Top = 'TOP'
}

export type WidgetPinSettings = {
  __typename?: 'WidgetPinSettings';
  /** Signifies if pinning of widget on all the articles of publication is enabled or not */
  isPinned: Scalars['Boolean'];
  /** Describes the location of the widget on the article, can be TOP or BOTTOM */
  location: WidgetPinLocation;
};

export type WidgetPinSettingsInput = {
  /** Enable Pinning of the widget */
  enable?: InputMaybe<Scalars['Boolean']>;
  /** Location of the Pinned widget on all the articles */
  location?: InputMaybe<WidgetPinLocation>;
};

export type CheckLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckLoginQuery = { __typename?: 'Query', me: { __typename?: 'MyUser', id: string, username: string } };

export type LinkedDocumentationProjectQueryVariables = Exact<{
  documentationProjectId: Scalars['ID']['input'];
}>;


export type LinkedDocumentationProjectQuery = { __typename?: 'Query', documentationProject?: { __typename?: 'DocumentationProject', id: string, name: string, domain?: { __typename?: 'DocumentationProjectDomainSettings', hashnodeSubDomain: string, customDomain?: { __typename?: 'DocumentationProjectCustomDomain', domain: string, status: CustomDomainStatus, wwwDomain?: { __typename?: 'DocumentationProjectCustomWwwDomain', status: CustomDomainStatus } | null } | null } | null, guides: Array<{ __typename?: 'DocumentationApiReference', id: string, slug: string, status: DocumentationGuideItemStatus, provider: GuideProvider } | { __typename?: 'DocumentationGuide', id: string, slug: string, status: DocumentationGuideItemStatus, provider: GuideProvider }> } | null };

export type DocumentationPreviewProjectQueryVariables = Exact<{
  documentationProjectId?: InputMaybe<Scalars['ID']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentationPreviewProjectQuery = { __typename?: 'Query', documentationProject?: { __typename?: 'DocumentationProject', id: string, name: string, url: string, domain?: { __typename?: 'DocumentationProjectDomainSettings', hashnodeSubDomain: string } | null } | null };


export const CheckLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckLogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode;
export const LinkedDocumentationProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LinkedDocumentationProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentationProjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentationProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentationProjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hashnodeSubDomain"}},{"kind":"Field","name":{"kind":"Name","value":"customDomain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"wwwDomain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"guides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IGuide"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
export const DocumentationPreviewProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentationPreviewProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentationProjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"host"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentationProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentationProjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"host"},"value":{"kind":"Variable","name":{"kind":"Name","value":"host"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hashnodeSubDomain"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    CheckLogin(variables?: CheckLoginQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckLoginQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckLoginQuery>(CheckLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CheckLogin', 'query', variables);
    },
    LinkedDocumentationProject(variables: LinkedDocumentationProjectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LinkedDocumentationProjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LinkedDocumentationProjectQuery>(LinkedDocumentationProjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LinkedDocumentationProject', 'query', variables);
    },
    DocumentationPreviewProject(variables?: DocumentationPreviewProjectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentationPreviewProjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentationPreviewProjectQuery>(DocumentationPreviewProjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DocumentationPreviewProject', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;